
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("dLvLk", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef1e17961f39522a$export$2e2bcd8739ae039);

var $cha5E = parcelRequire("cha5E");

var $ef1e17961f39522a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false);
    }
};

});

parcelRegister("1dSeV", function(module, exports) {
// src/rovo/agent/types.ts
var $d60690bf70aab450$export$474f4563a5282a33 = "rovo", $d60690bf70aab450$export$541c04ced4758f83 = "agent";



var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/rovo/agent/manifest.ts
var $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $d60690bf70aab450$export$474f4563a5282a33),
    resourceType: (0, $d60690bf70aab450$export$541c04ced4758f83),
    resourceIdSlug: "activation/{activationId}/{agentId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        agentId: /[a-zA-Z0-9\-]+/
    }
};
// src/rovo/agent/index.ts
var $0e41143f0a0ebdce$export$eaa394a67f27c50 = class _RovoAgentAri extends (0, $9j37t.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get agentId() {
        return this._agentId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts.qualifier,
            platformQualifier: $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts.resourceOwner,
            resourceType: $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.agentId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                agentId: opts.agentId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts);
        return new _RovoAgentAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $0e41143f0a0ebdce$var$rovoAgentAriStaticOpts);
        return new _RovoAgentAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            agentId: this.agentId
        };
    }
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._agentId = opts.resourceIdSegmentValues.agentId;
    }
};
module.exports["RovoAgentAri"] = $0e41143f0a0ebdce$export$eaa394a67f27c50;

});

parcelRegister("1koI0", function(module, exports) {

var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $i70Es = parcelRequire("i70Es");


var $454YE = parcelRequire("454YE");

const $0a94c1ac318e85a1$var$fetchPolicy = 'store-or-network';

const $0a94c1ac318e85a1$export$6333901e831d7af0 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("7lnAX")), {
        moduleId: "0e8b22f8",
        moduleName: "UserProfileCardEntryPoint",
        priority: "interaction",
        moduleId: 'user-profile-card-entrypoint'
    }),
    getPreloadProps: ({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, isReduced: isReduced })=>{
        const variables = (0, $i70Es.buildQueryVariables)({
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId,
            isReduced: isReduced
        });
        return {
            queries: {
                queryRef: {
                    parameters: $454YE.default,
                    variables: variables,
                    options: {
                        fetchPolicy: $0a94c1ac318e85a1$var$fetchPolicy
                    }
                }
            }
        };
    }
});
module.exports["entryPoint"] = $0a94c1ac318e85a1$export$6333901e831d7af0;

});

parcelRegister("i70Es", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

/**
 * @generated SignedSource<<7ec02cf1050e720e1ff362a3dfc5d86c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc0ddde612e6bc48$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v3 = {
        "kind": "ScalarField",
        "name": "email"
    }, v4 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v5 = {
        "kind": "ScalarField",
        "name": "product"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v10 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ]
        }
    ], v11 = [
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v13 = [
        v12 /*: any*/ 
    ], v14 = [
        v12 /*: any*/ ,
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": v13 /*: any*/ 
        }
    ], v15 = [
        {
            "alias": "trelloUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v16 = [
        {
            "alias": "webUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v17 = [
        {
            "concreteType": "AssetsLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "web"
                }
            ]
        }
    ], v18 = {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "accountIdentifier"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfDirectReports"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfTotalReports"
        },
        {
            "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
            "kind": "LinkedField",
            "name": "pii",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
                    "kind": "LinkedField",
                    "name": "extendedProfile",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 50,
                "kind": "LocalArgument",
                "name": "activityFirst"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "collabContextId"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeExternalAgentFields"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "orgId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "siteAri"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "skipActivity"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "skipKnowledgeDiscovery"
            },
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "skipReportingLines"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userIdString"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewerId"
            }
        ],
        "kind": "Fragment",
        "name": "UserProfileCardRelay_query",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "accountId",
                        "variableName": "userId"
                    }
                ],
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accountStatus"
                    },
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": [
                                    v4 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "department"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "location"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "organization"
                                    }
                                ]
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3 /*: any*/ 
                        ],
                        "type": "CustomerUser"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "appType"
                            },
                            {
                                "condition": "includeExternalAgentFields",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "nickname"
                                    },
                                    {
                                        "concreteType": "AppUserExtendedProfile",
                                        "kind": "LinkedField",
                                        "name": "extendedProfile",
                                        "plural": false,
                                        "selections": [
                                            v4 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "aboutMe"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "characteristics"
                                    }
                                ]
                            }
                        ],
                        "type": "AppUser"
                    }
                ]
            },
            {
                "condition": "skipActivity",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "Activity",
                        "kind": "LinkedField",
                        "name": "activity",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "fields": [
                                            {
                                                "items": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "actors.0",
                                                        "variableName": "userAri"
                                                    }
                                                ],
                                                "kind": "ListValue",
                                                "name": "actors"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "collabContextId",
                                                "variableName": "collabContextId"
                                            }
                                        ],
                                        "kind": "ObjectValue",
                                        "name": "filter"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "first",
                                        "variableName": "activityFirst"
                                    }
                                ],
                                "concreteType": "ActivityConnection",
                                "kind": "LinkedField",
                                "name": "workedOn",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ActivityItemEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "ActivityNode",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "ActivityObject",
                                                        "kind": "LinkedField",
                                                        "name": "object",
                                                        "plural": false,
                                                        "selections": [
                                                            v5 /*: any*/ ,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "data",
                                                                "plural": false,
                                                                "selections": [
                                                                    v0 /*: any*/ ,
                                                                    v7 /*: any*/ ,
                                                                    v8 /*: any*/ ,
                                                                    v9 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ConfluenceDatabaseLinks",
                                                                                "kind": "LinkedField",
                                                                                "name": "links",
                                                                                "plural": false,
                                                                                "selections": v6 /*: any*/ 
                                                                            }
                                                                        ],
                                                                        "type": "ConfluenceDatabase"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ConfluenceEmbedLinks",
                                                                                "kind": "LinkedField",
                                                                                "name": "links",
                                                                                "plural": false,
                                                                                "selections": v6 /*: any*/ 
                                                                            }
                                                                        ],
                                                                        "type": "ConfluenceEmbed"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v10 /*: any*/ ,
                                                                        "type": "ConfluenceFooterComment"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v10 /*: any*/ ,
                                                                        "type": "ConfluenceInlineComment"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "TownsquareGoal"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "TownsquareProject"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "TownsquareComment"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v13 /*: any*/ ,
                                                                        "type": "JiraIssue"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v14 /*: any*/ ,
                                                                        "type": "JiraPlatformComment"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v14 /*: any*/ ,
                                                                        "type": "JiraServiceManagementComment"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v15 /*: any*/ ,
                                                                        "type": "TrelloBoard"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v15 /*: any*/ ,
                                                                        "type": "TrelloCard"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v16 /*: any*/ ,
                                                                        "type": "DevOpsDocument"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "ExternalDocument"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "DevOpsPullRequestDetails"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "ExternalPullRequest"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v16 /*: any*/ ,
                                                                        "type": "DevOpsDesign"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "ExternalRemoteLink"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "MercuryFocusArea"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "MercuryPortfolio"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "RadarPosition"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "RadarView"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v11 /*: any*/ ,
                                                                        "type": "CompassComponent"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "href"
                                                                            }
                                                                        ],
                                                                        "type": "BitbucketPullRequest"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            {
                                                                                "alias": "loomUrl",
                                                                                "kind": "ScalarField",
                                                                                "name": "url"
                                                                            }
                                                                        ],
                                                                        "type": "LoomVideo"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v17 /*: any*/ ,
                                                                        "type": "AssetsObject"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v17 /*: any*/ ,
                                                                        "type": "AssetsObjectType"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": v17 /*: any*/ ,
                                                                        "type": "AssetsSchema"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "skipKnowledgeDiscovery",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "KnowledgeDiscoveryQueryApi",
                        "kind": "LinkedField",
                        "name": "knowledgeDiscovery",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "accountId",
                                        "variableName": "userIdString"
                                    },
                                    v18 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "requestingUserId",
                                        "variableName": "viewerId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "tenantId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "singleUser",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "KnowledgeDiscoveryUserProfile",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryUserManager",
                                                        "kind": "LinkedField",
                                                        "name": "manager",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            },
                                                            v4 /*: any*/ ,
                                                            v2 /*: any*/ ,
                                                            v1 /*: any*/ 
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                        "kind": "LinkedField",
                                                        "name": "thirdPartyIntegrations",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "externalId"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "integrationId"
                                                            },
                                                            v5 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "KnowledgeDiscoverySingleUser"
                                    }
                                ]
                            },
                            {
                                "condition": "skipReportingLines",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "aaid",
                                                "variableName": "userIdString"
                                            },
                                            v18 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "siteId",
                                                "variableName": "siteAri"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "reportingLines",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                        "kind": "LinkedField",
                                                        "name": "user",
                                                        "plural": false,
                                                        "selections": v19 /*: any*/ 
                                                    },
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                        "kind": "LinkedField",
                                                        "name": "managers",
                                                        "plural": true,
                                                        "selections": v19 /*: any*/ 
                                                    },
                                                    {
                                                        "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                        "kind": "LinkedField",
                                                        "name": "reports",
                                                        "plural": true,
                                                        "selections": v19 /*: any*/ 
                                                    }
                                                ],
                                                "type": "KnowledgeDiscoveryReportingLines"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$fc0ddde612e6bc48$var$node.hash = "78097f6eb6a405254f0d6d302740adc3";
var $fc0ddde612e6bc48$export$2e2bcd8739ae039 = $fc0ddde612e6bc48$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $dt88A = parcelRequire("dt88A");

/* ExternalAgentProfileCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $arQY7 = parcelRequire("arQY7");


var $cha5E = parcelRequire("cha5E");





var $iMnC5 = parcelRequire("iMnC5");


var $8pwQJ = parcelRequire("8pwQJ");


var $4ACma = parcelRequire("4ACma");

/* ExternalAgentAttribution.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");





var $w6R6I = parcelRequire("w6R6I");





var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");




parcelRequire("cozmU");

const $29647817cd4a0c0c$export$596fb3b37f9e6bc = ({ label: label = '', size: size = 16 })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": label ? undefined : true,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M5.75241 9.75161C6.14933 9.73039 6.528 9.92036 6.7485 10.2511C7.32031 11.1088 8.05518 12.6117 8.51364 14.3585C8.97113 16.1019 9.18446 18.2061 8.57662 20.2033C8.43233 20.6767 7.99497 21.0001 7.49996 21.0001H1.12496C0.731755 21.0001 0.366514 20.7943 0.162563 20.4582C-0.0410271 20.1221 -0.0541184 19.7037 0.127406 19.3551L4.81491 10.3551L4.89108 10.2291C5.08777 9.94852 5.40485 9.77036 5.75241 9.75161ZM2.97946 18.7501H6.60641C6.80904 17.5092 6.6641 16.1768 6.33688 14.9298C6.18545 14.3529 5.99926 13.811 5.80368 13.3258L2.97946 18.7501Z",
                fill: "currentcolor"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M10.6726 0.000100223C11.1078 -0.00569657 11.5069 0.240378 11.6979 0.631448L20.8474 19.3814C21.0175 19.7301 20.9958 20.1423 20.7902 20.4713C20.5846 20.8001 20.2244 21.0001 19.8366 21.0001H13.6052C13.1926 20.9999 12.813 20.7739 12.6164 20.4112C10.1305 15.8256 8.6081 12.5335 8.11493 9.55967C7.60757 6.49938 8.20182 3.87451 9.66327 0.65928L9.74091 0.51719C9.94288 0.202547 10.2916 0.00530807 10.6726 0.000100223ZM10.7941 3.91123C10.1838 5.79017 10.0388 7.40868 10.3342 9.19053C10.7398 11.6373 11.9886 14.4786 14.2805 18.7501H18.0363L10.7941 3.91123Z",
                fill: "currentcolor"
            })
        ]
    });
};





parcelRequire("cozmU");

const $5a38dc531732be03$export$46703f9c3f1cb6ef = ({ label: label = '', size: size = 16 })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": label ? undefined : true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M7.5 17.625C7.5 16.1753 6.32475 15 4.875 15C3.42525 15 2.25 16.1753 2.25 17.625C2.25 19.0747 3.42525 20.25 4.875 20.25C6.32475 20.25 7.5 19.0747 7.5 17.625ZM20.25 17.625C20.25 16.1753 19.0747 15 17.625 15C16.1753 15 15 16.1753 15 17.625C15 19.0747 16.1753 20.25 17.625 20.25C19.0747 20.25 20.25 19.0747 20.25 17.625ZM20.25 4.875C20.25 3.42525 19.0747 2.25 17.625 2.25C16.1753 2.25 15 3.42525 15 4.875C15 6.32475 16.1753 7.5 17.625 7.5C19.0747 7.5 20.25 6.32475 20.25 4.875ZM9.75 17.625C9.75 20.3174 7.56739 22.5 4.875 22.5C2.18261 22.5 0 20.3174 0 17.625C0 14.9326 2.18261 12.75 4.875 12.75C7.56739 12.75 9.75 14.9326 9.75 17.625ZM7.5 4.875C7.5 3.42525 6.32475 2.25 4.875 2.25C3.42525 2.25 2.25 3.42525 2.25 4.875C2.25 6.32475 3.42525 7.5 4.875 7.5C6.32475 7.5 7.5 6.32475 7.5 4.875ZM9.75 4.875C9.75 5.78992 9.49703 6.64541 9.05859 7.37695L15.1216 13.4399C15.8532 13.0013 16.7099 12.75 17.625 12.75C20.3174 12.75 22.5 14.9326 22.5 17.625C22.5 20.3174 20.3174 22.5 17.625 22.5C14.9326 22.5 12.75 20.3174 12.75 17.625C12.75 16.6628 13.0291 15.7659 13.5103 15.0103L7.48828 8.98828C6.73273 9.46931 5.83705 9.75 4.875 9.75C2.18261 9.75 0 7.56739 0 4.875C0 2.18261 2.18261 0 4.875 0C7.56739 0 9.75 2.18261 9.75 4.875ZM22.5 4.875C22.5 7.56739 20.3174 9.75 17.625 9.75C14.9326 9.75 12.75 7.56739 12.75 4.875C12.75 2.18261 14.9326 0 17.625 0C20.3174 0 22.5 2.18261 22.5 4.875Z",
            fill: "currentcolor"
        })
    });
};


const $eeb5823531f77a57$var$messages = (0, $kSwu1.defineMessages)({
    invokedBy: {
        id: "agent-profile-card.external-agent.ExternalAgentAttribution.invokedBy",
        defaultMessage: "Invoked by {name}"
    },
    invokedByOthers: {
        id: "agent-profile-card.external-agent.ExternalAgentAttribution.invokedByOthers",
        defaultMessage: "Invoked by {name} +{othersCount} {othersCount, plural, one {other} other {others}}"
    },
    viaMcp: {
        id: "agent-profile-card.external-agent.ExternalAgentAttribution.viaMcp",
        defaultMessage: "using Atlassian MCP"
    },
    viaTeamworkGraph: {
        id: "agent-profile-card.external-agent.ExternalAgentAttribution.viaTeamworkGraph",
        defaultMessage: "using Teamwork Graph CLI"
    }
});
const $eeb5823531f77a57$var$CHANNELS = {
    mcp: {
        message: $eeb5823531f77a57$var$messages.viaMcp,
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $29647817cd4a0c0c$export$596fb3b37f9e6bc), {
            size: 14
        })
    },
    'teamwork-graph': {
        message: $eeb5823531f77a57$var$messages.viaTeamworkGraph,
        icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5a38dc531732be03$export$46703f9c3f1cb6ef), {
            size: 15
        })
    }
};
const $eeb5823531f77a57$var$styles = {
    root: "_4ouGXIdnbC",
    rootAggregate: "_39xV02N91d",
    row: "_3iDTPbccYA _4ouGXIdnbC _1EqgXlN91d",
    rowSingle: "_0jFU0VoWWg",
    rowAggregate: "_4kiQYAoWWg _39xV02N91d",
    faceClip: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _3iDTPbvLZJ _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC",
    facepileOutline: "_0bjKvDS5Zs _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _39xV02SPN1 _0jFU0VSPN1 _46hvQmFQfX _0xmtkoFQfX _0LQT5EFQfX _03SyCPFQfX _0KLXrulfZc",
    faceShift: "_3iDTPbvLZJ _43nrzTLl21 _0rIjykLl21 _0GTcwRLl21 _2xTnZxLl21",
    facepile: "_3iDTPbQ4SZ _0hPCNLDIqT _2YgrGrP0S5",
    facepileItem: "_1mT5xdRAKS _2xTnZx5UaJ",
    facepileOverflow: "_1mT5xdRAKS _3YEZNOdnbC _2xTnZx5UaJ",
    facepileOverflowCount: "_0bjKvDS5Zs _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _0KLXruG6qS",
    iconSlot: "_39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    label: "_4ouGXIdnbC",
    labelAggregate: "_39xV02N91d"
};
const $eeb5823531f77a57$var$AttributionRow = ({ media: media, label: label, isAggregate: isAggregate = false, testId: testId })=>{
    const text = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "span",
        xcss: (0, $w6R6I.cx)($eeb5823531f77a57$var$styles.label, isAggregate && $eeb5823531f77a57$var$styles.labelAggregate),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            maxLines: isAggregate ? undefined : 1,
            children: label
        })
    });
    return isAggregate ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        xcss: $eeb5823531f77a57$var$styles.rowAggregate,
        space: "space.075",
        testId: testId,
        children: [
            media,
            text
        ]
    }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        as: "span",
        xcss: (0, $w6R6I.cx)($eeb5823531f77a57$var$styles.row, $eeb5823531f77a57$var$styles.rowSingle),
        space: "space.075",
        alignBlock: "center",
        testId: testId,
        children: [
            media,
            text
        ]
    });
};
const $eeb5823531f77a57$export$34de6b7af78218a7 = ({ invokedBy: invokedBy, invokedVia: invokedVia, renderInvokingUser: renderInvokingUser, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const invokingUsers = invokedBy ? 'name' in invokedBy ? [
        invokedBy
    ] : invokedBy : [];
    const channel = invokingUsers.length > 0 && invokedVia ? $eeb5823531f77a57$var$CHANNELS[invokedVia] : undefined;
    if (invokingUsers.length === 0) return null;
    const renderPerson = (user, content, visibleLabel)=>user.accountId && renderInvokingUser ? renderInvokingUser(user, content, visibleLabel) : content;
    const avatar = (user, isInFacepile = false)=>{
        const face = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $eeb5823531f77a57$var$styles.faceClip,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                xcss: $eeb5823531f77a57$var$styles.faceShift,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                    size: "xxsmall",
                    src: user.avatarUrl,
                    name: ""
                })
            })
        });
        return isInFacepile ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $eeb5823531f77a57$var$styles.facepileOutline,
            children: face
        }) : face;
    };
    const isAggregate = invokingUsers.length > 1;
    const attributionLabel = formatMessage(isAggregate ? $eeb5823531f77a57$var$messages.invokedByOthers : $eeb5823531f77a57$var$messages.invokedBy, {
        name: invokingUsers[0].name,
        othersCount: invokingUsers.length - 1
    });
    const personRow = /*#__PURE__*/ (0, $8aG6j.jsx)($eeb5823531f77a57$var$AttributionRow, {
        testId: testId && `${testId}--invoked-by`,
        isAggregate: isAggregate,
        label: attributionLabel,
        media: isAggregate ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $eeb5823531f77a57$var$styles.facepile,
            children: [
                invokingUsers.slice(0, 3).map((user, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        as: "span",
                        xcss: $eeb5823531f77a57$var$styles.facepileItem,
                        style: {
                            zIndex: 3 - index
                        },
                        "aria-hidden": user.accountId && renderInvokingUser ? undefined : true,
                        children: renderPerson(user, avatar(user, true))
                    }, user.accountId ?? `${user.name}:${index}`)),
                invokingUsers.length > 3 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    xcss: (0, $w6R6I.cx)($eeb5823531f77a57$var$styles.facepileOutline, $eeb5823531f77a57$var$styles.facepileOverflow),
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        as: "span",
                        xcss: $eeb5823531f77a57$var$styles.facepileOverflowCount,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            size: "small",
                            weight: "medium",
                            color: "color.text.subtle",
                            children: invokingUsers.length - 3
                        })
                    })
                })
            ]
        }) : avatar(invokingUsers[0])
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($eeb5823531f77a57$var$styles.root, isAggregate && $eeb5823531f77a57$var$styles.rootAggregate),
        space: isAggregate ? 'space.100' : 'space.0',
        testId: testId,
        children: [
            isAggregate ? personRow : renderPerson(invokingUsers[0], personRow, attributionLabel),
            channel && /*#__PURE__*/ (0, $8aG6j.jsx)($eeb5823531f77a57$var$AttributionRow, {
                testId: testId && `${testId}--invoked-via`,
                label: formatMessage(channel.message),
                media: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $eeb5823531f77a57$var$styles.iconSlot,
                    children: channel.icon
                })
            })
        ]
    });
};



var $jcCt7 = parcelRequire("jcCt7");

const $9f26605a97cb3a96$var$styles = {
    card: "_39xV02PIoL"
};
const $9f26605a97cb3a96$var$ExternalAgentAvatar = ({ name: name, iconUrl: iconUrl })=>{
    const isUplift = (0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false);
    const avatar = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        name: name,
        src: iconUrl,
        appearance: "hexagon",
        size: isUplift ? 'xlarge' : 'small',
        UNSAFE_isUpdatedGeometry: (0, $iDrrr.fg)('platform-dst-avatar-updated-geometry')
    });
    return isUplift ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jcCt7.ExternalAgentAvatarFrame), {
        children: avatar
    }) : avatar;
};
const $9f26605a97cb3a96$var$ExternalAgentCover = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ACma.CardCover), {
        ...props,
        avatar: $9f26605a97cb3a96$var$ExternalAgentAvatar
    });
const $9f26605a97cb3a96$var$NoMetadata = ()=>null;
const $9f26605a97cb3a96$export$37a250ddf8ea111 = ({ accountId: accountId, name: name, iconUrl: iconUrl, vendorLine: vendorLine, description: description, withUser: withUser, renderInvokingUser: renderInvokingUser, via: via, testId: testId })=>{
    const hasInvokingUser = Boolean(withUser && ('name' in withUser || withUser.length > 0));
    const ExternalAgentFooter = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $eeb5823531f77a57$export$34de6b7af78218a7), {
            invokedBy: withUser,
            invokedVia: via,
            renderInvokingUser: renderInvokingUser,
            testId: testId ? `${testId}--attribution` : undefined
        }), [
        withUser,
        via,
        renderInvokingUser,
        testId
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $9f26605a97cb3a96$var$styles.card,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8pwQJ.AgentCard), {
            agent: {
                id: accountId,
                name: name,
                iconUrl: iconUrl,
                description: description,
                creatorName: vendorLine
            },
            slots: {
                cover: $9f26605a97cb3a96$var$ExternalAgentCover,
                metadata: $9f26605a97cb3a96$var$NoMetadata,
                footer: hasInvokingUser ? ExternalAgentFooter : null
            },
            testId: testId
        })
    });
};



var $2khPJ = parcelRequire("2khPJ");

var $5PJPG = parcelRequire("5PJPG");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $d35qR = parcelRequire("d35qR");











var $2atIz = parcelRequire("2atIz");


var $9zU5G = parcelRequire("9zU5G");

const $61b82b6b66057185$var$messages = (0, $kSwu1.defineMessages)({
    viewInvokerProfile: {
        id: "user-profile-card.InvokingUserProfileCardTrigger.viewInvokerProfile",
        defaultMessage: "More information about {name}"
    }
});
const $61b82b6b66057185$export$1e0811641916fd5 = ({ user: user, cloudId: cloudId, orgId: orgId, viewerId: viewerId, visibleLabel: visibleLabel, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const parentCloseGuard = (0, $cozmU.useContext)((0, $2atIz.CardCloseGuardContext));
    const holdParentCardOpen = (0, $cozmU.useCallback)((held)=>{
        if (parentCloseGuard) parentCloseGuard.current = held;
    }, [
        parentCloseGuard
    ]);
    (0, $cozmU.useEffect)(()=>()=>holdParentCardOpen(false), [
        holdParentCardOpen
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: user.accountId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        trigger: "click",
        placement: "right-start",
        offset: [
            0,
            8
        ],
        prefilledProfileData: {
            accountId: user.accountId,
            name: user.name,
            avatarUrl: user.avatarUrl
        },
        ariaLabel: visibleLabel ?? formatMessage($61b82b6b66057185$var$messages.viewInvokerProfile, {
            name: user.name
        }),
        onOpen: ()=>holdParentCardOpen(true),
        onClose: ()=>holdParentCardOpen(false),
        children: children
    });
};



var $cHF6R = parcelRequire("cHF6R");


var $dEXCO = parcelRequire("dEXCO");

/* UserProfileCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $9EOlJ = parcelRequire("9EOlJ");





var $I7hWB = parcelRequire("I7hWB");














var $2tuSz = parcelRequire("2tuSz");


var $lUcpS = parcelRequire("lUcpS");


var $eRfpr = parcelRequire("eRfpr");


var $kKnPE = parcelRequire("kKnPE");


var $hMCZS = parcelRequire("hMCZS");


var $aIlZA = parcelRequire("aIlZA");

const $95df3807650703a0$export$2b163c291f77b3f9 = (bridge, url, app)=>{
    const sourceApp = app ?? 'teams';
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)({
        bridge: bridge,
        product: 'townsquare',
        subProduct: sourceApp
    });
    return app !== undefined && app !== 'teams' ? buildUrlWithAnalyticsParams(url) : url;
};


const $583e2a6550f59f49$var$shouldOpenInSameTab = (townsquareApp)=>townsquareApp === 'teams' || townsquareApp === 'teams-isolated';
const $583e2a6550f59f49$export$a3989301a7f69ed7 = (userId, cloudId, townsquareApp)=>{
    const { href: rawHref, target: target, onNavigate: onNavigate } = (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        shouldOpenInSameTab: $583e2a6550f59f49$var$shouldOpenInSameTab(townsquareApp)
    });
    // When no townsquareApp is provided, fall back to `'teams'` for the bridge string so
    // the analytics tag is always a real app name, never the literal `"undefined-customLink"`.
    const bridgeApp = townsquareApp ?? 'teams';
    const wrappedHref = (0, $95df3807650703a0$export$2b163c291f77b3f9)(`${bridgeApp}-customLink`, rawHref, townsquareApp);
    const href = townsquareApp ? wrappedHref : rawHref;
    const isCrossAppMauEnabled = Boolean(townsquareApp) && href !== rawHref;
    return {
        href: href,
        target: target,
        onNavigate: onNavigate,
        isCrossAppMauEnabled: isCrossAppMauEnabled
    };
};



var $bIiaK = parcelRequire("bIiaK");


var $9gll8 = parcelRequire("9gll8");

/** Appends `/work` to a profile URL, preserving any querystring. */ function $45508ebbf47750c1$export$f339ec3b489d28e5(href) {
    if (!href) return href;
    const [pathPart, queryPart] = href.split('?');
    const normalisedPath = pathPart.endsWith('/') ? `${pathPart}work` : `${pathPart}/work`;
    return queryPart === undefined ? normalisedPath : `${normalisedPath}?${queryPart}`;
}



var $bXEsj = parcelRequire("bXEsj");



















function $f6a1f04ce64d6d23$export$2ebec9f03312245c({ testId: testId, errorType: errorType }) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        fireEvent('ui.profilecard.rendered.error', {
            firedAt: (0, $eRfpr.firedAt)(),
            errorType: errorType,
            hasRetry: false
        });
    }, [
        fireEvent,
        errorType
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
        testId: testId
    });
}



var $fxdou = parcelRequire("fxdou");











var $aCJyI = parcelRequire("aCJyI");




const $dc4ce11f77a04115$var$messages = (0, $kSwu1.defineMessages)({
    accountDeactivated: {
        id: "user-profile-card.DeactivatedStatus.accountDeactivated",
        defaultMessage: "Account deactivated"
    }
});
function $dc4ce11f77a04115$export$3b55902e173dd56e() {
    const intl = (0, $kSwu1.useIntl)();
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aCJyI.default), {
        appearance: "neutral",
        testId: getTestId('account-status'),
        children: intl.formatMessage($dc4ce11f77a04115$var$messages.accountDeactivated)
    });
}


/* EmailSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $fHs3z = parcelRequire("fHs3z");


var $chu6R = parcelRequire("chu6R");





var $hBYtq = parcelRequire("hBYtq");





var $lpNn5 = parcelRequire("lpNn5");




const $ee59531fc0307eed$var$TIMEOUT_DELAY = 2500;
const $ee59531fc0307eed$var$messages = (0, $kSwu1.defineMessages)({
    copyEmailTooltip: {
        id: "user-profile-card.EmailSection.copyEmailTooltip",
        defaultMessage: "Copy email"
    },
    copiedTooltip: {
        id: "user-profile-card.EmailSection.copiedTooltip",
        defaultMessage: "Copied"
    },
    copyEmailButtonLabel: {
        id: "user-profile-card.EmailSection.copyEmailButtonLabel",
        defaultMessage: "Copy email address"
    },
    successIconLabel: {
        id: "user-profile-card.EmailSection.successIconLabel",
        defaultMessage: "Email copied"
    }
});
const $ee59531fc0307eed$var$styles = {
    row: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    copyButton: "_0bjKvDKxmn _2V7sgOdnbC _3hxITiYbGa _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VSPN1 _39xV02SPN1 _1YKVNsdnbC _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0KLXru66of _0wOv4Q7zJH _3Tg68S7dHp _1eOmH6o126 _3gzVzLN4oS",
    copyButtonVisible: "_1YKVNs7dHp",
    copyButtonCopied: "_0wOv4Q18ZR"
};
function $ee59531fc0307eed$export$a46750d033a321b6({ email: email, hideCopyButton: hideCopyButton = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const [isCopied, setIsCopied] = (0, $cozmU.useState)(false);
    const [isRowHovered, setIsRowHovered] = (0, $cozmU.useState)(false);
    const updateTooltip = (0, $cozmU.useRef)();
    const resetTimeout = (0, $cozmU.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>()=>{
            if (resetTimeout.current) clearTimeout(resetTimeout.current);
        }, []);
    const copyToClipboard = async ()=>{
        try {
            await navigator.clipboard.writeText(email);
        } catch  {
            return;
        }
        setIsCopied(true);
        resetTimeout.current = setTimeout(()=>{
            setIsCopied(false);
        }, $ee59531fc0307eed$var$TIMEOUT_DELAY);
    };
    const tooltipLabel = isCopied ? formatMessage($ee59531fc0307eed$var$messages.copiedTooltip) : formatMessage($ee59531fc0307eed$var$messages.copyEmailTooltip);
    const isButtonRevealed = isRowHovered || isCopied;
    if (hideCopyButton) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $ee59531fc0307eed$var$styles.row,
        testId: getTestId('email'),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            maxLines: 1,
            color: "color.text.subtlest",
            testId: getTestId('email-text'),
            children: email
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $ee59531fc0307eed$var$styles.row,
        testId: getTestId('email'),
        onMouseEnter: ()=>setIsRowHovered(true),
        onMouseLeave: ()=>setIsRowHovered(false),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                maxLines: 1,
                color: "color.text.subtlest",
                testId: getTestId('email-text'),
                children: email
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: ({ update: update })=>{
                    updateTooltip.current = update;
                    return tooltipLabel;
                },
                position: "top",
                hasNewContentOnTriggerClick: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                    isDisabled: isCopied,
                    onClick: copyToClipboard,
                    testId: getTestId('email-copy-button'),
                    "aria-label": formatMessage($ee59531fc0307eed$var$messages.copyEmailButtonLabel),
                    xcss: (0, $w6R6I.cx)($ee59531fc0307eed$var$styles.copyButton, isButtonRevealed && $ee59531fc0307eed$var$styles.copyButtonVisible, isCopied && $ee59531fc0307eed$var$styles.copyButtonCopied),
                    children: isCopied ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                        label: formatMessage($ee59531fc0307eed$var$messages.successIconLabel),
                        color: "var(--ds-icon-success, #6A9A23)"
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    })
                })
            })
        ]
    });
}












var $7WEaj = parcelRequire("7WEaj");


var $eKMV3 = parcelRequire("eKMV3");











var $cP7Ln = parcelRequire("cP7Ln");








var $buHp0 = parcelRequire("buHp0");


var $9DHhW = parcelRequire("9DHhW");

const $2066a53fd7da0b8e$export$c7eac394c4a88aeb = (townsquareApp)=>{
    // `fireCustomCrossAppAnalytic` needs raw `createAnalyticsEvent`, so this hook
    // intentionally owns the `@atlaskit/analytics-next` dependency.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (0, $cozmU.useCallback)(()=>{
        if (!townsquareApp) return;
        (0, $buHp0.fireCustomCrossAppAnalytic)({
            tags: [
                'townsquare',
                'navigationExperiences'
            ],
            analyticsEventFireName: 'atlas',
            destinationApp: 'teams',
            bridge: `${townsquareApp}-customLink`,
            source: `townsquare-${townsquareApp}`,
            actionSubjectId: 'viewProfileLink',
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        townsquareApp,
        createAnalyticsEvent
    ]);
};












parcelRequire("cozmU");

function $5ed6cd0d2efefbfe$export$b33fb54b08bb6422() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
                    fill: "#E01E5A"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
                    fill: "#36C5F0"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
                    fill: "#2EB67D"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
                    fill: "#ECB22E"
                })
            ]
        })
    });
}
function $5ed6cd0d2efefbfe$export$1bcbc9c337da86da() {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.1",
                d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.1",
                d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                opacity: "0.2",
                d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
                fill: "white"
            })
        ]
    });
}


const $aa9a50e7a58f2aaa$export$ebea5317ff1808bf = {
    slack: (0, $5ed6cd0d2efefbfe$export$b33fb54b08bb6422),
    teams: (0, $5ed6cd0d2efefbfe$export$1bcbc9c337da86da)
};
function $aa9a50e7a58f2aaa$export$5a867b7c6687d757(integration) {
    return $aa9a50e7a58f2aaa$export$ebea5317ff1808bf[integration];
}


const $9fb9b153af9bf64e$export$596e547f4ce626bc = (integrationId, user)=>{
    if (!integrationId || !user) return;
    const isSlack = integrationId === 'slack';
    const isMsTeams = integrationId === 'teams';
    if (isSlack) {
        const openDmUrl = $9fb9b153af9bf64e$export$9eb522d6e073fba0(user);
        if (openDmUrl) return {
            integration: 'slack',
            openDmUrl: openDmUrl
        };
    } else if (isMsTeams) {
        const openDmUrl = $9fb9b153af9bf64e$export$198aa8f5b10ebb27(user);
        if (openDmUrl) return {
            integration: 'teams',
            openDmUrl: openDmUrl
        };
    }
};
const $9fb9b153af9bf64e$export$9eb522d6e073fba0 = (user)=>{
    const externalId = user?.externalId;
    if (!externalId) return;
    return `https://slack.com/app_redirect?channel=${externalId}`;
};
const $9fb9b153af9bf64e$export$198aa8f5b10ebb27 = (user)=>{
    const email = user?.email;
    if (!email) return;
    return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};


const $8b78f8e317e74b4e$var$normalizeProductKey = (product)=>product.trim().toLowerCase();
/**
 * Keeps the first row for each `product` (case-insensitive). Order matches the input array.
 */ function $8b78f8e317e74b4e$var$uniqueRowsByFirstOccurrence(integrations = []) {
    const seen = new Set();
    const out = [];
    for (const row of integrations){
        const key = $8b78f8e317e74b4e$var$normalizeProductKey(row.product);
        if (seen.has(key)) continue;
        seen.add(key);
        out.push(row);
    }
    return out;
}
const $8b78f8e317e74b4e$export$cf50127c50537c52 = [
    'slack',
    'teams'
];
function $8b78f8e317e74b4e$export$523ecfa1815bea06(integrations, email, integrationIdOrder = $8b78f8e317e74b4e$export$cf50127c50537c52) {
    const rows = $8b78f8e317e74b4e$var$uniqueRowsByFirstOccurrence(integrations ? [
        ...integrations
    ] : []);
    for (const id of integrationIdOrder){
        const row = rows.find((r)=>r.integrationId === id);
        if (!row) continue;
        const entry = {
            email: email,
            externalId: row.externalId,
            integrationId: row.integrationId,
            product: row.product
        };
        const dm = (0, $9fb9b153af9bf64e$export$596e547f4ce626bc)(row.integrationId, {
            email: entry.email,
            externalId: entry.externalId
        });
        if (dm) return {
            entry: entry,
            dm: dm
        };
    }
    return undefined;
}












var $1sCHt = parcelRequire("1sCHt");


var $6TaGl = parcelRequire("6TaGl");


var $9d7Pd = parcelRequire("9d7Pd");


var $8oBbn = parcelRequire("8oBbn");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $4n1IT = parcelRequire("4n1IT");





var $jp2Q3 = parcelRequire("jp2Q3");










const $e73bf856672907cd$var$messages = (0, $kSwu1.defineMessages)({
    actionMenuLabel: {
        id: "user-profile-card.ActionMenu.actionMenuLabel",
        defaultMessage: "More actions for {name}"
    }
});
/** Assigns a node to either a callback ref or an object ref. */ function $e73bf856672907cd$var$assignRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if (ref && typeof ref === 'object') ref.current = node;
}
function $e73bf856672907cd$export$ed57a210b9d13bb6({ items: items, name: name, triggerRef: triggerRef }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setOpen] = (0, $cozmU.useState)(false);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    // Stable callbacks so the inner `Popup` and `IconButton` don't see prop churn each render.
    const handleClose = (0, $cozmU.useCallback)(()=>setOpen(false), []);
    const handleTriggerClick = (0, $cozmU.useCallback)(()=>setOpen((open)=>!open), []);
    const fireActionClick = (0, $cozmU.useCallback)((itemId, hasHref, hasOnClick, index)=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: hasHref,
            hasOnClick: hasOnClick,
            index: index,
            actionId: itemId
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
    if (items.length === 0) return null;
    const renderItem = (item, index)=>{
        if (item.kind === 'link') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oBbn.default), {
            href: item.href,
            target: item.target,
            rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
            testId: getTestId(`menu-item-${item.id}`),
            onClick: (event)=>{
                fireActionClick(item.id, true, Boolean(item.onClick), index);
                item.onClick?.(event);
                setOpen(false);
            },
            children: item.label
        }, item.id);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
            testId: getTestId(`menu-item-${item.id}`),
            onClick: (event)=>{
                fireActionClick(item.id, false, true, index);
                item.onClick(event);
                setOpen(false);
            },
            children: item.label
        }, item.id);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "right-start",
        // The host card sits at `layers.modal()` (510) — use `layers.tooltip()` (700) so the
        // action-menu popup stacks above it. `tooltip()` is the conventional next-layer-up in
        // ADS and is forward-compatible with the upcoming top-layer popup mode.
        zIndex: (0, $jp2Q3.layers).tooltip(),
        testId: getTestId('action-menu'),
        content: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8FgJC.default), {
                    children: items.map(renderItem)
                })
            }),
        trigger: ({ ref: popupTriggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ...triggerProps,
                ref: (node)=>{
                    $e73bf856672907cd$var$assignRef(popupTriggerRef, node);
                    // Skip `null`: Popup re-creates its ref on some renders, briefly passing null.
                    // Stale nodes are filtered by the consumer's `isConnected` check.
                    if (node && triggerRef) triggerRef.current = node;
                },
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: formatMessage($e73bf856672907cd$var$messages.actionMenuLabel, {
                    name: name
                }),
                onClick: handleTriggerClick,
                isSelected: isOpen,
                testId: getTestId('action-menu-trigger')
            })
    });
}












var $c4iAx = parcelRequire("c4iAx");


var $6nl31 = parcelRequire("6nl31");


var $as0eE = parcelRequire("as0eE");







const $4f68084afcb13ad1$var$messages = (0, $kSwu1.defineMessages)({
    giveKudosLabel: {
        id: "user-profile-card.useKudosMenuItem.giveKudosLabel",
        defaultMessage: "Give kudos"
    }
});
/**
 * Stable analytics source attributed to kudos drawer events fired from this card.
 */ const $4f68084afcb13ad1$var$ANALYTICS_SOURCE = 'user-profile-card';
function $4f68084afcb13ad1$export$e739febab83b2399({ accountId: accountId, cloudId: cloudId, viewerId: viewerId, actionMenuTriggerRef: actionMenuTriggerRef }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    // Getter so an unmounted trigger resolves to `null`; focusing a detached node drops focus
    // to `<body>`.
    const focusReturnRef = (0, $cozmU.useMemo)(()=>({
            get current () {
                const element = actionMenuTriggerRef?.current ?? null;
                return element && element.isConnected ? element : null;
            }
        }), [
        actionMenuTriggerRef
    ]);
    // Keep the card open while the drawer is up: clicks on the portalled drawer count as outside
    // clicks. Released on `onCloseComplete`, since trailing events can follow `onClose`.
    const cardCloseGuardRef = (0, $cozmU.useContext)((0, $2atIz.CardCloseGuardContext));
    const holdCardOpen = (0, $cozmU.useCallback)((held)=>{
        if (cardCloseGuardRef) cardCloseGuardRef.current = held;
    }, [
        cardCloseGuardRef
    ]);
    // Never leave the card stuck open if this unmounts mid-drawer.
    (0, $cozmU.useEffect)(()=>()=>holdCardOpen(false), [
        holdCardOpen
    ]);
    const onClose = (0, $cozmU.useCallback)(()=>setIsOpen(false), []);
    const onCloseComplete = (0, $cozmU.useCallback)(()=>holdCardOpen(false), [
        holdCardOpen
    ]);
    const onOpen = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('teams_a11y_focus_high_priority')) holdCardOpen(true);
        setIsOpen(true);
    }, [
        holdCardOpen
    ]);
    const recipient = (0, $cozmU.useMemo)(()=>({
            type: (0, $as0eE.KudosType).INDIVIDUAL,
            recipientId: accountId
        }), [
        accountId
    ]);
    const label = formatMessage($4f68084afcb13ad1$var$messages.giveKudosLabel);
    const menuItem = (0, $cozmU.useMemo)(()=>({
            kind: 'button',
            id: 'give-kudos',
            label: label,
            onClick: onOpen
        }), [
        label,
        onOpen
    ]);
    const teamCentralBaseUrl = (0, $c4iAx.getATLContextUrl)('home');
    const suppressed = !teamCentralBaseUrl || !!viewerId && viewerId === accountId;
    if (suppressed) return {
        menuItem: null,
        launcher: null
    };
    const isFocusA11yEnabled = (0, $iDrrr.fg)('teams_a11y_focus_high_priority');
    const launcher = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6nl31.GiveKudosLauncherLazy), {
            isOpen: isOpen,
            onClose: onClose,
            recipient: recipient,
            analyticsSource: $4f68084afcb13ad1$var$ANALYTICS_SOURCE,
            teamCentralBaseUrl: teamCentralBaseUrl,
            cloudId: cloudId,
            triggerRef: isFocusA11yEnabled ? focusReturnRef : undefined,
            onCloseComplete: isFocusA11yEnabled ? onCloseComplete : undefined
        })
    });
    return {
        menuItem: menuItem,
        launcher: launcher
    };
}


const $d60be53616d0626a$var$messages = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "user-profile-card.action-bar.view-profile",
        defaultMessage: "View profile"
    },
    sendMessageLabel: {
        id: "user-profile-card.action-bar.send-message-label",
        defaultMessage: "Message"
    }
});
function $d60be53616d0626a$export$223875819fd7cf93({ profileData: profileData, cloudId: cloudId, canViewProfile: canViewProfile = true, actions: actions, viewerId: viewerId, isDeactivated: isDeactivated = false }) {
    const intl = (0, $kSwu1.useIntl)();
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const { townsquareApp: townsquareApp, onProfileClick: onProfileClick, getTestId: getTestId, triggerMethod: triggerMethod } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const setPopupInitialFocusRef = (0, $cP7Ln.usePopupInitialFocusRef)();
    // On the top layer, the popup reads its focus target only as it opens. The card loads later,
    // so focus "View profile" when it mounts.
    // TODO: revisit this `.focus()` when late initial focus targets are resolved.
    // See platform/packages/design-system/top-layer/notes/follow-ups/late-mounting-initial-focus-targets.md
    const focusViewProfile = (0, $cozmU.useCallback)((element)=>{
        setPopupInitialFocusRef(element);
        element?.focus();
    }, [
        setPopupInitialFocusRef
    ]);
    const viewProfileInitialFocusRef = triggerMethod === 'click' && (0, $iDrrr.fg)('teams_a11y_focus_high_priority') ? (0, $iDrrr.fg)('platform-dst-top-layer') ? focusViewProfile : setPopupInitialFocusRef : undefined;
    const { accountId: accountId, thirdPartyIntegrations: thirdPartyIntegrations, email: email } = profileData;
    const { href: href, target: target, onNavigate: onNavigate, isCrossAppMauEnabled: isCrossAppMauEnabled } = (0, $583e2a6550f59f49$export$a3989301a7f69ed7)(accountId, cloudId, townsquareApp);
    const fireCrossAppProfileAnalytic = (0, $2066a53fd7da0b8e$export$c7eac394c4a88aeb)(townsquareApp);
    const externalMessage = (0, $cozmU.useMemo)(()=>(0, $8b78f8e317e74b4e$export$523ecfa1815bea06)(thirdPartyIntegrations, email), [
        email,
        thirdPartyIntegrations
    ]);
    // We reuse the existing `@atlaskit/profilecard` clicked.action event so the SLO dashboards see a
    // single click-event surface for both profile-card packages. `index` and `hasOnClick` are
    // required by that schema but are not meaningful for user-profile-card actions, so we always
    // send `index: 0` and `hasOnClick: true`.
    const handleThirdPartyMessageClick = (0, $cozmU.useCallback)((event)=>{
        if (event.type === 'auxclick' && event.button !== 1) return;
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(externalMessage?.dm.openDmUrl),
            hasOnClick: true,
            index: 0,
            actionId: 'thirdPartyMessage',
            isAuxClick: event.type === 'auxclick'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction,
        externalMessage
    ]);
    const handleViewProfileClick = (0, $cozmU.useCallback)((event)=>{
        if (event.type === 'auxclick' && event.button !== 1) return;
        const auxClick = event.type === 'auxclick';
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(href),
            hasOnClick: true,
            index: 0,
            actionId: 'viewProfile',
            isAuxClick: auxClick
        });
        if (isCrossAppMauEnabled) fireCrossAppProfileAnalytic();
        onProfileClick?.(accountId);
        // A middle-click on a link opens a new tab natively, so only run SPA navigation for
        // primary clicks.
        if (!auxClick) onNavigate?.(event);
    }, [
        fireEvent,
        getDurationSinceInteraction,
        href,
        onNavigate,
        onProfileClick,
        isCrossAppMauEnabled,
        fireCrossAppProfileAnalytic,
        accountId
    ]);
    const menuItems = (0, $cozmU.useMemo)(()=>{
        const visible = (actions ?? []).filter((action)=>!action.shouldRender || action.shouldRender(profileData));
        return visible.map((action, index)=>{
            const id = action.id ?? `action-${index}`;
            if (action.link) return {
                kind: 'link',
                id: id,
                label: action.label,
                href: action.link,
                target: action.target,
                onClick: action.callback ? (event, ...args)=>{
                    const isBasicClick = !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
                    if (isBasicClick) {
                        event.preventDefault();
                        action.callback?.(event, ...args);
                    }
                } : undefined
            };
            return {
                kind: 'button',
                id: id,
                label: action.label,
                onClick: (event, ...args)=>action.callback?.(event, ...args)
            };
        });
    }, [
        actions,
        profileData
    ]);
    // "More actions" button: the kudos drawer returns focus here, as the "Give kudos" item
    // unmounts when the menu closes.
    const actionMenuTriggerRef = (0, $cozmU.useRef)(null);
    const { menuItem: kudosMenuItem, launcher: kudosLauncher } = (0, $4f68084afcb13ad1$export$e739febab83b2399)({
        accountId: accountId,
        cloudId: cloudId,
        viewerId: viewerId,
        actionMenuTriggerRef: actionMenuTriggerRef
    });
    const allMenuItems = (0, $cozmU.useMemo)(// Deactivated accounts only surface the "View profile" button - no custom actions or kudos.
    ()=>isDeactivated ? [] : kudosMenuItem ? [
            ...menuItems,
            kudosMenuItem
        ] : menuItems, [
        isDeactivated,
        menuItems,
        kudosMenuItem
    ]);
    const hasActionMenu = allMenuItems.length > 0;
    const hasViewProfile = canViewProfile && Boolean(href);
    const hasExternalMessage = !isDeactivated && Boolean(externalMessage);
    if (!accountId || !hasViewProfile && !hasExternalMessage && !hasActionMenu) return null;
    const inline = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        children: [
            !isDeactivated && externalMessage && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7WEaj.default), {
                href: externalMessage.dm.openDmUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: handleThirdPartyMessageClick,
                onAuxClick: handleThirdPartyMessageClick,
                icon: (0, $aa9a50e7a58f2aaa$export$5a867b7c6687d757)(externalMessage.dm.integration),
                label: intl.formatMessage($d60be53616d0626a$var$messages.sendMessageLabel),
                isTooltipDisabled: false
            }),
            hasViewProfile && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                ref: viewProfileInitialFocusRef,
                href: href,
                appearance: "default",
                target: target,
                onClick: handleViewProfileClick,
                onAuxClick: handleViewProfileClick,
                rel: target === '_blank' ? 'noopener noreferrer' : undefined,
                testId: getTestId('view-profile-button'),
                children: intl.formatMessage($d60be53616d0626a$var$messages.viewProfile)
            }),
            hasActionMenu && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e73bf856672907cd$export$ed57a210b9d13bb6), {
                items: allMenuItems,
                name: profileData.name,
                triggerRef: actionMenuTriggerRef
            })
        ]
    });
    // When there's no kudos launcher to portal-mount, return the bare `<Inline>` element so that
    // callers which expected the legacy single-element return tree continue to see one node (and
    // no extra fragment wrapper). The fragment form is only used when we actually need to render
    // the launcher sibling.
    if (isDeactivated || !kudosLauncher) return inline;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            inline,
            kudosLauncher
        ]
    });
}


/* ReportingLinePane.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");





var $ad7Ou = parcelRequire("ad7Ou");





var $kdlgT = parcelRequire("kdlgT");


var $4bg4c = parcelRequire("4bg4c");













/* MiniHierarchyList.tsx generated by @compiled/babel-plugin v3.0.2 */ 











/* MiniHierarchyMoreRow.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");











var $7vK9E = parcelRequire("7vK9E");










const $c1f76a0ca51cd8c3$var$MAX_STACKED_AVATARS = 3;
const $c1f76a0ca51cd8c3$var$messages = (0, $kSwu1.defineMessages)({
    seeMore: {
        id: "user-profile-card.MiniHierarchyMoreRow.seeMore",
        defaultMessage: "See {count} more"
    }
});
const $c1f76a0ca51cd8c3$var$styles = {
    row: "_0bjKvDKTcp _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbvLZJ _39xV02N91d _0Of8r2gVvo _1Znuxb2ADO _1wydGWgVvo _2Zuz6Q2ADO _1UtDYzy7kJ",
    interactiveRow: "_0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _3gzVzLN4oS",
    stackedAvatar: "_0GTcwR4F84",
    firstAvatar: "_0GTcwRPgdg"
};
function $c1f76a0ca51cd8c3$export$becc079c0bfa72a({ people: people, href: href, target: target, onClick: onClick, onNavigate: onNavigate, testId: testId }) {
    const intl = (0, $kSwu1.useIntl)();
    const stacked = people.slice(0, $c1f76a0ca51cd8c3$var$MAX_STACKED_AVATARS);
    const content = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                alignBlock: "center",
                children: stacked.map((person, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: index === 0 ? $c1f76a0ca51cd8c3$var$styles.firstAvatar : $c1f76a0ca51cd8c3$var$styles.stackedAvatar,
                        "aria-hidden": true,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                            src: person.avatarUrl ?? undefined,
                            name: person.name
                        })
                    }, person.accountId))
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                weight: "medium",
                children: intl.formatMessage($c1f76a0ca51cd8c3$var$messages.seeMore, {
                    count: people.length
                })
            })
        ]
    });
    if (!href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $c1f76a0ca51cd8c3$var$styles.row,
        testId: testId,
        children: content
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        onClick: (event)=>{
            onClick?.();
            onNavigate?.(event);
        },
        xcss: (0, $w6R6I.cx)($c1f76a0ca51cd8c3$var$styles.row, $c1f76a0ca51cd8c3$var$styles.interactiveRow),
        testId: testId,
        children: content
    });
}


/* MiniHierarchyRow.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");





var $jLnA6 = parcelRequire("jLnA6");
















const $37a953e9ceb5bed0$var$styles = {
    row: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKHjOvk _0Of8r2gVvo _1Znuxb2ADO _1wydGWgVvo _2Zuz6Q2ADO _0KLXruDMqu _39xV02N91d",
    selectedRow: "_3vBAKHrzt2 _0KLXrulfZc"
};
function $37a953e9ceb5bed0$export$e0eb144c897b990f({ person: person, selected: selected = false, rowRef: rowRef, testId: testId }) {
    const { name: name, avatarUrl: avatarUrl, jobTitle: jobTitle, numberOfTotalReports: numberOfTotalReports = 0, numberOfDirectReports: numberOfDirectReports = 0 } = person;
    const showBadge = numberOfTotalReports > 0 && numberOfDirectReports > 0;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        ref: rowRef,
        xcss: (0, $w6R6I.cx)($37a953e9ceb5bed0$var$styles.row, selected && $37a953e9ceb5bed0$var$styles.selectedRow),
        testId: testId,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    space: "space.150",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                            src: avatarUrl ?? undefined,
                            name: name
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    color: "color.text",
                                    weight: "medium",
                                    maxLines: 1,
                                    children: name
                                }),
                                jobTitle && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    maxLines: 1,
                                    children: jobTitle
                                })
                            ]
                        })
                    ]
                }),
                showBadge && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jLnA6.default), {
                    appearance: selected ? 'primary' : 'default',
                    max: 99999,
                    children: numberOfTotalReports
                })
            ]
        })
    });
}


const $ce3e99e979c3bdb0$var$MAX_VISIBLE_REPORTS = 3; /** Levels of managers shown above the user when they have no direct reports (manager + skip). */ 
const $ce3e99e979c3bdb0$var$MAX_MANAGERS_NO_REPORTS = 2; /** Levels of managers shown above the user when they do have direct reports (immediate manager). */ 
const $ce3e99e979c3bdb0$var$MAX_MANAGERS_WITH_REPORTS = 1;
const $ce3e99e979c3bdb0$var$styles = {
    scrollArea: "_2O5Vij7dHp _3YEZNO7dHp _4kiQYAdnbC _2WAcuGIZbP _4bt5LAnQyn",
    connector: "_3SamIHFQfX _39xV024Y4b _0jFU0Vey7F _0KLXruKcZT",
    stack: "_4kiQYAN91d _0Of8r25zaO _1wydGW5zaO _1Znuxb5zaO _2Zuz6Q5zaO"
};
function $ce3e99e979c3bdb0$export$749b7901a1a4f14f({ data: data, scrollToken: scrollToken, moreHref: moreHref, moreTarget: moreTarget, onMoreClick: onMoreClick, onMoreNavigate: onMoreNavigate, testId: testId }) {
    const { managers: managers = [], user: user, reports: reports = [] } = data;
    const hasReports = reports.length > 0;
    const maxManagers = hasReports ? $ce3e99e979c3bdb0$var$MAX_MANAGERS_WITH_REPORTS : $ce3e99e979c3bdb0$var$MAX_MANAGERS_NO_REPORTS;
    const orderedManagers = managers.slice(0, maxManagers).reverse();
    const visibleReports = reports.slice(0, $ce3e99e979c3bdb0$var$MAX_VISIBLE_REPORTS);
    const overflowReports = reports.slice($ce3e99e979c3bdb0$var$MAX_VISIBLE_REPORTS);
    const showMoreRow = hasReports && overflowReports.length > 0;
    const connector = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $ce3e99e979c3bdb0$var$styles.connector,
        "aria-hidden": true,
        testId: "hierarchy-connector"
    });
    const scrollRef = (0, $cozmU.useRef)(null);
    const selectedRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        const container = scrollRef.current;
        const selected = selectedRef.current;
        if (!container || !selected) return;
        const center = ()=>{
            const target = selected.offsetTop - (container.clientHeight - selected.offsetHeight) / 2;
            container.scrollTop = Math.max(0, target);
        };
        if (container.clientHeight === 0) {
            const frame = requestAnimationFrame(center);
            return ()=>cancelAnimationFrame(frame);
        }
        center();
    }, [
        user.accountId,
        scrollToken
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        ref: scrollRef,
        xcss: $ce3e99e979c3bdb0$var$styles.scrollArea,
        testId: testId,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            space: "space.100",
            alignBlock: "center",
            alignInline: "center",
            xcss: $ce3e99e979c3bdb0$var$styles.stack,
            children: [
                orderedManagers.map((manager, index)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                        children: [
                            index > 0 && connector,
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $37a953e9ceb5bed0$export$e0eb144c897b990f), {
                                person: manager,
                                testId: `hierarchy-row-manager-${manager.accountId}`
                            })
                        ]
                    }, manager.accountId)),
                orderedManagers.length > 0 && connector,
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $37a953e9ceb5bed0$export$e0eb144c897b990f), {
                    person: user,
                    selected: true,
                    rowRef: selectedRef,
                    testId: "hierarchy-row-selected"
                }),
                hasReports && connector,
                visibleReports.map((person)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $37a953e9ceb5bed0$export$e0eb144c897b990f), {
                        person: person,
                        testId: `hierarchy-row-report-${person.accountId}`
                    }, person.accountId)),
                showMoreRow && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c1f76a0ca51cd8c3$export$becc079c0bfa72a), {
                    people: overflowReports,
                    href: moreHref,
                    target: moreTarget,
                    onClick: onMoreClick,
                    onNavigate: onMoreNavigate,
                    testId: "hierarchy-row-more"
                })
            ]
        })
    });
}


const $640c1c7a91167409$var$styles = {
    focusReset: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp",
    fill: "_2O5Vij7dHp _3YEZNO7dHp _4kiQYAdnbC _0jFU0VN91d _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    listRegion: "_2O5Vij7dHp _3YEZNO7dHp _4kiQYAdnbC _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $640c1c7a91167409$var$messages = (0, $kSwu1.defineMessages)({
    emptyState: {
        id: "user-profile-card.ReportingLinePane.emptyState",
        defaultMessage: "No reporting line information is available."
    },
    viewFullReportingLine: {
        id: "user-profile-card.ReportingLinePane.viewFullReportingLine",
        defaultMessage: "View full org chart"
    },
    heading: {
        id: "user-profile-card.ReportingLinePane.heading",
        defaultMessage: "Reporting line"
    },
    back: {
        id: "user-profile-card.ReportingLinePane.back",
        defaultMessage: "Back to profile"
    },
    backShort: {
        id: "user-profile-card.ReportingLinePane.backShort",
        defaultMessage: "Back"
    }
});
function $640c1c7a91167409$export$c0554440016547ea({ hierarchyData: hierarchyData, viewFullUrl: viewFullUrl, target: target, onNavigate: onNavigate, onViewFullClick: onViewFullClick, onBack: onBack, headingRef: headingRef, resetToken: resetToken, testId: testId }) {
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.200",
        testId: testId,
        xcss: $640c1c7a91167409$var$styles.fill,
        children: [
            onBack && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                space: "space.100",
                alignBlock: "center",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    ref: headingRef,
                    tabIndex: -1,
                    xcss: $640c1c7a91167409$var$styles.focusReset,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
                        appearance: "default",
                        onClick: onBack,
                        testId: "hierarchy-back-button",
                        "aria-label": intl.formatMessage($640c1c7a91167409$var$messages.back),
                        children: intl.formatMessage($640c1c7a91167409$var$messages.backShort)
                    })
                })
            }),
            hierarchyData ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $640c1c7a91167409$var$styles.listRegion,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ce3e99e979c3bdb0$export$749b7901a1a4f14f), {
                    data: hierarchyData,
                    scrollToken: resetToken,
                    moreHref: viewFullUrl,
                    moreTarget: target,
                    onMoreClick: onViewFullClick,
                    onMoreNavigate: onNavigate,
                    testId: "hierarchy-list"
                })
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                paddingBlock: "space.100",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: intl.formatMessage($640c1c7a91167409$var$messages.emptyState)
                })
            }),
            viewFullUrl && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                alignInline: "center",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                    href: viewFullUrl,
                    target: target,
                    rel: target === '_blank' ? 'noopener noreferrer' : undefined,
                    onClick: (event)=>{
                        onViewFullClick?.();
                        onNavigate?.(event);
                    },
                    appearance: "default",
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($4bg4c))),
                    testId: "hierarchy-view-full-link",
                    children: intl.formatMessage($640c1c7a91167409$var$messages.viewFullReportingLine)
                })
            })
        ]
    });
}


/* ManagerSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 






























const $edc2d3ea5f2e6444$export$1f2057e1ea6efa55 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
function $edc2d3ea5f2e6444$export$9219018d2db07e72() {
    return (0, $cozmU.useContext)($edc2d3ea5f2e6444$export$1f2057e1ea6efa55);
}





parcelRequire("cozmU");







const $1e8ff6c940adbec7$var$messages = (0, $kSwu1.defineMessages)({
    orgChart: {
        id: "user-profile-card.ViewReportingLineButton.orgChart",
        defaultMessage: "Org chart"
    }
});
function $1e8ff6c940adbec7$export$c6126cbbcc4238ee({ onClick: onClick, controls: controls, testId: testId }) {
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
        onClick: (event)=>{
            // Popup events cross React portals; do not let this secondary action activate an
            // ancestor control such as the Goals and Projects owner InlineEdit.
            event.stopPropagation();
            onClick();
        },
        "aria-controls": controls,
        testId: testId,
        spacing: "compact",
        appearance: "subtle",
        children: intl.formatMessage($1e8ff6c940adbec7$var$messages.orgChart)
    });
}


const $cd67a816341628e9$var$messages = (0, $kSwu1.defineMessages)({
    managerHeading: {
        id: "user-profile-card.ManagerSection.managerHeading",
        defaultMessage: "Manager"
    }
});
const $cd67a816341628e9$var$styles = {
    link: "_0bjKvDKTcp _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbvLZJ _0Of8r2gVvo _1wydGWgVvo _2Zuz6Q2ADO _1Znuxb2ADO _1UtDYzy7kJ _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _3gzVzLN4oS"
};
function $cd67a816341628e9$export$2992b481dad9fb03({ manager: manager, nonInteractive: nonInteractive = false }) {
    const intl = (0, $kSwu1.useIntl)();
    const { getTestId: getTestId, cloudId: cloudId, townsquareApp: townsquareApp } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const { id: id, name: name, avatarUrl: avatarUrl, jobTitle: jobTitle } = manager;
    const { href: href, target: target, onNavigate: onNavigate } = (0, $583e2a6550f59f49$export$a3989301a7f69ed7)(id, cloudId, townsquareApp);
    const slider = (0, $edc2d3ea5f2e6444$export$9219018d2db07e72)();
    const showOrgChartTrigger = Boolean(slider) && !nonInteractive;
    if (!name) return null;
    const managerDetails = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                src: avatarUrl ?? undefined,
                name: name
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        maxLines: 1,
                        children: name
                    }),
                    jobTitle && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        maxLines: 1,
                        size: "small",
                        children: jobTitle
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        testId: getTestId('manager'),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "start",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        weight: "medium",
                        color: "color.text",
                        children: intl.formatMessage($cd67a816341628e9$var$messages.managerHeading)
                    }),
                    showOrgChartTrigger && slider && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1e8ff6c940adbec7$export$c6126cbbcc4238ee), {
                        onClick: slider.onView,
                        controls: slider.backPaneId,
                        testId: getTestId('view-reporting-line')
                    })
                ]
            }),
            nonInteractive ? managerDetails : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                href: href,
                target: target,
                onClick: onNavigate,
                xcss: $cd67a816341628e9$var$styles.link,
                testId: getTestId('manager-link'),
                children: managerDetails
            })
        ]
    });
}


/* ProfileCardSlider.tsx generated by @compiled/babel-plugin v3.0.2 */ 












const $c676cd3726aaef40$var$SLIDE_DURATION = '0.35s';
const $c676cd3726aaef40$var$SLIDE_EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';
const $c676cd3726aaef40$var$styles = {
    viewport: "_1mT5xdRAKS _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d",
    pane: "_1kOSYtC67X _3Z9K0wngV3 _0qk6IKUtCU _2Iz54kmrqn",
    frontShown: "_1VJPcalna5",
    frontHidden: "_1VJPcaIt9z",
    backPane: "_49OCfRPgdg _4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _3iDTPbQ4SZ _0aFT5vbt8w",
    backHidden: "_1VJPcaKthN",
    backShown: "_1VJPcalna5"
};
function $c676cd3726aaef40$var$useInert(active) {
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const node = ref.current;
        if (!node) return;
        if (active) node.removeAttribute('inert');
        else node.setAttribute('inert', '');
    }, [
        active
    ]);
    return ref;
}
function $c676cd3726aaef40$export$da08d35d50ddd6ca({ children: children, onView: onView, onBack: onBack }) {
    const [showBack, setShowBack] = (0, $cozmU.useState)(false);
    const [resetToken, setResetToken] = (0, $cozmU.useState)(0);
    const backPaneId = (0, $cozmU.useId)();
    const handleView = (0, $cozmU.useCallback)(()=>{
        setShowBack(true);
        setResetToken((token)=>token + 1);
        onView?.();
    }, [
        onView
    ]);
    const handleBack = (0, $cozmU.useCallback)(()=>{
        setShowBack(false);
        onBack?.();
    }, [
        onBack
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            showBack: showBack,
            onView: handleView,
            onBack: handleBack,
            backPaneId: backPaneId,
            resetToken: resetToken
        }), [
        showBack,
        handleView,
        handleBack,
        backPaneId,
        resetToken
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $edc2d3ea5f2e6444$export$1f2057e1ea6efa55).Provider, {
        value: value,
        children: children
    });
}
function $c676cd3726aaef40$export$128359470049ac91({ front: front, back: back, showBack: showBack, onBack: onBack, backPaneId: backPaneId, testId: testId }) {
    const backHeadingRef = (0, $cozmU.useRef)(null);
    const viewportRef = (0, $cozmU.useRef)(null);
    const frontInertRef = $c676cd3726aaef40$var$useInert(!showBack);
    const backInertRef = $c676cd3726aaef40$var$useInert(showBack);
    (0, $cozmU.useEffect)(()=>{
        if (showBack) backHeadingRef.current?.focus({
            preventScroll: true
        });
    }, [
        showBack
    ]);
    (0, $cozmU.useEffect)(()=>{
        const viewport = viewportRef.current;
        if (!viewport) return;
        viewport.scrollLeft = 0;
        viewport.scrollTop = 0;
    }, [
        showBack
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        ref: viewportRef,
        xcss: $c676cd3726aaef40$var$styles.viewport,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                ref: frontInertRef,
                xcss: (0, $w6R6I.cx)($c676cd3726aaef40$var$styles.pane, showBack ? $c676cd3726aaef40$var$styles.frontHidden : $c676cd3726aaef40$var$styles.frontShown),
                children: front
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                ref: backInertRef,
                id: backPaneId,
                role: "group",
                xcss: (0, $w6R6I.cx)($c676cd3726aaef40$var$styles.pane, $c676cd3726aaef40$var$styles.backPane, showBack ? $c676cd3726aaef40$var$styles.backShown : $c676cd3726aaef40$var$styles.backHidden),
                children: back({
                    back: onBack,
                    headingRef: backHeadingRef
                })
            })
        ]
    });
}






parcelRequire("cozmU");






















parcelRequire("cozmU");


var $c2Doe = parcelRequire("c2Doe");




/* RecentWorkItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 


















var $a9aSv = parcelRequire("a9aSv");


var $l8wPz = parcelRequire("l8wPz");


var $4yYAm = parcelRequire("4yYAm");


var $44bfd = parcelRequire("44bfd");


var $7n0A2 = parcelRequire("7n0A2");

/**
 * Module-level memory of which recent-work URLs have previously resolved via Smart Card.
 *
 * 1. Records URLs that have resolved successfully at least once.
 * 2. Lets a freshly mounted item initialise its `resolved` state to `true`, avoiding a
 *    skeleton flash when the profile card re-mounts (e.g. reopening the hover card).
 * 3. Is a no-op on the server so SSR never touches the shared set.
 */ const $64a1c98534950ad8$var$resolvedUrls = new Set();
const $64a1c98534950ad8$var$isBrowser = typeof window !== 'undefined';
function $64a1c98534950ad8$export$16ad849210e30509(url) {
    if (!$64a1c98534950ad8$var$isBrowser || !url) return false;
    return $64a1c98534950ad8$var$resolvedUrls.has(url);
}
function $64a1c98534950ad8$export$4221f35a82bb4741(url) {
    if (!$64a1c98534950ad8$var$isBrowser || !url) return;
    $64a1c98534950ad8$var$resolvedUrls.add(url);
}
function $64a1c98534950ad8$export$85e4c24706d1f5ed() {
    $64a1c98534950ad8$var$resolvedUrls.clear();
}


const $3382bf690af37aa1$var$styles = {
    root: "_0bjKvDKTcp _1mT5xdRAKS _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0KLXru66of _1eOmH6o126",
    unresolved: "_4kiQYAFwex",
    unresolvedSkeletonOverlay: "_0bjKvDKTcp _1mT5xdWVPG _2I62gzPgdg _1ZB6UyPgdg _3iC0zdPgdg _1OKFqYPgdg _0KLXrunmFW _0Of8r22ADO _2Zuz6Q2ADO _42Yu6B7dHp",
    skeletonRows: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC"
}; // These styles target Smart Card's internal DOM (icon, title link, element group), which requires
// nested selectors. `@atlaskit/css`'s `cssMap` disallows nested selectors, so we use
// `@compiled/react`'s `cssMap` here instead — the same approach used by the LinkList component in
// `@atlassian/smart-knowledge-cards`.
const $3382bf690af37aa1$var$unboundedStyles = {
    titleWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC",
    titleBlock: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _4bInUCPgdg _4hM5yg8fU6 _0yksiO2ADO _32GWj52ADO _2ztbEw2ADO _46UOc62ADO _3l7hjhDMqu _2XqGtx5UaJ _16yMdq98eZ _1jGVpLYbGa _3v4Fnm6wH8 _3F6Feu98eZ _4D1MCdYbGa _0ffBHJ6wH8 _013U0G98eZ _0i7M44YbGa _0XBv4M6wH8",
    stateSlot: "_3YEZNOdnbC _3iDTPbQ4SZ _37wbyuz9WS _2XsHFM8HPE"
};
function $3382bf690af37aa1$export$9adc0410c9970c44({ url: url, index: index, onLinkClick: onLinkClick, testId: testId }) {
    const [resolved, setResolved] = (0, $cozmU.useState)(()=>(0, $64a1c98534950ad8$export$16ad849210e30509)(url));
    const handleResolve = (0, $cozmU.useCallback)(()=>{
        (0, $64a1c98534950ad8$export$4221f35a82bb4741)(url);
        setResolved(true);
    }, [
        url
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3382bf690af37aa1$var$styles.root, !resolved && $3382bf690af37aa1$var$styles.unresolved),
        testId: testId ? `${testId}-item-${index}` : undefined,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8wPz.Card), {
                appearance: "block",
                url: url,
                onClick: ()=>onLinkClick?.(url, index),
                ui: {
                    theme: (0, $4yYAm.SmartLinkTheme).Black,
                    clickableContainer: true,
                    hideBackground: true,
                    hideElevation: true,
                    hidePadding: true,
                    size: (0, $4yYAm.SmartLinkSize).Medium,
                    removeBlockRestriction: true
                },
                onResolve: handleResolve,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                    spread: "space-between",
                    alignBlock: "center",
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        alignBlock: "center",
                        xcss: $3382bf690af37aa1$var$unboundedStyles.titleWrapper,
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $3382bf690af37aa1$var$unboundedStyles.titleBlock,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7n0A2.TitleBlock), {
                                    maxLines: 1,
                                    showActionOnHover: true,
                                    subtitle: [
                                        {
                                            name: (0, $4yYAm.ElementName).Provider,
                                            hideIcon: true
                                        },
                                        {
                                            name: (0, $4yYAm.ElementName).ModifiedOn
                                        }
                                    ],
                                    position: (0, $4yYAm.SmartLinkPosition).Center
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $3382bf690af37aa1$var$unboundedStyles.stateSlot,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $44bfd.MetadataBlock), {
                                    maxLines: 1,
                                    primary: [
                                        {
                                            name: (0, $4yYAm.ElementName).State
                                        }
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            !resolved && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $3382bf690af37aa1$var$styles.unresolvedSkeletonOverlay,
                testId: testId ? `${testId}-item-${index}-skeleton` : undefined,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    space: "space.100",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: "32px",
                            height: "32px",
                            borderRadius: "var(--ds-radius-small, 4px)"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                            xcss: $3382bf690af37aa1$var$styles.skeletonRows,
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "40%",
                                    height: "12px",
                                    borderRadius: "var(--ds-radius-small, 4px)"
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "70%",
                                    height: "12px",
                                    borderRadius: "var(--ds-radius-small, 4px)"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


const $8e18470dab2f6ca5$var$DEFAULT_MAX_SOURCES = 3;
function $8e18470dab2f6ca5$export$66aebd6b65f0e0cf({ urls: urls, maxSources: maxSources = $8e18470dab2f6ca5$var$DEFAULT_MAX_SOURCES, onLinkClick: onLinkClick, testId: testId }) {
    if (urls.length === 0) return null;
    const visibleUrls = urls.slice(0, maxSources);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c2Doe.SmartCardProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dinVW.Stack), {
            space: "space.050",
            testId: testId,
            children: visibleUrls.map((url, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3382bf690af37aa1$export$9adc0410c9970c44), {
                    url: url,
                    index: index,
                    onLinkClick: onLinkClick,
                    testId: testId
                }, `${url}-${index}`))
        })
    });
}


const $00b2d1a91d1fd509$var$messages = (0, $kSwu1.defineMessages)({
    recentWorkHeading: {
        id: "user-profile-card.recent-work.heading",
        defaultMessage: "Recent work"
    },
    viewAll: {
        id: "user-profile-card.RecentWorkSection.viewAll",
        defaultMessage: "View all"
    }
});
function $00b2d1a91d1fd509$export$5981f4ad4928b105({ recentWorkData: recentWorkData, testId: testId, viewAllUrl: viewAllUrl, onLinkClick: onLinkClick, onViewAllLinkClick: onViewAllLinkClick }) {
    const intl = (0, $kSwu1.useIntl)();
    if (recentWorkData.length === 0) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        weight: "medium",
                        color: "color.text",
                        children: intl.formatMessage($00b2d1a91d1fd509$var$messages.recentWorkHeading)
                    }),
                    viewAllUrl && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eKMV3.default), {
                        href: viewAllUrl,
                        onClick: onViewAllLinkClick,
                        spacing: "compact",
                        appearance: "subtle",
                        testId: testId ? `${testId}-view-all` : undefined,
                        children: intl.formatMessage($00b2d1a91d1fd509$var$messages.viewAll)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                testId: testId,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8e18470dab2f6ca5$export$66aebd6b65f0e0cf), {
                    urls: recentWorkData,
                    maxSources: 3,
                    onLinkClick: onLinkClick
                })
            })
        ]
    });
}


const $ceb1b60f3799900e$var$styles = {
    root: "_39xV02wBC3 _4ouGXIe9dk _0wOv4Q18ZR _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0KLXruqi9L",
    deactivatedAvatar: "_1llTr6MFyn"
}; /**
    * Presentational profile card displaying a user's core information and recent work.
    * Renders avatar, name, pronouns, job title, department, location, manager, and recent-work items.
    *
    * Shows a loading skeleton when `isLoading` is true or `profileData` is undefined.
    * Displays an error state when profile data is missing or `name` is not provided.
    *
    * Recent-work previews require a `SmartCardProvider` from `@atlaskit/link-provider`
    * in scope (already provided by every Atlassian product shell).
    */ 
function $ceb1b60f3799900e$export$7bf40cd2a197df2d({ profileData: profileData, recentWorkData: recentWorkData, hierarchyData: hierarchyData, isLoading: isLoading = false, testId: testId = 'user-profile-card', cloudId: cloudId, canViewProfile: canViewProfile = true, error: error, actions: actions, viewerId: viewerId, analyticsAttributes: analyticsAttributes, isReduced: isReduced }) {
    const outerContext = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const userId = profileData?.accountId ?? '';
    const localGetTestId = (0, $cozmU.useMemo)(()=>(0, $bXEsj.makeGetTestId)(userId, testId), [
        userId,
        testId
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            ...outerContext,
            cloudId: cloudId,
            getTestId: outerContext.getTestId !== (0, $9gll8.defaultGetTestId) ? outerContext.getTestId : localGetTestId
        }), [
        cloudId,
        localGetTestId,
        outerContext
    ]);
    const analyticsData = {
        source: 'userProfileCard',
        attributes: {
            ...analyticsAttributes,
            cloudId: cloudId,
            userId: userId,
            hasManager: Boolean(profileData?.manager),
            hasRecentWork: Boolean(recentWorkData?.length),
            hasThirdPartyIntegrations: Boolean(profileData?.thirdPartyIntegrations?.length)
        }
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2tuSz.TeamsAppAnalyticsContext), {
        data: analyticsData,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9gll8.UserProfileCardContext).Provider, {
            value: contextValue,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bIiaK.CardOpenTimerProvider), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($ceb1b60f3799900e$var$UserProfileCardErrorBoundary, {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($ceb1b60f3799900e$var$UserProfileCardContent, {
                        profileData: profileData,
                        recentWorkData: recentWorkData,
                        hierarchyData: hierarchyData,
                        isLoading: isLoading,
                        testId: testId,
                        cloudId: cloudId,
                        canViewProfile: canViewProfile,
                        error: error,
                        actions: actions,
                        viewerId: viewerId,
                        isReduced: isReduced
                    })
                })
            })
        })
    });
}
function $ceb1b60f3799900e$var$UserProfileCardErrorBoundary({ children: children, testId: testId }) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const handleError = (0, $cozmU.useCallback)((_error)=>{
        // `default` (not `renderError`) - schema only allows `default | NotFound`.
        fireEvent('ui.profilecard.rendered.error', {
            firedAt: (0, $eRfpr.firedAt)(),
            errorType: 'default',
            hasRetry: false
        });
    }, [
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
        onError: handleError,
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
            testId: testId
        }),
        children: children
    });
}
function $ceb1b60f3799900e$var$UserProfileCardContent({ profileData: profileData, recentWorkData: recentWorkData, hierarchyData: hierarchyData, isLoading: isLoading, testId: testId, cloudId: cloudId, canViewProfile: canViewProfile, error: error, actions: actions, viewerId: viewerId, isReduced: isReduced }) {
    const { getTestId: getTestId } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const hasProfileData = Boolean(profileData && profileData.name);
    (0, $kKnPE.useFireRequestSucceeded)(!isLoading && hasProfileData);
    (0, $kKnPE.useFireRequestFailed)(!isLoading && !hasProfileData ? error ?? null : undefined);
    if (isLoading) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
        testId: testId,
        profileData: profileData,
        isReduced: isReduced
    });
    if (!profileData || !profileData.name) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f6a1f04ce64d6d23$export$2ebec9f03312245c), {
        testId: testId,
        errorType: "NotFound"
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($ceb1b60f3799900e$var$UserProfileCardRenderedContent, {
        profileData: profileData,
        recentWorkData: recentWorkData,
        hierarchyData: hierarchyData,
        testId: testId,
        cloudId: cloudId,
        canViewProfile: canViewProfile,
        getTestId: getTestId,
        actions: actions,
        viewerId: viewerId,
        isReduced: isReduced
    });
} /**
   * Success-only render, split out so `useFireContentRendered` fires only when the content is shown
   * (not on the loading or error states).
   */ 
function $ceb1b60f3799900e$var$UserProfileCardRenderedContent({ profileData: profileData, recentWorkData: recentWorkData, hierarchyData: hierarchyData, testId: testId, cloudId: cloudId, canViewProfile: canViewProfile, getTestId: getTestId, actions: actions, viewerId: viewerId, isReduced: isReduced }) {
    (0, $kKnPE.useFireContentRendered)(profileData);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const { townsquareApp: townsquareApp } = (0, $cozmU.useContext)((0, $9gll8.UserProfileCardContext));
    const { href: profileHref, target: profileTarget, onNavigate: onProfileNavigate } = (0, $583e2a6550f59f49$export$a3989301a7f69ed7)(profileData.accountId, cloudId, townsquareApp);
    const viewAllUrl = (0, $45508ebbf47750c1$export$f339ec3b489d28e5)(profileHref);
    const handleRecentWorkViewAllClick = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(viewAllUrl),
            hasOnClick: true,
            index: 0,
            actionId: 'recentWorkViewAll'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction,
        viewAllUrl
    ]);
    const handleViewReportingLine = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: false,
            hasOnClick: true,
            index: 1,
            actionId: 'viewReportingLine'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
    const handleBackToProfile = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: false,
            hasOnClick: true,
            index: 0,
            actionId: 'backToProfile'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
    const handleViewFullReportingLineClick = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(profileHref),
            hasOnClick: true,
            index: 0,
            actionId: 'viewFullReportingLine'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction,
        profileHref
    ]);
    const handleRecentWorkLinkClick = (0, $cozmU.useCallback)((url, index)=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(url),
            hasOnClick: true,
            index: index,
            actionId: 'recentWorkLink'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
    const { name: name, pronouns: pronouns, avatarUrl: avatarUrl, jobTitle: jobTitle, department: department, location: location, localTime: localTime, manager: manager, email: email } = profileData; // Deactivated (inactive/closed) accounts get a reduced experience: greyed-out avatar, only the
    // "View profile" action, a status lozenge, and no manager / recent-work sections.
    const isDeactivated = profileData.accountStatus === 'inactive' || profileData.accountStatus === 'closed';
    const subtitleParts = [
        jobTitle,
        department
    ].filter(Boolean);
    const subtitle = subtitleParts.join(` \u2022 `);
    const locationLine = localTime && location ? `${location} \u2013 ${localTime}` : location ?? undefined;
    const hasRecentWork = Boolean(recentWorkData?.length);
    const hasHierarchy = Boolean(hierarchyData?.user?.accountId);
    const useSlider = !isDeactivated && hasHierarchy && !isReduced;
    const recentWorkPanel = hasRecentWork && recentWorkData ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $00b2d1a91d1fd509$export$5981f4ad4928b105), {
        recentWorkData: recentWorkData,
        testId: getTestId('recent-work'),
        viewAllUrl: viewAllUrl,
        onViewAllLinkClick: handleRecentWorkViewAllClick,
        onLinkClick: handleRecentWorkLinkClick
    }) : null;
    const profileHeader = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "start",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: isDeactivated ? $ceb1b60f3799900e$var$styles.deactivatedAvatar : undefined,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                            src: avatarUrl ?? undefined,
                            name: name,
                            size: "xlarge",
                            testId: getTestId('avatar')
                        })
                    }),
                    !isReduced && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d60be53616d0626a$export$223875819fd7cf93), {
                        profileData: profileData,
                        cloudId: cloudId,
                        canViewProfile: canViewProfile,
                        actions: actions,
                        viewerId: viewerId,
                        isDeactivated: isDeactivated
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.100",
                        alignBlock: "end",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                                as: "h2",
                                size: "medium",
                                testId: getTestId('name'),
                                children: name
                            }),
                            pronouns && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                color: "color.text.subtlest",
                                testId: getTestId('pronouns'),
                                children: pronouns
                            })
                        ]
                    }),
                    subtitle && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        maxLines: 1,
                        color: "color.text.subtlest",
                        testId: getTestId('subtitle'),
                        children: subtitle
                    }),
                    locationLine && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        maxLines: 1,
                        color: "color.text.subtlest",
                        testId: getTestId('location'),
                        children: locationLine
                    }),
                    !isDeactivated && email && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ee59531fc0307eed$export$a46750d033a321b6), {
                        email: email,
                        hideCopyButton: isReduced
                    }),
                    isDeactivated && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dc4ce11f77a04115$export$3b55902e173dd56e), {})
                    })
                ]
            })
        ]
    });
    const managerSection = !isDeactivated && manager ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cd67a816341628e9$export$2992b481dad9fb03), {
        manager: manager,
        nonInteractive: isReduced
    }) : null;
    const mainColumn = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.150",
        children: [
            profileHeader,
            managerSection,
            !isDeactivated && !isReduced && recentWorkPanel
        ]
    });
    const content = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $ceb1b60f3799900e$var$styles.root,
        testId: testId,
        role: "region",
        "aria-label": name,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dinVW.Stack), {
            space: "space.150",
            testId: "profilecard",
            children: useSlider ? /*#__PURE__*/ (0, $8aG6j.jsx)($ceb1b60f3799900e$var$ReportingLineSliderBody, {
                front: mainColumn,
                renderBack: ({ back: back, headingRef: headingRef, resetToken: resetToken })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $640c1c7a91167409$export$c0554440016547ea), {
                        hierarchyData: hierarchyData,
                        viewFullUrl: profileHref,
                        target: profileTarget,
                        onNavigate: onProfileNavigate,
                        onViewFullClick: handleViewFullReportingLineClick,
                        onBack: back,
                        headingRef: headingRef,
                        resetToken: resetToken,
                        testId: getTestId('reporting-line')
                    }),
                testId: getTestId('slider')
            }) : mainColumn
        })
    });
    if (!useSlider) return content;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c676cd3726aaef40$export$da08d35d50ddd6ca), {
        onView: handleViewReportingLine,
        onBack: handleBackToProfile,
        children: content
    });
}
/**
 * Renders the two-pane reporting-line viewport, reading the shared slide state (toggled by the
 * trigger on the Manager row) from {@link ProfileCardSliderContext}.
 */ function $ceb1b60f3799900e$var$ReportingLineSliderBody({ front: front, renderBack: renderBack, testId: testId }) {
    const slider = (0, $edc2d3ea5f2e6444$export$9219018d2db07e72)();
    if (!slider) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c676cd3726aaef40$export$128359470049ac91), {
        front: front,
        back: ({ back: back, headingRef: headingRef })=>renderBack({
                back: back,
                headingRef: headingRef,
                resetToken: slider.resetToken
            }),
        showBack: slider.showBack,
        onBack: slider.onBack,
        backPaneId: slider.backPaneId,
        testId: testId
    });
}


/**
 * Derives a canonical URL for a recent-activity object, covering every
 * URL-bearing activity type returned by the full profile-page query.
 * Returns a single-element array (for `flatMap`) or an empty array when the
 * object type has no resolvable URL.
 */ function $12851398953afe33$var$extractActivityUrl(objectData) {
    if (!objectData) return [];
    switch(objectData.__typename){
        case 'ConfluencePage':
        case 'ConfluenceBlogPost':
        case 'ConfluenceWhiteboard':
        case 'ConfluenceDatabase':
        case 'ConfluenceEmbed':
        case 'ConfluenceFooterComment':
        case 'ConfluenceInlineComment':
            return objectData.links?.base && objectData.links?.webUi ? [
                `${objectData.links.base}${objectData.links.webUi}`
            ] : [];
        case 'JiraIssue':
        case 'JiraPlatformComment':
        case 'JiraServiceManagementComment':
        case 'DevOpsDocument':
        case 'DevOpsDesign':
            return objectData.webUrl ? [
                objectData.webUrl
            ] : [];
        case 'TrelloBoard':
        case 'TrelloCard':
            return objectData.trelloUrl ? [
                objectData.trelloUrl
            ] : [];
        case 'TownsquareGoal':
        case 'TownsquareProject':
        case 'TownsquareComment':
        case 'ExternalDocument':
        case 'DevOpsPullRequestDetails':
        case 'ExternalPullRequest':
        case 'ExternalRemoteLink':
        case 'MercuryFocusArea':
        case 'MercuryPortfolio':
        case 'RadarPosition':
        case 'RadarView':
        case 'CompassComponent':
            return objectData.url ? [
                objectData.url
            ] : [];
        case 'BitbucketPullRequest':
            return objectData.href ? [
                objectData.href
            ] : [];
        case 'LoomVideo':
            return objectData.loomUrl ? [
                objectData.loomUrl
            ] : [];
        case 'AssetsObject':
        case 'AssetsObjectType':
        case 'AssetsSchema':
            return objectData.links?.web ? [
                objectData.links.web
            ] : [];
        default:
            return [];
    }
}
/**
 * Computes the de-duplication key for a recent-activity object, mirroring the
 * full profile page's `deduplicateId` behaviour:
 * - Confluence comments de-duplicate on their container (page/blog/whiteboard),
 *   so multiple comments on the same page collapse to a single entry
 *   (equivalent to `deduplicateId: ['container.id']`).
 * - Jira comments de-duplicate on their parent issue
 *   (equivalent to `deduplicateId: ['issue.id']`).
 * - Everything else de-duplicates on its own URL
 *   (equivalent to `deduplicateId: ['objectId']`).
 *
 * Falls back to the object's own URL when the container/issue is unavailable.
 */ function $12851398953afe33$var$getActivityDedupeKey(objectData) {
    const ownUrl = $12851398953afe33$var$extractActivityUrl(objectData)[0] ?? '';
    if (!objectData) return ownUrl;
    switch(objectData.__typename){
        case 'ConfluenceFooterComment':
        case 'ConfluenceInlineComment':
            {
                const container = objectData.container;
                const containerUrl = container && 'links' in container && container.links?.base && container.links?.webUi ? `${container.links.base}${container.links.webUi}` : '';
                return containerUrl || ownUrl;
            }
        case 'JiraPlatformComment':
        case 'JiraServiceManagementComment':
            return objectData.issue?.webUrl || ownUrl;
        default:
            return ownUrl;
    }
}
const $12851398953afe33$var$RECENT_WORK_LINK_LIMIT = 3;
/**
 * How many activity entries to request. The card shows at most three links, but entries are
 * dropped before that: types with no resolvable URL, and comments that collapse onto their
 * container. The default over-fetches heavily to survive that; the smaller size trades some of
 * that headroom for a much cheaper request on a surface that fires on hover.
 */ function $12851398953afe33$var$getRecentWorkPageSize() {
    return (0, $iDrrr.fg)('ptc_user_profile_card_reduce_activity_traffic') ? 15 : 50;
}
/**
 * Picks up to `limit` links spread across products instead of taking the most recent few, which a
 * single busy product (a Jira-heavy week, say) would otherwise fill on its own. Products are
 * visited in order of their most recent activity, taking one link each per pass, so the first pick
 * is still the single most recent item.
 */ function $12851398953afe33$var$pickDiverseLinks(candidates, limit) {
    const urlsByProduct = new Map();
    for (const candidate of candidates){
        const existing = urlsByProduct.get(candidate.product);
        if (existing) existing.push(candidate.url);
        else urlsByProduct.set(candidate.product, [
            candidate.url
        ]);
    }
    const queues = Array.from(urlsByProduct.values());
    const picked = [];
    while(picked.length < limit && queues.some((queue)=>queue.length > 0))for (const queue of queues){
        const url = queue.shift();
        if (url) picked.push(url);
        if (picked.length === limit) break;
    }
    return picked;
}
/**
 * Maps a knowledge-discovery reporting-line person into the card's `HierarchyPerson`, or `null` when
 * the entry has no account identifier (unusable for rendering/keys).
 */ function $12851398953afe33$var$mapHierarchyPerson(person) {
    if (!person?.accountIdentifier) return null;
    return {
        accountId: person.accountIdentifier,
        name: person.pii?.name ?? '',
        avatarUrl: person.pii?.picture ?? null,
        jobTitle: person.pii?.extendedProfile?.jobTitle ?? null,
        numberOfDirectReports: person.numberOfDirectReports ?? undefined,
        numberOfTotalReports: person.numberOfTotalReports ?? undefined
    };
}
/** Maps a reporting-line person list to `HierarchyPerson`, dropping entries without an account id. */ function $12851398953afe33$var$mapPeople(people) {
    return (people ?? []).map($12851398953afe33$var$mapHierarchyPerson).filter((person)=>person !== null);
}
/**
 * Builds the full site ARI that `reportingLines(siteId:)` requires (it needs an ARI, not the raw
 * cloudId). Returns `''` when the cloudId is missing.
 */ function $12851398953afe33$var$buildSiteAri(cloudId) {
    return cloudId ? (0, $5PJPG.PlatformSiteAri).create({
        siteId: cloudId
    }).toString() : '';
}
/**
 * Renders a user profile card from a Relay fragment.
 *
 * The fragment is colocated: it contains the user's base profile (name, avatar,
 * email, extendedProfile) and the supplemental data (manager, third-party
 * integrations, recent work) in one spread, so everything fetches in a single
 * round-trip.
 *
 * Recent-work previews need a `SmartCardProvider` from `@atlaskit/link-provider`
 * in scope. Atlassian product shells provide this by default.
 *
 * @example
 * ```tsx
 * const data = useLazyLoadQuery<MyQuery>(
 *   graphql`
 *     query MyQuery($userId: ID!, $cloudId: String!, $orgId: String!, $viewerId: String!) {
 *       ...UserProfileCardRelay_query @arguments(
 *         userId: $userId, cloudId: $cloudId, orgId: $orgId, viewerId: $viewerId
 *       )
 *     }
 *   `,
 *   buildQueryVariables({ userId, cloudId, orgId, viewerId }),
 * );
 * return <UserProfileCardRelay queryFragment={data} cloudId={cloudId} />;
 * ```
 */ function $12851398953afe33$export$8d4b90914bf8e85e({ queryFragment: queryFragment, cloudId: cloudId, orgId: orgId, testId: testId, isLoading: isLoading, agent: agent, agentInvokedBy: agentInvokedBy, actions: actions, viewerId: viewerId, prefilledProfileData: prefilledProfileData, customerCardDataLoader: customerCardDataLoader, isReduced: isReduced }) {
    const data = (0, $6SsN4.useFragment)((0, $fc0ddde612e6bc48$export$2e2bcd8739ae039), queryFragment);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($12851398953afe33$var$UserProfileCardRelayContent, {
        data: data,
        cloudId: cloudId,
        orgId: orgId,
        testId: testId,
        isLoading: isLoading,
        agent: agent,
        agentInvokedBy: agentInvokedBy,
        actions: actions,
        viewerId: viewerId,
        prefilledProfileData: prefilledProfileData,
        customerCardDataLoader: customerCardDataLoader,
        isReduced: isReduced
    });
}
function $12851398953afe33$var$UserProfileCardRelayContent({ data: data, cloudId: cloudId, orgId: orgId, testId: testId, isLoading: isLoading, agent: agent = {}, agentInvokedBy: agentInvokedBy, actions: actions, viewerId: viewerId, prefilledProfileData: prefilledProfileData, customerCardDataLoader: customerCardDataLoader, isReduced: isReduced }) {
    const user = data.user;
    const accountId = user?.accountId ?? '';
    const [customerProfileData, setCustomerProfileData] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!accountId || user?.__typename !== 'CustomerUser' || user.email || !customerCardDataLoader) return;
        let isCurrent = true;
        Promise.resolve().then(()=>customerCardDataLoader(cloudId, accountId)).then((profileData)=>{
            if (isCurrent) setCustomerProfileData({
                accountId: accountId,
                profileData: profileData
            });
        }).catch(()=>undefined);
        return ()=>{
            isCurrent = false;
        };
    }, [
        accountId,
        cloudId,
        customerCardDataLoader,
        user?.__typename,
        user?.email
    ]);
    const fallbackProfileData = customerProfileData?.accountId === accountId ? customerProfileData.profileData : undefined;
    const rawSingleUser = data.knowledgeDiscovery?.singleUser;
    const knowledgeSingleUser = rawSingleUser && 'user' in rawSingleUser ? rawSingleUser : null;
    const rawManager = knowledgeSingleUser?.user?.manager;
    const rawReportingLines = data.knowledgeDiscovery?.reportingLines;
    const hierarchyData = (0, $cozmU.useMemo)(()=>{
        if (!rawReportingLines || !('user' in rawReportingLines)) return undefined;
        const hierarchyUser = $12851398953afe33$var$mapHierarchyPerson(rawReportingLines.user);
        if (!hierarchyUser) return undefined;
        const managers = $12851398953afe33$var$mapPeople(rawReportingLines.managers);
        const reports = $12851398953afe33$var$mapPeople(rawReportingLines.reports);
        return {
            user: hierarchyUser,
            managers: managers.length ? managers : undefined,
            reports: reports.length ? reports : undefined
        };
    }, [
        rawReportingLines
    ]);
    const recentWorkData = (0, $cozmU.useMemo)(()=>{
        const edges = data.activity?.workedOn?.edges ?? [];
        // De-duplicate by the profile page's `deduplicateId` key (comments collapse
        // onto their container/issue), keeping the first occurrence, then resolve
        // each survivor to its display URL.
        const seenKeys = new Set();
        const candidates = [];
        for (const edge of edges){
            const activityObject = edge?.node?.object;
            const displayUrl = $12851398953afe33$var$extractActivityUrl(activityObject?.data)[0];
            if (!displayUrl) continue;
            const dedupeKey = $12851398953afe33$var$getActivityDedupeKey(activityObject?.data);
            if (seenKeys.has(dedupeKey)) continue;
            seenKeys.add(dedupeKey);
            candidates.push({
                product: activityObject?.product ?? '',
                url: displayUrl
            });
        }
        const urls = (0, $iDrrr.fg)('ptc_user_profile_card_reduce_activity_traffic') ? $12851398953afe33$var$pickDiverseLinks(candidates, $12851398953afe33$var$RECENT_WORK_LINK_LIMIT) : candidates.slice(0, $12851398953afe33$var$RECENT_WORK_LINK_LIMIT).map((candidate)=>candidate.url);
        return urls.length ? urls : undefined;
    }, [
        data.activity?.workedOn?.edges
    ]);
    const appUserJobTitle = user?.__typename === 'AppUser' ? user.extendedProfile?.jobTitle : null;
    const appUserDescription = user?.__typename === 'AppUser' ? user.extendedProfile?.aboutMe ?? undefined : undefined;
    const appType = user && 'appType' in user ? user.appType : null;
    // AGG's AppUser job titles mark the Atlassian MCP route (graphql-gateway PR #6677).
    // The TWG variant has no marker here; computer control and user API key routes are not
    // identified by these values. Keep the loading and loaded card on the same routing rule.
    const cardKind = (0, $cHF6R.getProfileCardKind)({
        userType: user?.__typename,
        appType: appType,
        jobTitle: appUserJobTitle
    });
    const isAgent = cardKind !== 'person';
    const profileData = (0, $cozmU.useMemo)(()=>{
        if (!user || isAgent) return null;
        const knowledge = knowledgeSingleUser?.user;
        const manager = rawManager?.id ? {
            id: rawManager.id,
            name: rawManager.name,
            avatarUrl: rawManager.picture,
            jobTitle: rawManager.jobTitle
        } : null;
        const thirdPartyIntegrations = knowledge?.thirdPartyIntegrations?.filter((integration)=>Boolean(integration?.externalId && integration?.integrationId && integration?.product)).map((integration)=>({
                externalId: integration.externalId,
                integrationId: integration.integrationId,
                product: integration.product
            }));
        return {
            accountId: user.accountId,
            accountStatus: user.accountStatus ?? fallbackProfileData?.accountStatus,
            name: user.name ?? fallbackProfileData?.name ?? '',
            pronouns: fallbackProfileData?.pronouns,
            avatarUrl: user.picture ?? fallbackProfileData?.avatarUrl,
            email: user.email || fallbackProfileData?.email,
            jobTitle: user.extendedProfile?.jobTitle ?? fallbackProfileData?.jobTitle,
            department: user.extendedProfile?.department ?? fallbackProfileData?.department,
            location: user.extendedProfile?.location ?? fallbackProfileData?.location,
            localTime: fallbackProfileData?.localTime,
            organization: user.extendedProfile?.organization ?? fallbackProfileData?.organization,
            manager: manager ?? fallbackProfileData?.manager ?? null,
            thirdPartyIntegrations: thirdPartyIntegrations?.length ? thirdPartyIntegrations : fallbackProfileData?.thirdPartyIntegrations ?? null
        };
    }, [
        user,
        isAgent,
        knowledgeSingleUser,
        rawManager,
        fallbackProfileData
    ]);
    if (!accountId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
        testId: testId
    });
    // Agent cards own their chrome and width. Both agent kinds use the same trigger placement and
    // offset; the popup recalculates after the loading card changes size.
    if (isAgent) {
        if (cardKind === 'external-agent') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9f26605a97cb3a96$export$37a250ddf8ea111), {
            accountId: accountId,
            name: user?.name ?? '',
            iconUrl: user?.picture,
            description: appUserDescription,
            withUser: agentInvokedBy,
            renderInvokingUser: (invoker, content, visibleLabel)=>invoker.accountId ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $61b82b6b66057185$export$1e0811641916fd5), {
                    user: {
                        ...invoker,
                        accountId: invoker.accountId
                    },
                    cloudId: cloudId,
                    orgId: orgId,
                    viewerId: viewerId,
                    visibleLabel: visibleLabel,
                    children: content
                }) : content,
            via: "mcp",
            testId: testId
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dt88A.AgentCard), {
            ...agent,
            accountId: accountId,
            cloudId: cloudId,
            resourceClient: agent.resourceClient
        });
    }
    const displayedProfileData = isLoading && prefilledProfileData ? prefilledProfileData : profileData;
    if (!displayedProfileData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
        testId: testId
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d35qR.CardPopupWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ceb1b60f3799900e$export$7bf40cd2a197df2d), {
            cloudId: cloudId,
            testId: testId,
            isLoading: isLoading,
            profileData: displayedProfileData,
            canViewProfile: user?.__typename !== 'CustomerUser',
            recentWorkData: recentWorkData,
            hierarchyData: hierarchyData,
            actions: actions,
            viewerId: viewerId,
            isReduced: isReduced
        })
    });
}
function $12851398953afe33$export$9a3cee82e7cc08ff({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, isReduced: isReduced }) {
    const skipKnowledgeDiscovery = !cloudId || !orgId || !viewerId;
    const siteAri = $12851398953afe33$var$buildSiteAri(cloudId);
    const skipReportingLines = skipKnowledgeDiscovery || !siteAri;
    // The reduced card never renders the recent-activity panel, so don't fetch it.
    // Without a cloudId there is no collab context for Worklens to resolve.
    const skipActivity = !!isReduced || !cloudId && ((0, $iDrrr.fg)('mycl-493-activity-always-has-collab-context') || (0, $iDrrr.fg)('mycl-493-bitbucket-provides-collab-context'));
    const isUserAri = (0, $2khPJ.IdentityUserAri).check(userId);
    const accountId = (0, $dEXCO.profileQueryAccountId)(userId);
    return {
        userId: accountId,
        userIdString: accountId,
        cloudId: cloudId ?? '',
        orgId: orgId ?? '',
        viewerId: viewerId ?? '',
        siteAri: siteAri,
        userAri: isUserAri ? userId : (0, $2khPJ.IdentityUserAri).create({
            userId: userId
        }).toString(),
        skipKnowledgeDiscovery: skipKnowledgeDiscovery,
        skipReportingLines: skipReportingLines,
        skipActivity: skipActivity,
        collabContextId: cloudId ? (0, $5PJPG.PlatformSiteAri).create({
            siteId: cloudId
        }).toString() : null,
        activityFirst: $12851398953afe33$var$getRecentWorkPageSize(),
        includeExternalAgentFields: (0, $4o0zT.isExperimentEnabled)('cc_external_agent_profile_card')
    };
}
module.exports["UserProfileCardRelay"] = $12851398953afe33$export$8d4b90914bf8e85e;
module.exports["buildQueryVariables"] = $12851398953afe33$export$9a3cee82e7cc08ff;

});

parcelRegister("dt88A", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $cha5E = parcelRequire("cha5E");


var $iDrrr = parcelRequire("iDrrr");


var $4PAHv = parcelRequire("4PAHv");


var $3jT9F = parcelRequire("3jT9F");


var $bPFqZ = parcelRequire("bPFqZ");


var $c4fg0 = parcelRequire("c4fg0");


var $2bKeO = parcelRequire("2bKeO");


var $fk4o9 = parcelRequire("fk4o9");

function $39b35634554d0ec8$var$AgentCardRelay({ accountId: accountId, cloudId: cloudId, hideStarButton: hideStarButton, hideConversationStarters: hideConversationStarters, hideAiDisclaimer: hideAiDisclaimer, onChatClick: onChatClick, onConversationStartersClick: onConversationStartersClick, onViewProfile: onViewProfile, onDuplicate: onDuplicate, onCopyLink: onCopyLink, onEdit: onEdit, onDeleteAgent: onDeleteAgent, renderCTA: renderCTA, slots: slots, renderMoreActions: renderMoreActions }) {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isBrowseKitEnabled = (0, $iDrrr.fg)('rovo_agent_profile_card_browse_kit') && (0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false);
    const entryPoint = isBrowseKitEnabled ? (0, $2bKeO.agentProfileCardEntryPoint) : (0, $3jT9F.agentProfileCardEntryPoint);
    const fallback = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c4fg0.AgentCardLoading), {});
    const entryPointReference = (0, $cozmU.useMemo)(()=>(0, $6SsN4.loadEntryPoint)({
            getEnvironment: ()=>environment
        }, entryPoint, {
            identityAccountId: accountId,
            cloudId: cloudId
        }), [
        accountId,
        cloudId,
        environment,
        entryPoint
    ]);
    const handleConversationStarterClick = (0, $cozmU.useMemo)(()=>(prompt)=>onConversationStartersClick?.({
                message: prompt,
                type: 'static'
            }), [
        onConversationStartersClick
    ]);
    const handleDelete = (0, $cozmU.useMemo)(()=>onDeleteAgent ? (agentId)=>{
            onDeleteAgent(agentId);
        } : undefined, [
        onDeleteAgent
    ]);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            action: 'mounted',
            actionSubject: 'agentCardRelay',
            eventType: 'operational',
            attributes: {
                source: 'agentCard'
            }
        }).fire();
        return ()=>{
            entryPointReference.dispose?.();
        };
    }, [
        entryPointReference,
        createAnalyticsEvent
    ]);
    const card = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: fallback,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bPFqZ.InternalEntryPointContainer), {
            id: "agent-profile-card",
            entryPointReference: entryPointReference,
            runtimeProps: {
                cloudId: cloudId,
                identityAccountId: accountId,
                hideStarButton: hideStarButton,
                hideConversationStarters: hideConversationStarters,
                hideAiDisclaimer: hideAiDisclaimer,
                onChatClick: onChatClick,
                onConversationStarterClick: handleConversationStarterClick,
                onViewProfile: onViewProfile,
                onDuplicate: onDuplicate,
                onCopyLink: onCopyLink,
                onEdit: onEdit,
                onDelete: handleDelete,
                renderCTA: renderCTA,
                slots: slots,
                renderMoreActions: renderMoreActions
            },
            fallback: fallback
        })
    });
    return isBrowseKitEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fk4o9.AgentProfileCardCreditsWrapper), {
        cloudId: cloudId,
        children: card
    }) : card;
}
function $39b35634554d0ec8$export$4bb3d93416a668a2(props) {
    if ((0, $iDrrr.fg)('rovo_agent_profile_card_browse_kit') && (0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false) || (0, $iDrrr.fg)('rovo_agent_profile_card_relay')) return /*#__PURE__*/ (0, $8aG6j.jsx)($39b35634554d0ec8$var$AgentCardRelay, {
        ...props
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4PAHv.AgentProfileCardResourced), {
        ...props
    });
}
module.exports["AgentCard"] = $39b35634554d0ec8$export$4bb3d93416a668a2;

});

parcelRegister("3jT9F", function(module, exports) {

var $1dSeV = parcelRequire("1dSeV");


var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $3P7Ao = parcelRequire("3P7Ao");

function $13071ff81ef7f67c$var$resolveQueryVariables(params) {
    if ('identityAccountId' in params) {
        const identityAccountId = params.identityAccountId.startsWith('ari:cloud:identity::user/') ? params.identityAccountId : `ari:cloud:identity::user/${params.identityAccountId}`;
        return {
            agentAri: '',
            identityAccountId: identityAccountId,
            cloudId: params.cloudId,
            fetchByIdentity: true
        };
    }
    const agentAri = 'agentAri' in params ? params.agentAri : (0, $1dSeV.RovoAgentAri).create({
        activationId: params.activationId,
        agentId: params.agentId
    }).toString();
    return {
        agentAri: agentAri,
        identityAccountId: '',
        cloudId: '',
        fetchByIdentity: false
    };
}

const $13071ff81ef7f67c$export$cf39f5e5e131a6dd = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("jLN2H")), {
        moduleId: "dc6e5a58",
        moduleName: "AgentProfileCardContainer",
        priority: "interaction",
        moduleId: 'conversation-assistant-agent_agent-profile-card'
    }),
    getPreloadProps: (params)=>{
        const queryVariables = $13071ff81ef7f67c$var$resolveQueryVariables(params);
        return {
            queries: {
                agentProfileCardQuery: {
                    parameters: (0, $3P7Ao.default),
                    variables: queryVariables,
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});
module.exports["agentProfileCardEntryPoint"] = $13071ff81ef7f67c$export$cf39f5e5e131a6dd;

});

parcelRegister("3P7Ao", function(module, exports) {
/**
 * @generated SignedSource<<7322fdecc2db577f1cb581f993dd3334>>
 * @relayHash 0e768e393b30d02fefa70aea6ff331dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fefb4d34fda4855a9da03cd56fbed1e14738ca4c05789a9e81445f95ef8d208c

var $8CPva = parcelRequire("8CPva");

const $cfa90136d687f07f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "agentAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchByIdentity"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "identityAccountId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        v5 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "AgentProfileCard_agentRef"
                            }
                        ],
                        "type": "AgentStudioAssistant"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "AgentProfileCard_agentRef"
                }
            ],
            "type": "AgentStudioAssistant"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "identityAccountId"
        }
    ], v10 = [
        v5 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "description"
                },
                {
                    "kind": "ScalarField",
                    "name": "icon"
                },
                {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                },
                {
                    "condition": "__relay_internal__pv__migrateagentavatarcomponenttoadsrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "identityAccount",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isUser"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "appType"
                                        }
                                    ],
                                    "type": "AppUser"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                },
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                },
                {
                    "kind": "ScalarField",
                    "name": "conversationStarters"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorType"
                },
                {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                },
                {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountStatus"
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        v6 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "profileUrl"
                        },
                        v6 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "AgentStudioAgentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canEdit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canDelete"
                        }
                    ]
                }
            ],
            "type": "AgentStudioAssistant"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ 
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AgentProfileCardContainerQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__migrateagentavatarcomponenttoadsrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "AgentProfileCardContainerQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fefb4d34fda4855a9da03cd56fbed1e14738ca4c05789a9e81445f95ef8d208c",
            "metadata": {},
            "name": "AgentProfileCardContainerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__migrateagentavatarcomponenttoadsrelayprovider": (0, $8CPva.default)
            }
        }
    };
}();
$cfa90136d687f07f$var$node.hash = "7f56b7d6645b9220c953a6792948a3ba";
var $cfa90136d687f07f$export$2e2bcd8739ae039 = $cfa90136d687f07f$var$node;
module.exports["default"] = $cfa90136d687f07f$export$2e2bcd8739ae039;

});

parcelRegister("8CPva", function(module, exports) {
$parcel$export(module.exports, "default", () => $dca7f9fb0fe83c1c$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var $dca7f9fb0fe83c1c$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('migrate-agent-avatar-component-to-ads');
    }
};

});

parcelRegister("jLN2H", function(module, exports) {

let $e64872ee0f2dad36$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e64872ee0f2dad36$var$load("44XW6"),
    $e64872ee0f2dad36$var$load("6wr18"),
    $e64872ee0f2dad36$var$load("hyCrt"),
    $e64872ee0f2dad36$var$load("1cQg7"),
    $e64872ee0f2dad36$var$load("ffEVr"),
    $e64872ee0f2dad36$var$load("iYJZz"),
    $e64872ee0f2dad36$var$load("7EorR"),
    $e64872ee0f2dad36$var$load("jqoep"),
    $e64872ee0f2dad36$var$load("VXbA1"),
    $e64872ee0f2dad36$var$load("hhss7"),
    $e64872ee0f2dad36$var$load("8jBNC")
]).then(()=>parcelRequire('kzpDl'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("fWkhK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $fd925b40062fea78$var$styles = {
    cardDefiniteWidth: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _39xV029zBZ _0KLXruoI2d",
    body: "_0Of8r2Va5s _2Zuz6Q5zaO _1Znuxb5zaO _1wydGW5zaO"
};
const $fd925b40062fea78$export$406245d651cacfa7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "96px",
            borderRadius: 0
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fd925b40062fea78$var$styles.cardDefiniteWidth
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $fd925b40062fea78$var$styles.body,
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "160px",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "120px",
            height: "16px"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "48px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "32px"
        })));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd925b40062fea78$var$styles.cardDefiniteWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "96px",
        borderRadius: 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $fd925b40062fea78$var$styles.body,
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "160px",
        height: "20px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "120px",
        height: "16px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "48px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "32px"
    })));
};
module.exports["AgentProfileCardSkeleton"] = $fd925b40062fea78$export$406245d651cacfa7;

});

parcelRegister("jJ1KU", function(module, exports) {
/* AgentCardSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $eFbDl = parcelRequire("eFbDl");


var $cha5E = parcelRequire("cha5E");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $8bAf2 = parcelRequire("8bAf2");


var $dv8iP = parcelRequire("dv8iP");


var $4ACma = parcelRequire("4ACma");


var $jd7zX = parcelRequire("jd7zX");

const $82453c12379c0b8d$var$styles = {
    loadingContent: "_1xC2CJa6YE _4xdlr07p2s _4ouGXIdnbC",
    titleLine: "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VoWWg",
    textLine: "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0Vey7F",
    root: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _24h04i2Njc _0jFU0VN91d _39xV02N91d _0KLXrulfZc _3iDTPbgBM8 _2iEGP28wUV _0ca6V7uqJ7 _3NN0tObcaY _42d1HA8HPE",
    cover: "_1xC2CJiObl _1mT5xdRAKS _39xV02N91d _0jFU0VmdCj",
    coverBackground: "_1mT5xdWVPG _2I62gzPgdg _1ZB6Uy5zaO _3iC0zdPgdg _1OKFqYPgdg",
    coverForeground: "_1mT5xdRAKS _42Yu6B7dHp _24h04i2Njc _3iDTPbgBM8 _39xV02N91d _0jFU0VN91d _2iEGP2cMcx _0GwItXDIqT _0hPCNLDIqT _0Of8r2kG2W _1Znuxb5zaO _2Zuz6Q5zaO",
    content: "_1xC2CJa6YE _4ouGXIdnbC _1Znuxb5zaO _2Zuz6Q5zaO",
    metadata: "_1xC2CJphCm _4ouGXIdnbC _313842IZbP _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
};
const $82453c12379c0b8d$var$LoadingAvatar = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $dv8iP.CardAvatarFrame), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eFbDl.default), {
            size: "xlarge",
            appearance: "hexagon",
            color: "var(--ds-text, #292A2E)"
        })
    });
const $82453c12379c0b8d$export$4f536719d096d4ec = ({ testId: testId })=>{
    if ((0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8bAf2.Card), {
        "aria-hidden": "true",
        hasCutout: true,
        isDisabled: true,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ACma.CardCover), {
                name: "",
                avatar: $82453c12379c0b8d$var$LoadingAvatar,
                coverStyle: "plain",
                testId: testId ? `${testId}--cover` : undefined
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                xcss: $82453c12379c0b8d$var$styles.loadingContent,
                space: "space.150",
                testId: testId ? `${testId}--content` : undefined,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $82453c12379c0b8d$var$styles.titleLine,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "70%",
                                    height: 16
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $82453c12379c0b8d$var$styles.textLine,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "45%",
                                    height: 12
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $82453c12379c0b8d$var$styles.textLine,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "100%",
                                    height: 12
                                })
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $82453c12379c0b8d$var$styles.textLine,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "80%",
                                    height: 12
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $jd7zX.CardFooter), {
                testId: testId ? `${testId}--footer` : undefined,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: 24,
                        height: 24,
                        borderRadius: "var(--ds-radius-medium, 6px)"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: 24,
                        height: 24,
                        borderRadius: "var(--ds-radius-medium, 6px)"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $82453c12379c0b8d$var$styles.root,
        "aria-hidden": "true",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: $82453c12379c0b8d$var$styles.cover,
                testId: testId ? `${testId}--cover` : undefined,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $82453c12379c0b8d$var$styles.coverBackground,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: "100%",
                            height: "100%",
                            borderRadius: 0,
                            isShimmering: true
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $82453c12379c0b8d$var$styles.coverForeground,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: 32,
                            height: 32,
                            isShimmering: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $82453c12379c0b8d$var$styles.content,
                testId: testId ? `${testId}--content` : undefined,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                    space: "space.075",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            space: "space.075",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: 112,
                                    height: 20,
                                    isShimmering: true
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: 16,
                                    height: 16,
                                    isShimmering: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dinVW.Stack), {
                            space: "space.025",
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "100%",
                                height: 16,
                                isShimmering: true
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $82453c12379c0b8d$var$styles.metadata,
                testId: testId ? `${testId}--metadata` : undefined,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    space: "space.075",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: 72,
                            height: 16,
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: 16,
                            height: 16,
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: 32,
                            height: 16,
                            isShimmering: true
                        })
                    ]
                })
            })
        ]
    });
};
module.exports["AgentCardSkeleton"] = $82453c12379c0b8d$export$4f536719d096d4ec;

});

parcelRegister("8bAf2", function(module, exports) {
/* Card.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $cha5E = parcelRequire("cha5E");


var $iMnC5 = parcelRequire("iMnC5");


var $hBYtq = parcelRequire("hBYtq");

/* Card.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $cozmU = parcelRequire("cozmU");











var $dinVW = parcelRequire("dinVW");

const $375f08866154a5dc$var$styles = {
    card: "_0bjKvDyzSk _23rrnHcvle _1mT5xdRAKS _0KLXrulfZc _0jFU0VN91d",
    interactive: "_3B9ZVQJNoT _2bmPrZzwhj _1eOmH6d1Zr _3fSdSTGk8v _3NJLv8TCo3",
    surface: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _24h04i2Njc _0jFU0VN91d",
    pressable: "_0bjKvDyzSk _1mT5xdWVPG _2I62gzPgdg _1ZB6UyPgdg _3iC0zdPgdg _1OKFqYPgdg _42Yu6BgtVO _0KLXrujOvk",
    content: "_1mT5xdRAKS _0jFU0VN91d _39xV02N91d _3iDTPbgBM8 _2iEGP2IZbP _0ca6V72ulg _3NN0tOmM0j _42d1HA8HPE"
};
const $375f08866154a5dc$export$60332b2344f7fe41 = ({ children: children, ariaLabel: ariaLabel, onClick: onClick, isDisabled: isDisabled = false, testId: testId, xcss: xcss, ...boxProps })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onClick?.();
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        ...boxProps,
        xcss: (0, $w6R6I.cx)($375f08866154a5dc$var$styles.card, Boolean(onClick) && !isDisabled && $375f08866154a5dc$var$styles.interactive, xcss),
        testId: testId,
        children: [
            onClick ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                xcss: $375f08866154a5dc$var$styles.pressable,
                onClick: handleClick,
                "aria-label": ariaLabel,
                isDisabled: isDisabled,
                "data-card-pressable": true
            }) : null,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $375f08866154a5dc$var$styles.surface,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dinVW.Stack), {
                    xcss: $375f08866154a5dc$var$styles.content,
                    space: "space.200",
                    children: children
                })
            })
        ]
    });
};


const $bf3abfcac1dc716b$var$styles = {
    card: "_0bjKvDyzSk _23rrnH0rAS _1mT5xdRAKS _0jFU0VN91d _4ouGXIPIoL _1EqgXlsz7G _1SdfoHYbGa",
    frame: "_1mT5xdRAKS _0jFU0VN91d",
    cutout: "_3X9j4qseFd _45s7WmbMq5 _4AZChJnPJF _3mXABNXSSG _0A6Iyfk2L1 _2Y5PIXHgVH",
    cutoutShadow: "_0bjKvDS5Zs _1mT5xdWVPG _2I62gz2ADO _3iC0zd715P _1VJPcajssS _39xV02R4us _0jFU0VZimw _2OUyjtKPGx _1pp6NdYbGa",
    interactive: "_3fSdSTGk8v _3NJLv8TCo3 _4eGeXtYbGa",
    pressable: "_0bjKvDyzSk _1mT5xdWVPG _2I62gzPgdg _1ZB6UyPgdg _3iC0zdPgdg _1OKFqYPgdg _42Yu6BgtVO _0KLXrujOvk",
    disabledPressable: "_0wOv4Q18ZR",
    surface: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _24h04i2Njc _0KLXruqi9L _3iDTPbgBM8 _2iEGP20MSB _0ca6V792QF _3NN0tOO1EA _42d1HA8HPE _0hPCNLF05b _0jFU0VN91d _46hvQm5zaO _0xmtko5zaO _0LQT5E5zaO _03SyCP5zaO"
};
const $bf3abfcac1dc716b$export$60332b2344f7fe41 = ({ xcss: xcss, hasCutout: hasCutout = false, ...props })=>{
    if (!(0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $375f08866154a5dc$export$60332b2344f7fe41), {
        ...props,
        xcss: xcss
    });
    const { children: children, ariaLabel: ariaLabel, 'aria-describedby': ariaDescribedBy, onClick: onClick, isDisabled: isDisabled = false, testId: testId, ...boxProps } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        ...boxProps,
        xcss: (0, $w6R6I.cx)($bf3abfcac1dc716b$var$styles.card, Boolean(onClick) && !isDisabled && $bf3abfcac1dc716b$var$styles.interactive, xcss),
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($bf3abfcac1dc716b$var$styles.frame, hasCutout && $bf3abfcac1dc716b$var$styles.cutout),
                children: [
                    onClick ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                        xcss: (0, $w6R6I.cx)($bf3abfcac1dc716b$var$styles.pressable, isDisabled && $bf3abfcac1dc716b$var$styles.disabledPressable),
                        onClick: ()=>onClick(),
                        "aria-label": ariaLabel,
                        "aria-describedby": ariaDescribedBy,
                        isDisabled: isDisabled,
                        "data-card-pressable": true
                    }) : null,
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $bf3abfcac1dc716b$var$styles.surface,
                        "data-card-surface": true,
                        children: children
                    })
                ]
            }),
            hasCutout ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $bf3abfcac1dc716b$var$styles.cutoutShadow,
                "aria-hidden": "true"
            }) : null
        ]
    });
};
module.exports["Card"] = $bf3abfcac1dc716b$export$60332b2344f7fe41;

});

parcelRegister("dv8iP", function(module, exports) {
/* CardAvatarFrame.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $iMnC5 = parcelRequire("iMnC5");

const $35a62c7d35ac3553$var$styles = {
    frame: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02pJKa _0jFU0VpJKa",
    avatar: "_3YEZNOdnbC _39xV02JgOI _0jFU0VJgOI _1VJPcaFzSL _0yKXXaDIqT",
    hexagon: "_1uo2ZfTcEg"
}; // Compiled supports the child selector needed to size consumer-provided images.
const $35a62c7d35ac3553$var$imageStyles = null;
const $35a62c7d35ac3553$export$34c21c6cf8773dae = ({ children: children, name: name, isHexagon: isHexagon = false })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $35a62c7d35ac3553$var$styles.frame,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                $35a62c7d35ac3553$var$styles.avatar,
                "_3Uxj39vLZJ _1f4A43N91d _2nmIiEN91d _3XtUJZiObl _0NjqGzDIqT",
                isHexagon && $35a62c7d35ac3553$var$styles.hexagon
            ]),
            children: children ?? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                name: name,
                appearance: isHexagon ? 'hexagon' : 'circle',
                size: "xlarge"
            })
        })
    });
module.exports["CardAvatarFrame"] = $35a62c7d35ac3553$export$34c21c6cf8773dae;

});

parcelRegister("4ACma", function(module, exports) {
/* CardCover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $w6R6I = parcelRequire("w6R6I");


var $cJ0FD = parcelRequire("cJ0FD");


var $cha5E = parcelRequire("cha5E");


var $iMnC5 = parcelRequire("iMnC5");


var $dv8iP = parcelRequire("dv8iP");

/* CardCover.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");










const $73f1c039e15f14b8$var$DEFAULT_COVER_COLOR = "var(--ds-background-accent-green-subtlest, #DCFFF1)";
const $73f1c039e15f14b8$var$DEFAULT_GRID_LINE = "var(--ds-border, #0B120E24)";
const $73f1c039e15f14b8$var$DEFAULT_GRID_LINE_WIDTH = '0.3px';
const $73f1c039e15f14b8$var$BACKGROUND_STYLES = {
    grid: `linear-gradient(${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE} ${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE_WIDTH}, transparent ${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE_WIDTH}), linear-gradient(90deg, ${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE} ${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE_WIDTH}, transparent ${$73f1c039e15f14b8$var$DEFAULT_GRID_LINE_WIDTH})`,
    gradient: 'linear-gradient(90deg, rgb(255 255 255 / 0.25) 0%, rgb(255 255 255 / 0) 70%)'
};
const $73f1c039e15f14b8$var$styles = {
    root: "_1xC2CJiObl _1mT5xdRAKS _39xV02N91d _0jFU0VmdCj",
    background: "_1mT5xdWVPG _2I62gzPgdg _1ZB6Uy5zaO _3iC0zdPgdg _1OKFqYPgdg _39xV02N91d _0jFU0VIZbP",
    gridBackground: "_3OqcjTWxuo _1DJ2rVphmj",
    plainRoot: "_0jFU0VIZbP",
    plainForeground: "_46hvQm5zaO",
    foreground: "_2Y7lL45zaO _24h04i2Njc _3iDTPbgBM8 _39xV02N91d _0jFU0VN91d _2iEGP2cMcx _0ca6V7IZbP _3NN0tO0GnG _0GwItXDIqT _0hPCNLDIqT _17lj8p2ADO _46hvQmkG2W",
    avatar: "_1xC2CJNoyG _4xdlr0DIqT _2p6ht9DIqT",
    content: "_1xC2CJa6YE _1mT5xdRAKS _42Yu6Bbhqd _2p6ht9F05b _4ouGXIdnbC",
    slot: "_3iDTPbgBM8 _0pI6nMF05b _0hPCNLDIqT",
    layer: "_1xC2CJYhv7"
};
const $73f1c039e15f14b8$var$DefaultAvatar = ({ name: name, iconUrl: iconUrl })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
        name: name,
        src: iconUrl,
        size: "small"
    });
const $73f1c039e15f14b8$export$1a2d6d8c98d2c941 = ({ name: name, avatar: AvatarComponent = $73f1c039e15f14b8$var$DefaultAvatar, coverStyle: coverStyle = 'grid', coverColor: coverColor, children: children, badge: badge, iconUrl: iconUrl, testId: testId })=>{
    const trailing = badge ?? children;
    const overlay = Boolean(badge && children);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($73f1c039e15f14b8$var$styles.root, coverStyle === 'plain' && $73f1c039e15f14b8$var$styles.plainRoot),
        testId: testId,
        children: [
            coverStyle === 'plain' ? null : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($73f1c039e15f14b8$var$styles.background, coverStyle === 'grid' && $73f1c039e15f14b8$var$styles.gridBackground),
                "aria-hidden": "true",
                style: {
                    backgroundColor: coverColor ?? $73f1c039e15f14b8$var$DEFAULT_COVER_COLOR,
                    backgroundImage: $73f1c039e15f14b8$var$BACKGROUND_STYLES[coverStyle]
                }
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($73f1c039e15f14b8$var$styles.foreground, coverStyle === 'plain' && $73f1c039e15f14b8$var$styles.plainForeground),
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $73f1c039e15f14b8$var$styles.avatar,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)(AvatarComponent, {
                            name: name,
                            iconUrl: iconUrl
                        })
                    }),
                    overlay ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                        xcss: (0, $w6R6I.cx)($73f1c039e15f14b8$var$styles.content, $73f1c039e15f14b8$var$styles.slot),
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $73f1c039e15f14b8$var$styles.layer,
                                children: badge
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $73f1c039e15f14b8$var$styles.layer,
                                children: children
                            })
                        ]
                    }) : trailing ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $73f1c039e15f14b8$var$styles.content,
                        children: trailing
                    }) : null
                ]
            })
        ]
    });
};



var $2SgeP = parcelRequire("2SgeP");

const $e26c08d1c8dff3bd$var$styles = {
    cover: "_1xC2CJiObl _0hPCNLDIqT _0pI6nMDIqT _1mT5xdRAKS _3iDTPbgBM8 _42d1HA5zaO _0xmtkoNHnM",
    background: "_1mT5xdWVPG _2I62gzUgYP _1ZB6UyPgdg _3iC0zdUgYP _1OKFqYUgYP _1pp6NdYbGa",
    neutral: "_0KLXrunmFW",
    gradient: "_3X9j4qp3mJ",
    cutout: "_0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1mT5xdRAKS _24h04i2Njc _43nrzTB0rP _39xV02UF4f _0jFU0VJg58",
    avatar: "_1mT5xdRAKS _3iDTPbQ4SZ",
    disabledAvatar: "_1llTr6DZ41",
    trailing: "_1mT5xdWVPG _2I62gzPgdg _1OKFqYPgdg _42Yu6Bbhqd _3iDTPbgBM8 _0pI6nMF05b _0hPCNLDIqT _1EqgXlN91d",
    layer: "_1xC2CJYhv7"
};
const $e26c08d1c8dff3bd$var$DefaultAvatar = ({ name: name, iconUrl: iconUrl })=>iconUrl ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
        src: iconUrl,
        alt: name,
        width: 48,
        height: 48
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dv8iP.CardAvatarFrame), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
            name: name,
            size: "xlarge"
        })
    });
const $e26c08d1c8dff3bd$export$1a2d6d8c98d2c941 = (props)=>{
    if (!(0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $73f1c039e15f14b8$export$1a2d6d8c98d2c941), {
        ...props
    });
    const { name: name, avatar: AvatarComponent = $e26c08d1c8dff3bd$var$DefaultAvatar, coverStyle: coverStyle = 'grid', coverColor: coverColor, background: background, children: children, badge: badge, iconUrl: iconUrl, isDisabled: isDisabled, testId: testId } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $e26c08d1c8dff3bd$var$styles.cover,
        testId: testId,
        children: [
            background !== undefined ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $e26c08d1c8dff3bd$var$styles.background,
                "aria-hidden": "true",
                children: background
            }) : coverStyle !== 'gradient' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($e26c08d1c8dff3bd$var$styles.background, $e26c08d1c8dff3bd$var$styles.neutral),
                "aria-hidden": "true",
                children: coverStyle === 'grid' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2SgeP.CardCoverArtwork), {}) : null
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($e26c08d1c8dff3bd$var$styles.background, $e26c08d1c8dff3bd$var$styles.gradient),
                style: {
                    backgroundColor: coverColor
                },
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $e26c08d1c8dff3bd$var$styles.cutout,
                "data-card-cutout": true,
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($e26c08d1c8dff3bd$var$styles.avatar, isDisabled && $e26c08d1c8dff3bd$var$styles.disabledAvatar),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)(AvatarComponent, {
                    name: name,
                    iconUrl: iconUrl
                })
            }),
            badge || children ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: $e26c08d1c8dff3bd$var$styles.trailing,
                children: [
                    badge ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $e26c08d1c8dff3bd$var$styles.layer,
                        children: badge
                    }) : null,
                    children ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $e26c08d1c8dff3bd$var$styles.layer,
                        children: children
                    }) : null
                ]
            }) : null
        ]
    });
};
module.exports["CardCover"] = $e26c08d1c8dff3bd$export$1a2d6d8c98d2c941;

});

parcelRegister("2SgeP", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $6ebb9aacbc91d412$export$c8a30effa66534ce = ({ appearance: appearance = 'default' })=>{
    const id = (0, $cozmU.useId)();
    const gridId = `${id}-grid`;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "100%",
        height: "100%",
        "aria-hidden": "true",
        focusable: "false",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("pattern", {
                    id: gridId,
                    width: "20",
                    height: "20",
                    patternUnits: "userSpaceOnUse",
                    x: "50%",
                    y: "9",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M 0 1 H 20 M 0 1 V 21",
                        fill: "none",
                        stroke: appearance === 'inverse' ? "var(--ds-border-inverse, #FFFFFF)" : "var(--ds-border-bold, #7D818A)",
                        strokeOpacity: 0.5,
                        strokeWidth: 1.25,
                        strokeDasharray: "0 4",
                        strokeLinecap: "round"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                width: "100%",
                height: "100%",
                fill: `url(#${gridId})`
            })
        ]
    });
};
module.exports["CardCoverArtwork"] = $6ebb9aacbc91d412$export$c8a30effa66534ce;

});

parcelRegister("jd7zX", function(module, exports) {
/* CardFooter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $cha5E = parcelRequire("cha5E");


var $1l0kj = parcelRequire("1l0kj");

/* CardFooter.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $b626f27198f7c7ef$var$styles = {
    footer: "_1xC2CJtr1Z _2Y7lL45zaO _1mT5xdRAKS _42Yu6Bbhqd _1pp6NdIZbP _4ouGXIdnbC _1wydGW5zaO"
};
const $b626f27198f7c7ef$export$e9897d434e0741ee = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $b626f27198f7c7ef$var$styles.footer,
        testId: testId,
        children: children
    });


const $bd7467a63557867b$var$styles = {
    footer: "_1xC2CJtr1Z _1mT5xdRAKS _42Yu6Bbhqd _4ouGXIdnbC"
};
const $bd7467a63557867b$export$e9897d434e0741ee = (props)=>{
    if (!(0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b626f27198f7c7ef$export$e9897d434e0741ee), {
        ...props
    });
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
        xcss: $bd7467a63557867b$var$styles.footer,
        space: "space.100",
        alignInline: "start",
        alignBlock: "center",
        shouldWrap: true,
        testId: testId,
        children: children
    });
};
module.exports["CardFooter"] = $bd7467a63557867b$export$e9897d434e0741ee;

});

parcelRegister("2bKeO", function(module, exports) {

var $1dSeV = parcelRequire("1dSeV");


var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $1EUnE = parcelRequire("1EUnE");


const $3a7ad12ffbd4d935$export$cf39f5e5e131a6dd = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("wWOwk")).then((module)=>module.AgentProfileCard), {
        moduleId: "a0ccb7dd",
        moduleName: "AgentProfileCard",
        priority: "interaction",
        moduleId: 'agent-profile-card_browse-kit'
    }),
    getPreloadProps: (params)=>{
        const fetchByIdentity = 'identityAccountId' in params;
        const identityAccountId = fetchByIdentity ? params.identityAccountId.startsWith('ari:cloud:identity::user/') ? params.identityAccountId : `ari:cloud:identity::user/${params.identityAccountId}` : '';
        const agentAri = fetchByIdentity ? '' : 'agentAri' in params ? params.agentAri : (0, $1dSeV.RovoAgentAri).create({
            agentId: params.agentId,
            activationId: params.activationId
        }).toString();
        return {
            queries: {
                agentProfileCardQuery: {
                    parameters: (0, $1EUnE.default),
                    variables: {
                        agentAri: agentAri,
                        identityAccountId: identityAccountId,
                        cloudId: fetchByIdentity ? params.cloudId : '',
                        fetchByIdentity: fetchByIdentity
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});
module.exports["agentProfileCardEntryPoint"] = $3a7ad12ffbd4d935$export$cf39f5e5e131a6dd;

});

parcelRegister("1EUnE", function(module, exports) {
/**
 * @generated SignedSource<<40528ebec0584eb606139b5a16dd6e9f>>
 * @relayHash ed587056b8126761659725d58a2a6c8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6c68d7da96edd6d79f9e0278e859ae61f503255861ad8d6a556cdb9b6d76e9be

var $dLvLk = parcelRequire("dLvLk");

const $eb82cffce767a44e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "agentAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchByIdentity"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "identityAccountId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = [
        {
            "fragment": {
                "kind": "InlineFragment",
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "FragmentSpread",
                        "name": "AgentCardRelay_StudioBrowseKit"
                    }
                ],
                "type": "AgentStudioAssistant"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "agent"
        }
    ], v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "identityAccountId"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v11 = [
        v8 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v5 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "description"
                },
                {
                    "kind": "ScalarField",
                    "name": "isVerified"
                },
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__id"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "icon"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                },
                {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                },
                {
                    "kind": "LinkedField",
                    "name": "identityAccount",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                        },
                        v10 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                }
                            ],
                            "type": "AppUser"
                        },
                        v9 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorType"
                },
                {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                },
                {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        v9 /*: any*/ 
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountStatus"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                }
                            ]
                        },
                        v9 /*: any*/ 
                    ]
                }
            ],
            "type": "AgentStudioAssistant"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v9 /*: any*/ 
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AgentProfileCardQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "AgentProfileCardQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v11 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v11 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6c68d7da96edd6d79f9e0278e859ae61f503255861ad8d6a556cdb9b6d76e9be",
            "metadata": {},
            "name": "AgentProfileCardQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider": (0, $dLvLk.default)
            }
        }
    };
}();
$eb82cffce767a44e$var$node.hash = "6bb49a428565993244c38618367b96d4";
var $eb82cffce767a44e$export$2e2bcd8739ae039 = $eb82cffce767a44e$var$node;
module.exports["default"] = $eb82cffce767a44e$export$2e2bcd8739ae039;

});

parcelRegister("wWOwk", function(module, exports) {

let $06309c7a7a625dc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $06309c7a7a625dc5$var$load("hyCrt"),
    $06309c7a7a625dc5$var$load("eOsfC"),
    $06309c7a7a625dc5$var$load("44XW6"),
    $06309c7a7a625dc5$var$load("fHVVl"),
    $06309c7a7a625dc5$var$load("lcWtr"),
    $06309c7a7a625dc5$var$load("1cQg7"),
    $06309c7a7a625dc5$var$load("1AybA"),
    $06309c7a7a625dc5$var$load("hhss7"),
    $06309c7a7a625dc5$var$load("c7hX7")
]).then(()=>parcelRequire('hf1Z9'));

});

parcelRegister("fk4o9", function(module, exports) {
/* AgentProfileCardCreditsWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $lr072 = parcelRequire("lr072");


var $9i4uP = parcelRequire("9i4uP");

const $3a4733d007e35e35$var$styles = {
    frame: "_0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02W9qI _0KLXrunmFW _07XDTD4rZt",
    message: "_24h04i2Njc _39xV02PIoL"
};
const $3a4733d007e35e35$var$AgentProfileCardCreditsContent = ({ children: children, agentName: agentName })=>{
    const { bannerState: bannerState } = (0, $9i4uP.useCreditsState)();
    if (bannerState?.balanceState !== 'depleted') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        padding: "space.100",
        xcss: $3a4733d007e35e35$var$styles.frame,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            space: "space.150",
            children: [
                children,
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    paddingInline: "space.050",
                    paddingBlockEnd: "space.050",
                    xcss: $3a4733d007e35e35$var$styles.message,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lr072.CreditsInlineMessage), {
                        featureName: "agent-profile-card",
                        agentName: agentName
                    })
                })
            ]
        })
    });
};
const $3a4733d007e35e35$export$ad9224e0c5f40802 = ({ children: children, cloudId: cloudId, agentName: agentName })=>{
    if (!(0, $iDrrr.fg)('rovo_credits_degradation_ui')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9i4uP.CreditsProvider), {
        product: "atlassian-agent-studio",
        cloudId: cloudId,
        sessionScope: "site",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($3a4733d007e35e35$var$AgentProfileCardCreditsContent, {
            agentName: agentName,
            children: children
        })
    });
};
module.exports["AgentProfileCardCreditsWrapper"] = $3a4733d007e35e35$export$ad9224e0c5f40802;

});

parcelRegister("lr072", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $a1ZzW = parcelRequire("a1ZzW");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $gUmQU = parcelRequire("gUmQU");


var $lg0Hb = parcelRequire("lg0Hb");


var $i8pw6 = parcelRequire("i8pw6");


var $fhLSq = parcelRequire("fhLSq");


var $ezd2Q = parcelRequire("ezd2Q");

const $b97967f60ffd55b6$var$styles = {
    message: "_1UtDYzy7kJ _3W2Oc8wPeg",
    warning: "_1UtDYzKGUX",
    link: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzy7kJ _1kk5Tkf7mX"
};
const $b97967f60ffd55b6$export$464b311eee196361 = ({ additionalContext: additionalContext, showViewUsage: showViewUsage = false, ...props })=>{
    const usageUrl = (0, $ezd2Q.useCreditsUsageUrl)();
    const context = additionalContext?.trim();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i8pw6.CreditsSurface), props, ({ formattedResetDate: formattedResetDate, isWarning: isWarning, canRequestCredits: canRequestCredits, scope: scope, agentName: agentName })=>{
        const descriptor = isWarning ? context ? formattedResetDate ? (0, $gUmQU.messages).warningWithContextAndResetDate : (0, $gUmQU.messages).warningWithContext : formattedResetDate ? (0, $gUmQU.messages).warningWithResetDate : (0, $gUmQU.messages).warningWithoutResetDate : (0, $lg0Hb.getDepletedDescriptor)({
            scope: scope,
            agentName: agentName,
            hasContext: Boolean(context),
            hasResetDate: Boolean(formattedResetDate)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
            label: "",
            size: "medium",
            color: isWarning ? "var(--ds-icon-subtlest, #6B6E76)" : "var(--ds-text, #292A2E)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: (0, $w6R6I.cx)($b97967f60ffd55b6$var$styles.message, isWarning && $b97967f60ffd55b6$var$styles.warning)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...descriptor,
            values: {
                additionalContext: context,
                resetDate: formattedResetDate,
                agentName: agentName
            }
        }), canRequestCredits ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fhLSq.RequestCreditsAction), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: (0, $w6R6I.cx)($b97967f60ffd55b6$var$styles.link, isWarning && $b97967f60ffd55b6$var$styles.warning)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $gUmQU.messages).requestMore)))) : null, showViewUsage && usageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...canRequestCredits ? (0, $gUmQU.messages).orViewUsage : (0, $gUmQU.messages).viewUsage,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        appearance: "subtle",
                        href: usageUrl,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        as: "span",
                        xcss: (0, $w6R6I.cx)($b97967f60ffd55b6$var$styles.link, isWarning && $b97967f60ffd55b6$var$styles.warning)
                    }, chunks))
            }
        })) : null));
    });
};
module.exports["CreditsInlineMessage"] = $b97967f60ffd55b6$export$464b311eee196361;

});

parcelRegister("8pwQJ", function(module, exports) {
/* AgentCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $d2UzA = parcelRequire("d2UzA");


var $cha5E = parcelRequire("cha5E");


var $iMnC5 = parcelRequire("iMnC5");


var $8bAf2 = parcelRequire("8bAf2");


var $jrFSb = parcelRequire("jrFSb");


var $4ACma = parcelRequire("4ACma");


var $jd7zX = parcelRequire("jd7zX");


var $dCIW4 = parcelRequire("dCIW4");








var $56lNQ = parcelRequire("56lNQ");

const $095515959c22787b$export$8a82e8f180d45206 = ({ agent: agent, testId: testId })=>{
    const metadataItems = (0, $cozmU.useMemo)(()=>[
            agent.creatorName && {
                key: 'creator',
                label: agent.creatorName
            }
        ].filter(Boolean), [
        agent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $56lNQ.CardMetadata), {
        items: metadataItems,
        testId: testId
    });
};


const $cddd3b6415894530$var$styles = {
    favourite: "_3iDt72dnbC _0GOZSVYbGa _3XXdRC7dHp _1dtD5U7dHp _0aCvoJIZbP _1zk0SRIZbP"
};
const $cddd3b6415894530$var$VerifiedBadge = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        label: "Verified",
        size: "small",
        color: "var(--ds-icon-information, #357DE8)"
    });
const $cddd3b6415894530$export$4bb3d93416a668a2 = ({ agent: agent, analyticsContext: analyticsContext, onClick: onClick, isDisabled: isDisabled, slots: slots = {}, testId: testId, xcss: xcss, ...cardProps })=>{
    const isUplift = (0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false);
    const descriptionId = (0, $cozmU.useId)();
    const { cover: CoverComponent = (0, $4ACma.CardCover), content: ContentComponent = (0, $jrFSb.CardContent), metadata: MetadataComponent = isUplift ? undefined : (0, $095515959c22787b$export$8a82e8f180d45206), badge: BadgeComponent, footer: FooterComponent } = slots;
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (analyticsContext) onClick?.(agent.id, {
            ...analyticsContext,
            interactionElement: 'card'
        });
        else onClick?.(agent.id);
    }, [
        analyticsContext,
        onClick,
        agent.id
    ]);
    const badge = BadgeComponent && CoverComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        "data-card-badge": true,
        testId: testId ? `${testId}--badge` : undefined,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(BadgeComponent, {
            agent: agent,
            testId: testId ? `${testId}--badge-content` : undefined
        })
    }) : null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dCIW4.StudioBrowseKitIntlProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8bAf2.Card), {
            ...cardProps,
            xcss: (0, $w6R6I.cx)(isUplift && $cddd3b6415894530$var$styles.favourite, xcss),
            isDisabled: isDisabled,
            hasCutout: Boolean(CoverComponent),
            ariaLabel: agent.name,
            "aria-describedby": agent.description ? descriptionId : undefined,
            onClick: onClick ? handleClick : undefined,
            testId: testId,
            children: [
                CoverComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)(CoverComponent, {
                    name: agent.name,
                    iconUrl: agent.iconUrl,
                    coverColor: agent.coverColor,
                    isDisabled: isDisabled,
                    testId: testId ? `${testId}--cover` : undefined,
                    badge: badge
                }) : null,
                ContentComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)(ContentComponent, {
                    name: agent.name,
                    description: agent.description,
                    descriptionId: descriptionId,
                    isDisabled: isDisabled,
                    subtitle: isUplift ? agent.creatorName : undefined,
                    badge: agent.isVerified ? /*#__PURE__*/ (0, $8aG6j.jsx)($cddd3b6415894530$var$VerifiedBadge, {}) : undefined,
                    testId: testId ? `${testId}--content` : undefined
                }) : null,
                MetadataComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)(MetadataComponent, {
                    agent: agent,
                    testId: testId ? `${testId}--metadata` : undefined
                }) : null,
                FooterComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jd7zX.CardFooter), {
                    testId: testId ? `${testId}--footer` : undefined,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(FooterComponent, {
                        agent: agent,
                        testId: testId ? `${testId}--footer-content` : undefined
                    })
                }) : null
            ]
        })
    });
};
module.exports["AgentCard"] = $cddd3b6415894530$export$4bb3d93416a668a2;

});

parcelRegister("jrFSb", function(module, exports) {
/* CardContent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $cha5E = parcelRequire("cha5E");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");

/* CardContent.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");







/* CardHeader.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");










const $c474296b3a6d2a1a$var$styles = {
    actions: "_1pp6NdIZbP"
};
const $c474296b3a6d2a1a$export$5665775b26e26c5d = ({ name: name, badge: badge, headerActions: headerActions })=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center",
        spread: "space-between",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                space: "space.075",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        weight: "medium",
                        maxLines: 2,
                        children: name
                    }),
                    badge
                ]
            }),
            headerActions ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                as: "span",
                xcss: $c474296b3a6d2a1a$var$styles.actions,
                children: headerActions
            }) : null
        ]
    });


const $91379b692b42bdf1$var$styles = {
    content: "_1xC2CJa6YE _2Y7lL45zaO _4ouGXIdnbC"
};
const $91379b692b42bdf1$export$64ef9b8c11710c47 = ({ name: name, description: description, badge: badge, headerActions: headerActions, subtitle: subtitle, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        xcss: $91379b692b42bdf1$var$styles.content,
        space: "space.075",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c474296b3a6d2a1a$export$5665775b26e26c5d), {
                name: name,
                badge: badge,
                headerActions: headerActions
            }),
            subtitle ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtle",
                children: subtitle
            }) : null,
            description ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest",
                maxLines: 2,
                children: description
            }) : null
        ]
    });
};


const $00964ea9cf813f18$var$styles = {
    content: "_1xC2CJa6YE _4xdlr07p2s _4ouGXIdnbC",
    title: "_4ouGXIdnbC",
    badge: "_3YEZNOdnbC",
    actions: "_1mT5xdRAKS _42Yu6Bbhqd _3YEZNOdnbC"
};
const $00964ea9cf813f18$export$64ef9b8c11710c47 = (props)=>{
    if (!(0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $91379b692b42bdf1$export$64ef9b8c11710c47), {
        ...props
    });
    const { name: name, description: description, descriptionId: descriptionId, badge: badge, headerActions: headerActions, subtitle: subtitle, isDisabled: isDisabled, testId: testId } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        xcss: $00964ea9cf813f18$var$styles.content,
        space: "space.150",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.100",
                        alignBlock: "center",
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                xcss: $00964ea9cf813f18$var$styles.title,
                                space: "space.100",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        size: "large",
                                        weight: "medium",
                                        color: isDisabled ? 'color.text.disabled' : 'color.text',
                                        maxLines: 1,
                                        children: name
                                    }),
                                    badge ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                        xcss: $00964ea9cf813f18$var$styles.badge,
                                        children: badge
                                    }) : null
                                ]
                            }),
                            headerActions ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $00964ea9cf813f18$var$styles.actions,
                                children: headerActions
                            }) : null
                        ]
                    }),
                    subtitle ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        size: "small",
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtlest',
                        children: subtitle
                    }) : null
                ]
            }),
            description ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                id: descriptionId,
                size: "small",
                color: isDisabled ? 'color.text.disabled' : 'color.text.subtlest',
                maxLines: 3,
                children: description
            }) : null
        ]
    });
};
module.exports["CardContent"] = $00964ea9cf813f18$export$64ef9b8c11710c47;

});

parcelRegister("dCIW4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");


var $15qC3 = parcelRequire("15qC3");
































const $c54b6a9cb6d43787$var$asyncLanguages = {
    cs: ()=>(parcelRequire("Y8sxG")),
    da: ()=>(parcelRequire("jVNzG")),
    de: ()=>(parcelRequire("ALcTA")),
    'en-GB': ()=>(parcelRequire("6KP8L")),
    'en-ZZ': ()=>(parcelRequire("2Wdbc")),
    es: ()=>(parcelRequire("jwEM7")),
    fi: ()=>(parcelRequire("e8cLX")),
    fr: ()=>(parcelRequire("9pFhC")),
    hr: ()=>(parcelRequire("lxCp1")),
    hu: ()=>(parcelRequire("fX2XI")),
    it: ()=>(parcelRequire("jRTIU")),
    ja: ()=>(parcelRequire("dzDck")),
    ko: ()=>(parcelRequire("i1gBn")),
    nb: ()=>(parcelRequire("gwmz2")),
    nl: ()=>(parcelRequire("aLiSH")),
    pl: ()=>(parcelRequire("8dOFd")),
    'pt-BR': ()=>(parcelRequire("iOlGJ")),
    ru: ()=>(parcelRequire("bgfQN")),
    sl: ()=>(parcelRequire("9gdTv")),
    'sr-RS': ()=>(parcelRequire("jdxPR")),
    'sr-YR': ()=>(parcelRequire("2WqNQ")),
    sv: ()=>(parcelRequire("ijiQH")),
    th: ()=>(parcelRequire("dXQPq")),
    tr: ()=>(parcelRequire("2S193")),
    uk: ()=>(parcelRequire("2WSLf")),
    vi: ()=>(parcelRequire("7gsAp")),
    zh: ()=>(parcelRequire("eX488")),
    'zh-TW': ()=>(parcelRequire("b5HMl"))
};
const $c54b6a9cb6d43787$export$2b153a2030b0feb2 = async (locale)=>{
    const language = locale.split(/[-_]/)[0];
    const loader = $c54b6a9cb6d43787$var$asyncLanguages[locale.replace(/_/g, '-')] ?? $c54b6a9cb6d43787$var$asyncLanguages[language];
    try {
        const messages = await loader?.();
        return messages?.default ?? (0, $15qC3.default);
    } catch  {
        return 0, $15qC3.default;
    }
};


const $40700cd3a32b3907$export$4427ca076de56b8e = ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $64VTj.default), {
        loaderFn: (0, $c54b6a9cb6d43787$export$2b153a2030b0feb2),
        defaultMessages: (0, $15qC3.default),
        children: children
    });
module.exports["StudioBrowseKitIntlProvider"] = $40700cd3a32b3907$export$4427ca076de56b8e;

});

parcelRegister("Y8sxG", function(module, exports) {

let $0b4c2a90535e0324$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0b4c2a90535e0324$var$load("7rL7C").then(()=>parcelRequire('76C0w'));

});

parcelRegister("jVNzG", function(module, exports) {

let $e829cba7ec2d4944$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e829cba7ec2d4944$var$load("1RSxn").then(()=>parcelRequire('5JUxC'));

});

parcelRegister("ALcTA", function(module, exports) {

let $06e7fb3b92c6d762$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $06e7fb3b92c6d762$var$load("ghT31").then(()=>parcelRequire('6FyJf'));

});

parcelRegister("6KP8L", function(module, exports) {

let $4eaeb562bafb572f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4eaeb562bafb572f$var$load("lM2G0").then(()=>parcelRequire('bFnuv'));

});

parcelRegister("2Wdbc", function(module, exports) {

let $223b38ba1584c4e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $223b38ba1584c4e3$var$load("lTP5S").then(()=>parcelRequire('gDRUS'));

});

parcelRegister("jwEM7", function(module, exports) {

let $e370a28e2614f248$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e370a28e2614f248$var$load("jZqyp").then(()=>parcelRequire('a4GzN'));

});

parcelRegister("e8cLX", function(module, exports) {

let $a49bb868a3aabede$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a49bb868a3aabede$var$load("kIcDP").then(()=>parcelRequire('7fNMO'));

});

parcelRegister("9pFhC", function(module, exports) {

let $6da678d71598877d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6da678d71598877d$var$load("8e8NT").then(()=>parcelRequire('k18ty'));

});

parcelRegister("lxCp1", function(module, exports) {

let $faea77fa37e3c96d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $faea77fa37e3c96d$var$load("dcx0z").then(()=>parcelRequire('t77Qe'));

});

parcelRegister("fX2XI", function(module, exports) {

let $b9cea9ee8f083107$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9cea9ee8f083107$var$load("gznax").then(()=>parcelRequire('6piaF'));

});

parcelRegister("jRTIU", function(module, exports) {

let $e76e310e4a56ac2d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e76e310e4a56ac2d$var$load("2gIpG").then(()=>parcelRequire('bON8j'));

});

parcelRegister("dzDck", function(module, exports) {

let $9e1cf31a9cb351b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e1cf31a9cb351b8$var$load("iZiNp").then(()=>parcelRequire('et3sU'));

});

parcelRegister("i1gBn", function(module, exports) {

let $d1e532c48b3cc799$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d1e532c48b3cc799$var$load("6Bgnb").then(()=>parcelRequire('bizGR'));

});

parcelRegister("gwmz2", function(module, exports) {

let $c0712340b524bcf2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0712340b524bcf2$var$load("43PKJ").then(()=>parcelRequire('2yspM'));

});

parcelRegister("aLiSH", function(module, exports) {

let $7d5cf09dfb7fa522$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d5cf09dfb7fa522$var$load("fqoiV").then(()=>parcelRequire('iGViI'));

});

parcelRegister("8dOFd", function(module, exports) {

let $5fc6d66427bc4a3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5fc6d66427bc4a3b$var$load("dHzvE").then(()=>parcelRequire('16eLw'));

});

parcelRegister("iOlGJ", function(module, exports) {

let $db1db8514e2b2566$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db1db8514e2b2566$var$load("1SbqQ").then(()=>parcelRequire('2VzNa'));

});

parcelRegister("bgfQN", function(module, exports) {

let $832d7bea03e72db7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $832d7bea03e72db7$var$load("di9bz").then(()=>parcelRequire('9mCTq'));

});

parcelRegister("9gdTv", function(module, exports) {

let $6be062cdb25fb31a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6be062cdb25fb31a$var$load("6HheT").then(()=>parcelRequire('fKQFE'));

});

parcelRegister("jdxPR", function(module, exports) {

let $dfd97a3d57766d9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfd97a3d57766d9c$var$load("6yHZ2").then(()=>parcelRequire('5Xh0B'));

});

parcelRegister("2WqNQ", function(module, exports) {

let $2245ca08e38d46bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2245ca08e38d46bd$var$load("dVmSH").then(()=>parcelRequire('43niR'));

});

parcelRegister("ijiQH", function(module, exports) {

let $d5489f5ee3095072$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5489f5ee3095072$var$load("iL6r3").then(()=>parcelRequire('erDog'));

});

parcelRegister("dXQPq", function(module, exports) {

let $a2a9c3b1ca5f1fe1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2a9c3b1ca5f1fe1$var$load("hcqod").then(()=>parcelRequire('gFYm5'));

});

parcelRegister("2S193", function(module, exports) {

let $2171835297172898$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2171835297172898$var$load("k56dn").then(()=>parcelRequire('7Nl5D'));

});

parcelRegister("2WSLf", function(module, exports) {

let $225b79f977a26d3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $225b79f977a26d3d$var$load("2ncZ7").then(()=>parcelRequire('dn4Wf'));

});

parcelRegister("7gsAp", function(module, exports) {

let $54a033aa67a79062$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $54a033aa67a79062$var$load("3rax9").then(()=>parcelRequire('aYTfg'));

});

parcelRegister("eX488", function(module, exports) {

let $ae29c78a8cfe329b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae29c78a8cfe329b$var$load("dJQNS").then(()=>parcelRequire('3pzq9'));

});

parcelRegister("b5HMl", function(module, exports) {

let $81321ede75c71f86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81321ede75c71f86$var$load("ZkI53").then(()=>parcelRequire('ZuYUa'));

});

parcelRegister("56lNQ", function(module, exports) {
/* CardMetadata.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $cha5E = parcelRequire("cha5E");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");

/* CardMetadata.tsx generated by @compiled/babel-plugin v3.0.2 */ 

















const $c7558f28ba4de500$var$styles = {
    metadata: "_1xC2CJphCm _2Y7lL45zaO _313842IZbP _4ouGXIdnbC _1wydGW5zaO",
    interactive: "_1pp6NdIZbP",
    row: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _3TGfC9LRg7",
    item: "_4ouGXIdnbC"
};
const $c7558f28ba4de500$var$DEFAULT_ICON_COLOR = "var(--ds-icon-subtlest, #6B6E76)";
const $c7558f28ba4de500$var$Separator = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle",
        children: "\xb7"
    });
const $c7558f28ba4de500$export$58a22cd6ba503d6f = ({ items: items, children: children, isInteractive: isInteractive = false, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c7558f28ba4de500$var$styles.metadata, isInteractive && $c7558f28ba4de500$var$styles.interactive),
        testId: testId,
        children: items ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            xcss: $c7558f28ba4de500$var$styles.row,
            space: "space.075",
            alignBlock: "center",
            children: items.map(({ key: key, icon: Icon, iconColor: iconColor, label: label }, index)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                    children: [
                        index > 0 ? /*#__PURE__*/ (0, $8aG6j.jsx)($c7558f28ba4de500$var$Separator, {}) : null,
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            xcss: $c7558f28ba4de500$var$styles.item,
                            space: "space.050",
                            alignBlock: "center",
                            children: [
                                Icon ? /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                                    label: "",
                                    size: "small",
                                    color: iconColor ?? $c7558f28ba4de500$var$DEFAULT_ICON_COLOR
                                }) : null,
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    children: label
                                })
                            ]
                        })
                    ]
                }, key))
        }) : children
    });


const $a68f5d595e93284c$var$styles = {
    metadata: "_1xC2CJphCm _4ouGXIdnbC _0LQT5E8HPE",
    interactive: "_1mT5xdRAKS _42Yu6Bbhqd _1pp6NdIZbP",
    item: "_4ouGXIdnbC"
};
const $a68f5d595e93284c$export$58a22cd6ba503d6f = (props)=>{
    if (!(0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c7558f28ba4de500$export$58a22cd6ba503d6f), {
        ...props
    });
    const { items: items, children: children, isInteractive: isInteractive = false, testId: testId } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($a68f5d595e93284c$var$styles.metadata, isInteractive && $a68f5d595e93284c$var$styles.interactive),
        testId: testId,
        children: items ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "center",
            alignInline: "end",
            shouldWrap: true,
            children: items.map(({ key: key, icon: Icon, iconColor: iconColor, label: label }, index)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                    children: [
                        index > 0 ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            size: "small",
                            color: "color.text.subtle",
                            children: "\xb7"
                        }) : null,
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            xcss: $a68f5d595e93284c$var$styles.item,
                            space: "space.050",
                            alignBlock: "center",
                            children: [
                                Icon ? /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                                    label: "",
                                    size: "small",
                                    color: iconColor ?? "var(--ds-icon-subtlest, #6B6E76)"
                                }) : null,
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    maxLines: 1,
                                    children: label
                                })
                            ]
                        })
                    ]
                }, key))
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            alignInline: "end",
            alignBlock: "center",
            children: children
        })
    });
};
module.exports["CardMetadata"] = $a68f5d595e93284c$export$58a22cd6ba503d6f;

});

parcelRegister("3Z1Pc", function(module, exports) {
/* CardError.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $d35qR = parcelRequire("d35qR");

const $fd4a3a1c380784ee$var$messages = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "user-profile-card.error.title",
        defaultMessage: "Something went wrong and we couldn't load this profile."
    },
    errorDescription: {
        id: "user-profile-card.error.description",
        defaultMessage: "Try again in a few moments."
    }
});
const $fd4a3a1c380784ee$var$styles = {
    body: "_0Of8r2NHnM _1wydGWNHnM _2Zuz6QNHnM _1ZnuxbNHnM _2fwxA5DIqT"
}; /**
    * Error fallback when the entry point fails to render or profile data is missing.
    */ 
function $fd4a3a1c380784ee$export$f7f7efdefcc02999({ testId: testId }) {
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d35qR.CardPopupWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            role: "alert",
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.100",
                xcss: $fd4a3a1c380784ee$var$styles.body,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        weight: "semibold",
                        color: "color.text.subtlest",
                        children: intl.formatMessage($fd4a3a1c380784ee$var$messages.errorTitle)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: intl.formatMessage($fd4a3a1c380784ee$var$messages.errorDescription)
                    })
                ]
            })
        })
    });
}
module.exports["CardError"] = $fd4a3a1c380784ee$export$f7f7efdefcc02999;

});

parcelRegister("9zU5G", function(module, exports) {
/* UserProfileCardWithTrigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $2tuSz = parcelRequire("2tuSz");


var $lUcpS = parcelRequire("lUcpS");


var $cP7Ln = parcelRequire("cP7Ln");


var $jp2Q3 = parcelRequire("jp2Q3");


var $d5gEx = parcelRequire("d5gEx");


var $eRfpr = parcelRequire("eRfpr");


var $kKnPE = parcelRequire("kKnPE");


var $1koI0 = parcelRequire("1koI0");


var $2atIz = parcelRequire("2atIz");


var $bIiaK = parcelRequire("bIiaK");


var $9gll8 = parcelRequire("9gll8");


var $bXEsj = parcelRequire("bXEsj");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");




/**
 * @generated SignedSource<<10235a77b158c220c2cec110bad297df>>
 * @relayHash 519ab2a53c4df2c9d06fac9d39d3cd7d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 161a08af42ab7afb03887af7040bdd8daed8b94927b1e99c456602011fd7f392
const $683cdae9f8b4231f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "appType"
            },
            {
                "concreteType": "AppUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "aboutMe"
                    }
                ]
            }
        ],
        "type": "AppUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CardLoadingByIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CardLoadingByIdentityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "161a08af42ab7afb03887af7040bdd8daed8b94927b1e99c456602011fd7f392",
            "metadata": {},
            "name": "CardLoadingByIdentityQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$683cdae9f8b4231f$var$node.hash = "b49652c3a49c742749aa2056ecc5fe74";
var $683cdae9f8b4231f$export$2e2bcd8739ae039 = $683cdae9f8b4231f$var$node;















var $iMnC5 = parcelRequire("iMnC5");

/* ExternalAgentProfileCardSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");


var $eFbDl = parcelRequire("eFbDl");


var $w6R6I = parcelRequire("w6R6I");


var $cha5E = parcelRequire("cha5E");





var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $8bAf2 = parcelRequire("8bAf2");


var $4ACma = parcelRequire("4ACma");


var $jd7zX = parcelRequire("jd7zX");


var $jcCt7 = parcelRequire("jcCt7");

const $41b1f0a5347050da$var$styles = {
    card: "_39xV02PIoL",
    content: "_1xC2CJa6YE _4xdlr07p2s _4ouGXIdnbC",
    legacyContent: "_0LQT5E5zaO _03SyCP5zaO",
    titleLine: "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VoWWg",
    legacyTitleLine: "_0jFU0VSPN1",
    textLine: "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0Vey7F",
    attribution: "_39xV02N91d",
    attributionRow: "_4ouGXIdnbC _0jFU0VoWWg"
};
const $41b1f0a5347050da$var$LoadingAvatar = ()=>{
    if (!(0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eFbDl.default), {
        size: "small",
        appearance: "hexagon",
        color: "var(--ds-text, #292A2E)"
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jcCt7.ExternalAgentAvatarFrame), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eFbDl.default), {
            size: "xlarge",
            appearance: "hexagon",
            color: "var(--ds-text, #292A2E)"
        })
    });
};
const $41b1f0a5347050da$var$AttributionRowSkeleton = ({ width: width, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        xcss: $41b1f0a5347050da$var$styles.attributionRow,
        space: "space.075",
        alignBlock: "center",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                width: 16,
                height: 16,
                borderRadius: "var(--ds-radius-full, 9999px)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                width: width,
                height: 12
            })
        ]
    }); /** Reserves the shared agent card layout while the external AppUser data loads. */ 
const $41b1f0a5347050da$export$c5eb75ff4dafb442 = ({ attributionRows: attributionRows = 0, hasVendorLine: hasVendorLine = false, hasDescription: hasDescription = false, testId: testId })=>{
    const isUplift = (0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $41b1f0a5347050da$var$styles.card,
        testId: testId,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8bAf2.Card), {
            hasCutout: true,
            isDisabled: true,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ACma.CardCover), {
                    name: "",
                    avatar: $41b1f0a5347050da$var$LoadingAvatar,
                    testId: testId ? `${testId}--cover` : undefined
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                    xcss: (0, $w6R6I.cx)($41b1f0a5347050da$var$styles.content, !isUplift && $41b1f0a5347050da$var$styles.legacyContent),
                    space: isUplift ? 'space.150' : 'space.075',
                    testId: testId ? `${testId}--content` : undefined,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    xcss: (0, $w6R6I.cx)($41b1f0a5347050da$var$styles.titleLine, !isUplift && $41b1f0a5347050da$var$styles.legacyTitleLine),
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                        width: "70%",
                                        height: 16
                                    })
                                }),
                                hasVendorLine && isUplift && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    xcss: $41b1f0a5347050da$var$styles.textLine,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                        width: "45%",
                                        height: 12
                                    })
                                })
                            ]
                        }),
                        hasDescription && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            testId: testId ? `${testId}--description` : undefined,
                            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                                space: "space.0",
                                children: [
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                        xcss: $41b1f0a5347050da$var$styles.textLine,
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                            width: "100%",
                                            height: 12
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                        xcss: $41b1f0a5347050da$var$styles.textLine,
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                            width: "90%",
                                            height: 12
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                attributionRows > 0 && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jd7zX.CardFooter), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        xcss: $41b1f0a5347050da$var$styles.attribution,
                        testId: testId ? `${testId}--attribution` : undefined,
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)($41b1f0a5347050da$var$AttributionRowSkeleton, {
                                width: "60%",
                                testId: testId ? `${testId}--attribution--invoked-by` : undefined
                            }),
                            attributionRows > 1 && /*#__PURE__*/ (0, $8aG6j.jsx)($41b1f0a5347050da$var$AttributionRowSkeleton, {
                                width: "50%",
                                testId: testId ? `${testId}--attribution--invoked-via` : undefined
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $c4fg0 = parcelRequire("c4fg0");





var $cHF6R = parcelRequire("cHF6R");


var $dEXCO = parcelRequire("dEXCO");




const $8d3de5f30dd9a450$var$messages = (0, $kSwu1.defineMessages)({
    loadingAgentProfile: {
        id: "user-profile-card.CardLoadingByIdentity.loadingAgentProfile",
        defaultMessage: "Loading agent profile"
    }
});
function $8d3de5f30dd9a450$var$AgentLoading({ kind: kind, testId: testId, hasInvokedBy: hasInvokedBy, hasDescription: hasDescription }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $kKnPE.useFireRenderedSpinner)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        role: "status",
        "aria-label": formatMessage($8d3de5f30dd9a450$var$messages.loadingAgentProfile),
        children: kind === 'external-agent' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $41b1f0a5347050da$export$c5eb75ff4dafb442), {
            testId: testId,
            attributionRows: hasInvokedBy ? 2 : 0,
            hasDescription: hasDescription
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c4fg0.AgentCardLoading), {
            testId: testId
        })
    });
}
function $8d3de5f30dd9a450$var$ResolvedIdentityLoading({ userId: userId, testId: testId, profileData: profileData, isReduced: isReduced, hasInvokedBy: hasInvokedBy }) {
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $683cdae9f8b4231f$export$2e2bcd8739ae039), {
        accountId: (0, $dEXCO.profileQueryAccountId)(userId)
    }, {
        fetchPolicy: 'store-or-network'
    });
    const kind = (0, $cHF6R.getProfileCardKind)({
        userType: data.user?.__typename,
        appType: data.user?.__typename === 'AppUser' ? data.user.appType : null,
        jobTitle: data.user?.__typename === 'AppUser' ? data.user.extendedProfile?.jobTitle : null
    });
    if (kind === 'person') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
        testId: testId,
        profileData: profileData,
        isReduced: isReduced
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($8d3de5f30dd9a450$var$AgentLoading, {
        kind: kind,
        testId: testId,
        hasInvokedBy: hasInvokedBy,
        hasDescription: data.user?.__typename === 'AppUser' && Boolean(data.user.extendedProfile?.aboutMe)
    });
}
function $8d3de5f30dd9a450$export$193861ce4963beef(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($8d3de5f30dd9a450$var$ResolvedIdentityLoading, {
                ...props
            })
        })
    });
}


/* UserProfileCardTrigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 


parcelRequire("cozmU");








var $hBYtq = parcelRequire("hBYtq");

const $e5738d39a9fd0a96$var$styles = {
    trigger: "_1mb4UnZqHV _3iDTPbS8kF",
    fullWidthTrigger: "_1mb4UnZqHV _3iDTPbvLZJ _39xV02N91d"
};
const $e5738d39a9fd0a96$var$messages = (0, $kSwu1.defineMessages)({
    fallbackAriaLabel: {
        id: "user-profile-card.UserProfileCardTrigger.fallbackAriaLabel",
        defaultMessage: "More information about this user"
    }
});
const $e5738d39a9fd0a96$export$d5e867b0afea0b23 = ({ trigger: trigger, triggerProps: triggerProps, children: children, ariaHideProfileTrigger: ariaHideProfileTrigger, ariaLabel: ariaLabel, fullWidthTrigger: fullWidthTrigger = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hoverOnlyTrigger = Array.isArray(trigger) ? trigger.every((mode)=>mode === 'hover') : trigger === 'hover';
    const useNonInteractiveHoverTrigger = hoverOnlyTrigger;
    const accessibleName = ariaHideProfileTrigger ? undefined : ariaLabel ?? formatMessage($e5738d39a9fd0a96$var$messages.fallbackAriaLabel);
    if (useNonInteractiveHoverTrigger) {
        const { 'aria-expanded': _ariaExpanded, 'aria-haspopup': _ariaHasPopup, ...nonInteractiveTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            ...nonInteractiveTriggerProps,
            testId: "user-profile-card-trigger-wrapper",
            xcss: fullWidthTrigger ? $e5738d39a9fd0a96$var$styles.fullWidthTrigger : $e5738d39a9fd0a96$var$styles.trigger,
            "aria-hidden": ariaHideProfileTrigger ? true : undefined,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
        ...triggerProps,
        testId: "user-profile-card-trigger-wrapper",
        xcss: fullWidthTrigger ? $e5738d39a9fd0a96$var$styles.fullWidthTrigger : $e5738d39a9fd0a96$var$styles.trigger,
        "aria-label": accessibleName,
        "aria-hidden": ariaHideProfileTrigger ? true : undefined,
        tabIndex: ariaHideProfileTrigger ? -1 : undefined,
        children: children
    });
};


const $b98ac5af1bd78598$var$PRELOAD_INTENT_DELAY = 750;
const $b98ac5af1bd78598$var$EARLY_PRELOAD_INTENT_DELAY = 650;
const $b98ac5af1bd78598$var$messages = (0, $kSwu1.defineMessages)({
    profileAriaLabel: {
        id: "user-profile-card.UserProfileCardWithTrigger.profileAriaLabel",
        defaultMessage: "More information about {name}"
    },
    popupFallbackLabel: {
        id: "user-profile-card.UserProfileCardWithTrigger.popupFallbackLabel",
        defaultMessage: "Profile card"
    }
}); /**
     * Consumer-facing types re-exported so callers of the `./trigger` subpath can import them
     * without reaching into the package internals.
     */ 
function $b98ac5af1bd78598$export$74fa5d03ff375804({ isVisible: isVisible, ...props }) {
    const hostRelayEnvironment = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext))?.environment;
    if (isVisible === false) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: props.children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d5gEx.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($b98ac5af1bd78598$var$UserProfileCardWithTriggerInner, {
            ...props,
            hostRelayEnvironment: hostRelayEnvironment
        })
    });
} /** Inner implementation of {@link UserProfileCardWithTrigger}. */ 
function $b98ac5af1bd78598$var$UserProfileCardWithTriggerInner({ hostRelayEnvironment: hostRelayEnvironment, userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, trigger: trigger, placement: placement = 'bottom-start', shouldFitViewport: shouldFitViewport = false, offset: offset, shouldRenderToParent: shouldRenderToParent = false, children: children, testId: testId, townsquareApp: townsquareApp, onOpen: onOpen, onClose: onClose, onProfileClick: onProfileClick, agent: agent, isAgent: isAgent, agentInvokedBy: agentInvokedBy, actions: actions, ariaHideProfileTrigger: ariaHideProfileTrigger, ariaLabel: ariaLabel, analyticsAttributes: analyticsAttributes, fullWidthTrigger: fullWidthTrigger, prefilledProfileData: prefilledProfileData, customerCardDataLoader: customerCardDataLoader, isReduced: isReduced }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const resolvedTriggerMode = trigger ?? 'click';
    const resolvedAriaLabel = ariaLabel ?? (prefilledProfileData?.name ? formatMessage($b98ac5af1bd78598$var$messages.profileAriaLabel, {
        name: prefilledProfileData.name
    }) : undefined);
    const relayWrappedChildren = hostRelayEnvironment ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6SsN4.RelayEnvironmentProvider), {
        environment: hostRelayEnvironment,
        children: children
    }) : children;
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const getTestId = (0, $cozmU.useMemo)(()=>(0, $bXEsj.makeGetTestId)(userId, testId), [
        userId,
        testId
    ]); // `triggerMethod` is the actual open method ('click' | 'hover') reported by the popup
    // adapter. It stays `undefined` until the first open so we never report a trigger-mode
    // value (e.g. 'preload-on-hover') as if it were an open method. This is hoisted onto
    // `TeamsAppAnalyticsContext.attributes` below so every analytics event fired beneath
    // the popup picks it up automatically without each event having to attach it manually.
    const [triggerMethod, setTriggerMethod] = (0, $cozmU.useState)(undefined);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            cloudId: cloudId ?? '',
            townsquareApp: townsquareApp,
            onProfileClick: onProfileClick,
            getTestId: getTestId,
            triggerMethod: triggerMethod
        }), [
        cloudId,
        townsquareApp,
        onProfileClick,
        getTestId,
        triggerMethod
    ]); // A click open is a dialog; a hover open has no role, so focus does not move.
    const isDialog = triggerMethod === 'click' && (0, $iDrrr.fg)('platform-dst-top-layer');
    const analyticsContextData = (0, $cozmU.useMemo)(()=>({
            source: 'userProfileCard',
            attributes: {
                ...analyticsAttributes,
                cloudId: cloudId ?? '',
                userId: userId,
                viewerId: viewerId ?? '',
                // Only attach `method` once an actual open has occurred so SLO dashboards never
                // see a synthetic method on pre-open events (e.g. preload).
                ...triggerMethod !== undefined ? {
                    method: triggerMethod
                } : {}
            }
        }), [
        cloudId,
        viewerId,
        userId,
        triggerMethod,
        analyticsAttributes
    ]);
    if (!userId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: relayWrappedChildren
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: relayWrappedChildren
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9gll8.UserProfileCardContext).Provider, {
            value: contextValue,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2tuSz.TeamsAppAnalyticsContext), {
                data: analyticsContextData,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bIiaK.CardOpenTimerProvider), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($b98ac5af1bd78598$var$UserProfileCardPopupWithAnalytics, {
                        entryPointParams: {
                            userId: userId,
                            cloudId: cloudId,
                            orgId: orgId,
                            viewerId: viewerId,
                            // `isReduced` never reached the entry point, so the reduced card's
                            // `skipActivity` optimisation has never taken effect.
                            ...(0, $iDrrr.fg)('ptc_user_profile_card_reduce_activity_traffic') ? {
                                isReduced: isReduced
                            } : {}
                        },
                        entryPointProps: {
                            cloudId: cloudId ?? '',
                            ...(0, $4o0zT.isExperimentEnabled)('cc_external_agent_profile_card') ? {
                                orgId: orgId
                            } : {},
                            viewerId: viewerId,
                            testId: testId,
                            agent: agent,
                            isAgent: isAgent,
                            agentInvokedBy: agentInvokedBy,
                            actions: actions,
                            isReduced: isReduced,
                            ...prefilledProfileData ? {
                                prefilledProfileData: prefilledProfileData
                            } : {},
                            ...customerCardDataLoader ? {
                                customerCardDataLoader: customerCardDataLoader
                            } : {}
                        },
                        shouldFitViewport: shouldFitViewport,
                        placement: placement,
                        offset: offset,
                        shouldRenderToParent: shouldRenderToParent,
                        triggerMode: resolvedTriggerMode,
                        errorFallback: entryPointErrorFallback,
                        autoFocus: triggerMethod === 'click',
                        role: isDialog ? 'dialog' : undefined,
                        label: isDialog ? prefilledProfileData?.name ?? formatMessage($b98ac5af1bd78598$var$messages.popupFallbackLabel) : undefined,
                        onTriggerMethodChange: setTriggerMethod,
                        onOpen: onOpen,
                        onClose: onClose,
                        trigger: (triggerProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $e5738d39a9fd0a96$export$d5e867b0afea0b23), {
                                trigger: resolvedTriggerMode,
                                triggerProps: triggerProps,
                                ariaHideProfileTrigger: ariaHideProfileTrigger,
                                ariaLabel: resolvedAriaLabel,
                                fullWidthTrigger: fullWidthTrigger,
                                children: relayWrappedChildren
                            })
                    })
                })
            })
        })
    });
}
const $b98ac5af1bd78598$var$popupStyles = {
    scrollable: "_0bjKvD8fU6 _4bt5LAIZbP _2WAcuGIZbP _2OUyjtFYNq _4kiQYAdnbC"
};
const $b98ac5af1bd78598$var$REFERENCE_HIDDEN_STYLE = {
    visibility: 'hidden',
    pointerEvents: 'none'
}; /**
    * Replaces `@atlaskit/popup`'s default popup component, so it re-applies the `z-index` that
    * component would otherwise provide.
    */ 
const $b98ac5af1bd78598$var$ReferenceHidingPopupComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, style: style, className: className, isReferenceHidden: isReferenceHidden, shouldFitViewport: shouldFitViewport, ...rest }, ref)=>{
    const mergedStyle = {
        ...style,
        zIndex: (0, $jp2Q3.layers).modal(),
        ...isReferenceHidden ? $b98ac5af1bd78598$var$REFERENCE_HIDDEN_STYLE : undefined
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...rest,
        className: (0, $hekY6.default)([
            shouldFitViewport && $b98ac5af1bd78598$var$popupStyles.scrollable,
            className
        ]),
        ref: ref,
        style: mergedStyle,
        children: children
    });
});
function $b98ac5af1bd78598$var$UserProfileCardPopupWithAnalytics({ entryPointParams: entryPointParams, entryPointProps: entryPointProps, shouldFitViewport: shouldFitViewport, placement: placement, offset: offset, shouldRenderToParent: shouldRenderToParent, triggerMode: triggerMode, errorFallback: errorFallback, autoFocus: autoFocus, role: role, label: label, onTriggerMethodChange: onTriggerMethodChange, onOpen: onOpen, onClose: onClose, trigger: trigger }) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { markInteractionStart: markInteractionStart } = (0, $bIiaK.useCardOpenTimer)();
    const fireTriggeredRequest = (0, $kKnPE.useFireTriggeredRequest)();
    const isOpenRef = (0, $cozmU.useRef)(false);
    const handleOpen = (0, $cozmU.useCallback)((method, { preloaded: preloaded })=>{
        isOpenRef.current = true; // t=0 for all downstream `duration` measurements.
        markInteractionStart();
        onTriggerMethodChange(method); // `method` is attached inline because the context update from
        // `onTriggerMethodChange` has not propagated yet at this exact moment.
        fireEvent('ui.profilecard.triggered', {
            firedAt: (0, $eRfpr.firedAt)(),
            method: method,
            preloaded: preloaded
        });
        fireTriggeredRequest();
        onOpen?.(method);
    }, [
        fireEvent,
        fireTriggeredRequest,
        markInteractionStart,
        onOpen,
        onTriggerMethodChange
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        if (!isOpenRef.current) return;
        isOpenRef.current = false;
        fireEvent('ui.userProfileCard.closed', {});
        onClose?.();
    }, [
        fireEvent,
        onClose
    ]);
    const handlePreload = (0, $cozmU.useCallback)(()=>{
        fireEvent('operational.profilecard.preloaded.request', {
            firedAt: (0, $eRfpr.firedAt)()
        });
    }, [
        fireEvent
    ]); // Lets card content hold the card open; see `CardCloseGuardContext`.
    const closeGuardRef = (0, $cozmU.useRef)(false);
    const shouldPreventClose = (0, $cozmU.useCallback)(()=>closeGuardRef.current, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2atIz.CardCloseGuardContext).Provider, {
        value: closeGuardRef,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cP7Ln.PopupTriggerWithHover), {
            shouldFitViewport: shouldFitViewport,
            entryPoint: (0, $1koI0.entryPoint),
            placement: placement,
            offset: offset,
            fallback: (0, $4o0zT.isExperimentEnabled)('cc_external_agent_profile_card') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8d3de5f30dd9a450$export$193861ce4963beef), {
                userId: entryPointParams.userId,
                testId: entryPointProps.testId,
                profileData: entryPointProps.prefilledProfileData,
                isReduced: entryPointProps.isReduced,
                hasInvokedBy: Array.isArray(entryPointProps.agentInvokedBy) ? entryPointProps.agentInvokedBy.length > 0 : Boolean(entryPointProps.agentInvokedBy)
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
                testId: entryPointProps.testId ?? '',
                profileData: entryPointProps.prefilledProfileData,
                isReduced: entryPointProps.isReduced,
                isAgent: entryPointProps.isAgent
            }),
            updateOnFallbackResize: (0, $4o0zT.isExperimentEnabled)('cc_external_agent_profile_card'),
            errorFallback: errorFallback,
            delays: (0, $iDrrr.fg)('ptc_user_profile_card_reduce_activity_traffic') ? {
                preloadIntent: (0, $iDrrr.fg)('ptc_user_profile_card_preload_tuning') ? $b98ac5af1bd78598$var$EARLY_PRELOAD_INTENT_DELAY : $b98ac5af1bd78598$var$PRELOAD_INTENT_DELAY
            } : undefined,
            keepPreloadOnLeave: (0, $iDrrr.fg)('ptc_user_profile_card_preload_tuning'),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            shouldRenderToParent: shouldRenderToParent,
            autoFocus: autoFocus,
            role: role,
            label: label,
            shouldUseCaptureOnOutsideClick: true,
            triggerMode: triggerMode,
            onOpen: handleOpen,
            onClose: handleClose,
            onPreload: handlePreload,
            trigger: trigger,
            zIndex: (0, $jp2Q3.layers).modal(),
            popupComponent: $b98ac5af1bd78598$var$ReferenceHidingPopupComponent,
            shouldPreventClose: shouldPreventClose
        })
    });
}
module.exports["UserProfileCardWithTrigger"] = $b98ac5af1bd78598$export$74fa5d03ff375804;

});

parcelRegister("g0RaX", function(module, exports) {
const $d415e99ed33e2323$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $d415e99ed33e2323$var$performanceAvailable = $d415e99ed33e2323$var$isPerformanceAvailable();
const $d415e99ed33e2323$var$initialPageTime = Date.now();
const $d415e99ed33e2323$export$e9faea7c41053334 = ()=>{
    if ($d415e99ed33e2323$var$performanceAvailable) return performance.now();
    return Date.now() - $d415e99ed33e2323$var$initialPageTime;
};
module.exports["getPageTime"] = $d415e99ed33e2323$export$e9faea7c41053334;

});

parcelRegister("fxdou", function(module, exports) {
/* CardLoading.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $c4fg0 = parcelRequire("c4fg0");


var $kKnPE = parcelRequire("kKnPE");


var $d35qR = parcelRequire("d35qR");

const $c8358ec2650d268a$var$messages = (0, $kSwu1.defineMessages)({
    managerHeading: {
        id: "user-profile-card.CardLoading.managerHeading",
        defaultMessage: "Manager"
    }
});
const $c8358ec2650d268a$var$styles = {
    inner: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
    fill: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    linkRow: "_0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO",
    managerRow: "_0Of8r2gVvo _1wydGWgVvo _2Zuz6Q2ADO _1Znuxb2ADO"
};
function $c8358ec2650d268a$var$HeaderLoading({ profileData: profileData, isReduced: isReduced = false }) {
    const subtitle = [
        profileData?.jobTitle,
        profileData?.department
    ].filter(Boolean).join(" \u2022 ");
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "start",
                children: [
                    profileData?.avatarUrl || profileData?.name ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                        src: profileData.avatarUrl ?? undefined,
                        name: profileData.name,
                        size: "xlarge"
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "96px",
                        height: "96px",
                        borderRadius: "var(--ds-radius-full, 9999px)"
                    }),
                    !isReduced && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        space: "space.100",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "32px",
                                height: "32px",
                                borderRadius: "var(--ds-radius-medium, 6px)"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "96px",
                                height: "32px",
                                borderRadius: "var(--ds-radius-medium, 6px)"
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "32px",
                                height: "32px",
                                borderRadius: "var(--ds-radius-medium, 6px)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.050",
                children: [
                    profileData?.name ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                        as: "h2",
                        size: "medium",
                        children: profileData.name
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "45%",
                        height: "24px",
                        borderRadius: "var(--ds-radius-small, 4px)"
                    }),
                    subtitle ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: subtitle
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "80%",
                        height: "20px",
                        borderRadius: "var(--ds-radius-small, 4px)"
                    }),
                    profileData?.location ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: profileData.location
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "50%",
                        height: "20px",
                        borderRadius: "var(--ds-radius-small, 4px)"
                    }),
                    profileData?.email ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: profileData.email
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "80%",
                        height: "20px",
                        borderRadius: "var(--ds-radius-small, 4px)"
                    })
                ]
            })
        ]
    });
}
function $c8358ec2650d268a$var$ManagerSectionLoading({ profileData: profileData }) {
    const intl = (0, $kSwu1.useIntl)();
    const manager = profileData?.manager;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        children: [
            manager?.name ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                as: "p",
                weight: "medium",
                children: intl.formatMessage($c8358ec2650d268a$var$messages.managerHeading)
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                width: "60px",
                height: "24px",
                borderRadius: "var(--ds-radius-small, 4px)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                space: "space.100",
                alignBlock: "center",
                xcss: $c8358ec2650d268a$var$styles.managerRow,
                children: [
                    manager?.avatarUrl || manager?.name ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                        src: manager.avatarUrl ?? undefined,
                        name: manager.name ?? undefined
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                        width: "36px",
                        height: "36px",
                        borderRadius: "var(--ds-radius-full, 9999px)"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        space: "space.050",
                        xcss: $c8358ec2650d268a$var$styles.fill,
                        children: [
                            manager?.name ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                children: manager.name
                            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "45%",
                                height: "14px",
                                borderRadius: "var(--ds-radius-small, 4px)"
                            }),
                            manager?.jobTitle ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                color: "color.text.subtlest",
                                size: "small",
                                children: manager.jobTitle
                            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                width: "65%",
                                height: "14px",
                                borderRadius: "var(--ds-radius-small, 4px)"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $c8358ec2650d268a$var$LinkRowSkeleton() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $c8358ec2650d268a$var$styles.linkRow,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    space: "space.100",
                    alignBlock: "center",
                    xcss: $c8358ec2650d268a$var$styles.fill,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                            width: "36px",
                            height: "36px",
                            borderRadius: "var(--ds-radius-large, 8px)"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                            xcss: $c8358ec2650d268a$var$styles.fill,
                            space: "space.050",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "40%",
                                    height: "16px",
                                    borderRadius: "var(--ds-radius-small, 4px)"
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                                    width: "70%",
                                    height: "16px",
                                    borderRadius: "var(--ds-radius-small, 4px)"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                    width: "32px",
                    height: "16px",
                    borderRadius: "var(--ds-radius-small, 4px)"
                })
            ]
        })
    });
}
function $c8358ec2650d268a$var$RecentWorkSectionSkeleton() {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        space: "space.075",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                width: "90px",
                height: "24px",
                borderRadius: "var(--ds-radius-small, 4px)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$LinkRowSkeleton, {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$LinkRowSkeleton, {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$LinkRowSkeleton, {})
                ]
            })
        ]
    });
} /**
   * Loading state shown while the profile card entry chunk resolves. Mirrors the
   * populated card layout:
   *
   * - Header: 96px avatar + action buttons (icon + "View profile") above the
   *   name + pronouns, subtitle (up to 2 lines), and location.
   * - Manager: heading + 24px avatar with name and job title lines.
   * - Recent work: heading + 3 bordered link rows that mirror the compact
   *   `LinkList` rendering used in `RecentWorkSection`
   *
   * Keeping the skeleton shape close to the populated layout minimises the
   * perceived layout jump when data resolves. Fires `rendered.spinner` on mount
   * so the event only emits when the spinner is actually on screen.
   */ 
function $c8358ec2650d268a$export$5d25853fd6bdf402({ testId: testId, profileData: profileData, isReduced: isReduced = false, isAgent: isAgent = false }) {
    (0, $kKnPE.useFireRenderedSpinner)();
    if (isAgent) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        role: "status",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c4fg0.AgentCardLoading), {})
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d35qR.CardPopupWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            role: "status",
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.150",
                xcss: $c8358ec2650d268a$var$styles.inner,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$HeaderLoading, {
                        profileData: profileData,
                        isReduced: isReduced
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$ManagerSectionLoading, {
                        profileData: profileData
                    }),
                    !isReduced && /*#__PURE__*/ (0, $8aG6j.jsx)($c8358ec2650d268a$var$RecentWorkSectionSkeleton, {})
                ]
            })
        })
    });
}
module.exports["CardLoading"] = $c8358ec2650d268a$export$5d25853fd6bdf402;

});

parcelRegister("5qqDD", function(module, exports) {
/** Identity job titles assigned to third-party agents using Atlassian MCP. */ const $b150d47e477a8a0a$export$cb1436379c18374d = 'ai.dcr3p';
const $b150d47e477a8a0a$export$b6c60d5570ef888d = 'ai.cimd-mcp';
module.exports["DCR3P_AGENT_JOB_TITLE"] = $b150d47e477a8a0a$export$cb1436379c18374d;
module.exports["CIMD_MCP_AGENT_JOB_TITLE"] = $b150d47e477a8a0a$export$b6c60d5570ef888d;

});

parcelRegister("454YE", function(module, exports) {
/**
 * @generated SignedSource<<d649da1907eb1cf03e569a413633a08e>>
 * @relayHash 94a8dfdd99ade0914ac983611edfb339
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ecf6fb4b0c3a0177231545cb548a99c2a11f488e7ba12ae01e147687852130de
const $3b461e95a816e67a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "activityFirst"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collabContextId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeExternalAgentFields"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "siteAri"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipActivity"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipKnowledgeDiscovery"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipReportingLines"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userAri"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userIdString"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewerId"
    }, v13 = {
        "kind": "Variable",
        "name": "collabContextId",
        "variableName": "collabContextId"
    }, v14 = {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v18 = {
        "kind": "ScalarField",
        "name": "email"
    }, v19 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "product"
    }, v22 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v23 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v22 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v22 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v22 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v20 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v27 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v22 /*: any*/ 
        },
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v15 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ 
            ]
        }
    ], v28 = {
        "kind": "ScalarField",
        "name": "url"
    }, v29 = [
        v28 /*: any*/ 
    ], v30 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v31 = [
        v30 /*: any*/ ,
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                v30 /*: any*/ ,
                v20 /*: any*/ 
            ]
        }
    ], v32 = [
        {
            "alias": "trelloUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v33 = [
        {
            "alias": "webUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v34 = [
        v28 /*: any*/ ,
        v20 /*: any*/ 
    ], v35 = [
        {
            "concreteType": "AssetsLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "web"
                }
            ]
        }
    ], v36 = [
        {
            "kind": "ScalarField",
            "name": "accountIdentifier"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfDirectReports"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfTotalReports"
        },
        {
            "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
            "kind": "LinkedField",
            "name": "pii",
            "plural": false,
            "selections": [
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
                    "kind": "LinkedField",
                    "name": "extendedProfile",
                    "plural": false,
                    "selections": [
                        v19 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserProfileCardEntryPointQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "activityFirst",
                            "variableName": "activityFirst"
                        },
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        v13 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "includeExternalAgentFields",
                            "variableName": "includeExternalAgentFields"
                        },
                        v14 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "siteAri",
                            "variableName": "siteAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "skipActivity",
                            "variableName": "skipActivity"
                        },
                        {
                            "kind": "Variable",
                            "name": "skipKnowledgeDiscovery",
                            "variableName": "skipKnowledgeDiscovery"
                        },
                        {
                            "kind": "Variable",
                            "name": "skipReportingLines",
                            "variableName": "skipReportingLines"
                        },
                        {
                            "kind": "Variable",
                            "name": "userAri",
                            "variableName": "userAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        },
                        {
                            "kind": "Variable",
                            "name": "userIdString",
                            "variableName": "userIdString"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewerId",
                            "variableName": "viewerId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "UserProfileCardRelay_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v12 /*: any*/ ,
                v5 /*: any*/ ,
                v9 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserProfileCardEntryPointQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "accountId",
                            "variableName": "userId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accountStatus"
                        },
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                    "kind": "LinkedField",
                                    "name": "extendedProfile",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "department"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "location"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "organization"
                                        }
                                    ]
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v18 /*: any*/ 
                            ],
                            "type": "CustomerUser"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                },
                                {
                                    "condition": "includeExternalAgentFields",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "nickname"
                                        },
                                        {
                                            "concreteType": "AppUserExtendedProfile",
                                            "kind": "LinkedField",
                                            "name": "extendedProfile",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "aboutMe"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "characteristics"
                                        }
                                    ]
                                }
                            ],
                            "type": "AppUser"
                        },
                        v20 /*: any*/ 
                    ]
                },
                {
                    "condition": "skipActivity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "Activity",
                            "kind": "LinkedField",
                            "name": "activity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "fields": [
                                                {
                                                    "items": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "actors.0",
                                                            "variableName": "userAri"
                                                        }
                                                    ],
                                                    "kind": "ListValue",
                                                    "name": "actors"
                                                },
                                                v13 /*: any*/ 
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "first",
                                            "variableName": "activityFirst"
                                        }
                                    ],
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "workedOn",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ConfluenceDatabaseLinks",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": false,
                                                                                    "selections": v22 /*: any*/ 
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceDatabase"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ConfluenceEmbedLinks",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": false,
                                                                                    "selections": v22 /*: any*/ 
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceEmbed"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v27 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v27 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v29 /*: any*/ ,
                                                                            "type": "TownsquareGoal"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v29 /*: any*/ ,
                                                                            "type": "TownsquareProject"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v29 /*: any*/ ,
                                                                            "type": "TownsquareComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v30 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraIssue"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v31 /*: any*/ ,
                                                                            "type": "JiraPlatformComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v31 /*: any*/ ,
                                                                            "type": "JiraServiceManagementComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v32 /*: any*/ ,
                                                                            "type": "TrelloBoard"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v32 /*: any*/ ,
                                                                            "type": "TrelloCard"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v33 /*: any*/ ,
                                                                            "type": "DevOpsDocument"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v29 /*: any*/ ,
                                                                            "type": "ExternalDocument"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v34 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v29 /*: any*/ ,
                                                                            "type": "ExternalPullRequest"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v33 /*: any*/ ,
                                                                            "type": "DevOpsDesign"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v29 /*: any*/ ,
                                                                            "type": "ExternalRemoteLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v29 /*: any*/ ,
                                                                            "type": "MercuryFocusArea"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v34 /*: any*/ ,
                                                                            "type": "MercuryPortfolio"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v29 /*: any*/ ,
                                                                            "type": "RadarPosition"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v29 /*: any*/ ,
                                                                            "type": "RadarView"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v29 /*: any*/ ,
                                                                            "type": "CompassComponent"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "href"
                                                                                }
                                                                            ],
                                                                            "type": "BitbucketPullRequest"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": "loomUrl",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "url"
                                                                                }
                                                                            ],
                                                                            "type": "LoomVideo"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v35 /*: any*/ ,
                                                                            "type": "AssetsObject"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v35 /*: any*/ ,
                                                                            "type": "AssetsObjectType"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v35 /*: any*/ ,
                                                                            "type": "AssetsSchema"
                                                                        },
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "skipKnowledgeDiscovery",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "KnowledgeDiscoveryQueryApi",
                            "kind": "LinkedField",
                            "name": "knowledgeDiscovery",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "accountId",
                                            "variableName": "userIdString"
                                        },
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "requestingUserId",
                                            "variableName": "viewerId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "tenantId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "singleUser",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeDiscoveryUserProfile",
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryUserManager",
                                                            "kind": "LinkedField",
                                                            "name": "manager",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v19 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                            "kind": "LinkedField",
                                                            "name": "thirdPartyIntegrations",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "externalId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "integrationId"
                                                                },
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "KnowledgeDiscoverySingleUser"
                                        }
                                    ]
                                },
                                {
                                    "condition": "skipReportingLines",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "aaid",
                                                    "variableName": "userIdString"
                                                },
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "Variable",
                                                    "name": "siteId",
                                                    "variableName": "siteAri"
                                                }
                                            ],
                                            "kind": "LinkedField",
                                            "name": "reportingLines",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": v36 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                            "kind": "LinkedField",
                                                            "name": "managers",
                                                            "plural": true,
                                                            "selections": v36 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                                            "kind": "LinkedField",
                                                            "name": "reports",
                                                            "plural": true,
                                                            "selections": v36 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "KnowledgeDiscoveryReportingLines"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ecf6fb4b0c3a0177231545cb548a99c2a11f488e7ba12ae01e147687852130de",
            "metadata": {},
            "name": "UserProfileCardEntryPointQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3b461e95a816e67a$var$node.hash = "80b0677a1317047c82d340d12324f292";
var $3b461e95a816e67a$export$2e2bcd8739ae039 = $3b461e95a816e67a$var$node;
module.exports["default"] = $3b461e95a816e67a$export$2e2bcd8739ae039;

});

parcelRegister("7lnAX", function(module, exports) {

let $558ccc12ee09af34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $558ccc12ee09af34$var$load("fGYoU").then(()=>parcelRequire('9tb7H'));

});

parcelRegister("d35qR", function(module, exports) {
/* CardPopupWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $03ac0dbc50e02241$var$styles = {
    wrapper: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _39xV02wBC3 _2OUyjtFYNq"
};
function $03ac0dbc50e02241$export$aefd550f0f72fff8({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $03ac0dbc50e02241$var$styles.wrapper,
        backgroundColor: "elevation.surface.overlay",
        children: children
    });
}
module.exports["CardPopupWrapper"] = $03ac0dbc50e02241$export$aefd550f0f72fff8;

});

parcelRegister("eRfpr", function(module, exports) {

var $g0RaX = parcelRequire("g0RaX");

function $c6281ea988ae57a1$export$935a1f551ec13075(profileData) {
    if (!profileData) return 0;
    let count = 0;
    if (profileData.accountId) count += 1;
    const isDeactivated = profileData.accountStatus === 'inactive' || profileData.accountStatus === 'closed';
    if (!isDeactivated && profileData.thirdPartyIntegrations && profileData.thirdPartyIntegrations.length > 0) count += 1;
    return count;
}
const $c6281ea988ae57a1$export$feb180212387929b = ()=>Math.round((0, $g0RaX.getPageTime)());
const $c6281ea988ae57a1$export$6ad9e7706a4ee0f8 = (error)=>{
    const statusCode = $c6281ea988ae57a1$var$readNumericField(error, 'statusCode') ?? $c6281ea988ae57a1$var$readNumericField(error, 'status') ?? $c6281ea988ae57a1$var$readRelayExtensionsStatusCode(error);
    if (statusCode === 404 || $c6281ea988ae57a1$var$isNotFoundLikeError(error, statusCode)) return statusCode !== undefined ? {
        errorType: 'NotFound',
        statusCode: statusCode
    } : {
        errorType: 'NotFound'
    };
    return statusCode !== undefined ? {
        errorType: 'default',
        statusCode: statusCode
    } : {
        errorType: 'default'
    };
};
/**
 * Relay surfaces network errors as `{ errors: [{ extensions: { statusCode, errorType, ... } }] }`.
 * Reads the first error's `extensions.statusCode` so the SLO classification works against the
 * common Relay error envelope, not just hand-rolled `{ statusCode }` objects.
 */ const $c6281ea988ae57a1$var$readRelayExtensionsStatusCode = (error)=>{
    if (!error || typeof error !== 'object' || !('errors' in error)) return undefined;
    const errors = error.errors;
    if (!Array.isArray(errors) || errors.length === 0) return undefined;
    const first = errors[0];
    if (!first || typeof first !== 'object' || !('extensions' in first)) return undefined;
    const extensions = first.extensions;
    if (!extensions || typeof extensions !== 'object') return undefined;
    return $c6281ea988ae57a1$var$readNumericField(extensions, 'statusCode') ?? $c6281ea988ae57a1$var$readNumericField(extensions, 'status');
};
const $c6281ea988ae57a1$var$readNumericField = (error, field)=>{
    if (error && typeof error === 'object' && field in error) {
        const value = error[field];
        if (typeof value === 'number' && Number.isFinite(value)) return value;
    }
    return undefined;
};
/** Returns true for unambiguous not-found signals. Message-pattern matching is last-resort — only used when statusCode is absent to avoid misclassifying generic errors (e.g. a 500 whose message contains "not found"). */ const $c6281ea988ae57a1$var$isNotFoundLikeError = (error, statusCode)=>{
    if (!error || typeof error !== 'object') return false;
    const code = $c6281ea988ae57a1$var$readStringField(error, 'code');
    if (code && /NOT_FOUND/i.test(code)) return true;
    // Only match message patterns when there is no statusCode — a 500 with "not found" in its message must not be misclassified as NotFound.
    if (statusCode === undefined) {
        const message = $c6281ea988ae57a1$var$readStringField(error, 'message');
        if (message && /\bnot\s*found\b/i.test(message)) return true;
    }
    return false;
};
const $c6281ea988ae57a1$var$readStringField = (error, field)=>{
    if (field in error) {
        const value = error[field];
        if (typeof value === 'string') return value;
    }
    return undefined;
};
module.exports["countRenderedActions"] = $c6281ea988ae57a1$export$935a1f551ec13075;
module.exports["firedAt"] = $c6281ea988ae57a1$export$feb180212387929b;
module.exports["getErrorAttributes"] = $c6281ea988ae57a1$export$6ad9e7706a4ee0f8;

});

parcelRegister("kKnPE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lUcpS = parcelRequire("lUcpS");


var $eRfpr = parcelRequire("eRfpr");


var $bIiaK = parcelRequire("bIiaK");

// Cast payload superset to `never` so `fireEvent` accepts extra SLO fields.
const $5204e5464349947f$var$asExtendedPayload = (payload)=>payload;
function $5204e5464349947f$export$97ec6f6769110fe4() {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    return ()=>{
        fireEvent('operational.profilecard.triggered.request', {
            firedAt: (0, $eRfpr.firedAt)()
        });
    };
}
function $5204e5464349947f$export$f7831696c122c106() {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const firedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (firedRef.current) return;
        firedRef.current = true;
        fireEvent('ui.profilecard.rendered.spinner', {
            firedAt: (0, $eRfpr.firedAt)()
        });
    }, [
        fireEvent
    ]);
}
function $5204e5464349947f$export$38eb2c63ddf3e3a3(hasProfileData) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const firedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasProfileData || firedRef.current) return;
        firedRef.current = true;
        fireEvent('operational.profilecard.succeeded.request', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0
        });
    }, [
        hasProfileData,
        fireEvent,
        getDurationSinceInteraction
    ]);
}
function $5204e5464349947f$export$20c24f03e0a7c8fc(profileData) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const firedRef = (0, $cozmU.useRef)(false);
    const profileDataRef = (0, $cozmU.useRef)(profileData);
    profileDataRef.current = profileData;
    (0, $cozmU.useEffect)(()=>{
        if (firedRef.current) return;
        firedRef.current = true;
        fireEvent('ui.profilecard.rendered.content', {
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            numActions: (0, $eRfpr.countRenderedActions)(profileDataRef.current)
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
}
function $5204e5464349947f$export$5fc91356da713d06(error) {
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $bIiaK.useCardOpenTimer)();
    const firedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (error === undefined || firedRef.current) return;
        firedRef.current = true;
        const attributes = error === null ? {
            errorType: 'NotFound'
        } : (0, $eRfpr.getErrorAttributes)(error);
        if (attributes.errorType === 'NotFound') {
            fireEvent('operational.profilecard.succeeded.request', {
                firedAt: (0, $eRfpr.firedAt)(),
                duration: getDurationSinceInteraction() ?? 0
            });
            return;
        }
        fireEvent('operational.profilecard.failed.request', $5204e5464349947f$var$asExtendedPayload({
            firedAt: (0, $eRfpr.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            // schema requires `errorMessage`; send the classified type to avoid PII.
            errorMessage: attributes.errorType,
            errorType: attributes.errorType,
            ...attributes.statusCode !== undefined ? {
                errorStatusCode: attributes.statusCode
            } : {}
        }));
    }, [
        error,
        fireEvent,
        getDurationSinceInteraction
    ]);
}
module.exports["useFireTriggeredRequest"] = $5204e5464349947f$export$97ec6f6769110fe4;
module.exports["useFireRenderedSpinner"] = $5204e5464349947f$export$f7831696c122c106;
module.exports["useFireRequestSucceeded"] = $5204e5464349947f$export$38eb2c63ddf3e3a3;
module.exports["useFireContentRendered"] = $5204e5464349947f$export$20c24f03e0a7c8fc;
module.exports["useFireRequestFailed"] = $5204e5464349947f$export$5fc91356da713d06;

});

parcelRegister("2atIz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $50c6c751a4eda4dc$export$cd42012d8c9757c9 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["CardCloseGuardContext"] = $50c6c751a4eda4dc$export$cd42012d8c9757c9;

});

parcelRegister("bIiaK", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $g0RaX = parcelRequire("g0RaX");

const $1aeaee3bd13c0f7b$var$noopContext = {
    markInteractionStart: ()=>{},
    getDurationSinceInteraction: ()=>undefined
};
const $1aeaee3bd13c0f7b$var$CardOpenTimerContext = /*#__PURE__*/ (0, $cozmU.createContext)($1aeaee3bd13c0f7b$var$noopContext);
function $1aeaee3bd13c0f7b$export$8f61ff484d9ed897({ children: children }) {
    const outer = (0, $cozmU.useContext)($1aeaee3bd13c0f7b$var$CardOpenTimerContext);
    const interactionStartRef = (0, $cozmU.useRef)(null);
    const markInteractionStart = (0, $cozmU.useCallback)(()=>{
        // Re-arm per interaction so successive opens each measure from their own t=0.
        interactionStartRef.current = (0, $g0RaX.getPageTime)();
    }, []);
    const getDurationSinceInteraction = (0, $cozmU.useCallback)(()=>{
        if (interactionStartRef.current === null) return undefined;
        return Math.max(0, (0, $g0RaX.getPageTime)() - interactionStartRef.current);
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            markInteractionStart: markInteractionStart,
            getDurationSinceInteraction: getDurationSinceInteraction
        }), [
        markInteractionStart,
        getDurationSinceInteraction
    ]);
    if (outer !== $1aeaee3bd13c0f7b$var$noopContext) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($1aeaee3bd13c0f7b$var$CardOpenTimerContext.Provider, {
        value: value,
        children: children
    });
}
function $1aeaee3bd13c0f7b$export$d0c3a3e820a371d6() {
    return (0, $cozmU.useContext)($1aeaee3bd13c0f7b$var$CardOpenTimerContext);
}
module.exports["CardOpenTimerProvider"] = $1aeaee3bd13c0f7b$export$8f61ff484d9ed897;
module.exports["useCardOpenTimer"] = $1aeaee3bd13c0f7b$export$d0c3a3e820a371d6;

});

parcelRegister("9gll8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/** Sentinel identity used to detect "no outer provider" without an explicit flag. */ const $c070228ab88c7aa0$export$ff993edec5f1dba3 = ()=>undefined;
const $c070228ab88c7aa0$export$24fd9e960a1a443b = /*#__PURE__*/ (0, $cozmU.createContext)({
    cloudId: '',
    townsquareApp: undefined,
    onProfileClick: undefined,
    getTestId: $c070228ab88c7aa0$export$ff993edec5f1dba3
});
module.exports["defaultGetTestId"] = $c070228ab88c7aa0$export$ff993edec5f1dba3;
module.exports["UserProfileCardContext"] = $c070228ab88c7aa0$export$24fd9e960a1a443b;

});

parcelRegister("bXEsj", function(module, exports) {
/**
 * Default testId used by the user profile card when the consumer does not pass one.
 * Centralised so the `getTestId` factory in `UserProfileCard` and
 * `UserProfileCardWithTrigger` agrees on what counts as "default".
 */ const $a9a5f85cd687888c$export$d0c64eda5f53987e = 'user-profile-card';
const $a9a5f85cd687888c$export$51b2da6fcb5ae549 = (userId, testId)=>{
    const baseTestId = `user-profile-card-${userId}`;
    const isDefaultTestId = !testId || testId === $a9a5f85cd687888c$export$d0c64eda5f53987e;
    const suffixModifier = isDefaultTestId ? '' : `--${testId}`;
    return (suffix)=>userId ? `${baseTestId}-${suffix}${suffixModifier}` : undefined;
};
module.exports["makeGetTestId"] = $a9a5f85cd687888c$export$51b2da6fcb5ae549;

});

parcelRegister("jcCt7", function(module, exports) {
/* ExternalAgentAvatarFrame.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $1a42da5bfe884940$var$styles = {
    frame: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02mdCj _0jFU0VfI2J",
    avatar: "_39xV02JgOI _0jFU0VJgOI _3YEZNOdnbC _1VJPcaKDB8 _0yKXXaDIqT"
};
const $1a42da5bfe884940$export$1f86cbf76aea2abb = ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $1a42da5bfe884940$var$styles.frame,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $1a42da5bfe884940$var$styles.avatar,
            children: children
        })
    });
module.exports["ExternalAgentAvatarFrame"] = $1a42da5bfe884940$export$1f86cbf76aea2abb;

});

parcelRegister("c4fg0", function(module, exports) {
/* AgentCardLoading.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $cha5E = parcelRequire("cha5E");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $fWkhK = parcelRequire("fWkhK");


var $jJ1KU = parcelRequire("jJ1KU");

const $c38eaf812f6ce80f$var$styles = {
    card: "_39xV02PIoL"
};
function $c38eaf812f6ce80f$export$54489a2dfb0679c2({ testId: testId } = {}) {
    return (0, $iDrrr.fg)('rovo_agent_profile_card_browse_kit') && (0, $cha5E.expVal)('jira_browse_agent_modal_update', 'isEnabled', false) ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $c38eaf812f6ce80f$var$styles.card,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jJ1KU.AgentCardSkeleton), {
            testId: testId
        })
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fWkhK.AgentProfileCardSkeleton), {});
}
module.exports["AgentCardLoading"] = $c38eaf812f6ce80f$export$54489a2dfb0679c2;

});

parcelRegister("cHF6R", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $5qqDD = parcelRequire("5qqDD");

function $376419ae07ceff42$export$1adaa688a523bf7e({ userType: userType, appType: appType, jobTitle: jobTitle }) {
    // The MCP job title identifies the card route; invoking-user attribution is optional.
    if (userType === 'AppUser' && (jobTitle === (0, $5qqDD.DCR3P_AGENT_JOB_TITLE) || jobTitle === (0, $5qqDD.CIMD_MCP_AGENT_JOB_TITLE)) && (0, $4o0zT.isExperimentEnabled)('cc_external_agent_profile_card')) return 'external-agent';
    return typeof appType === 'string' && appType.toLowerCase() === 'agent' ? 'studio-agent' : 'person';
}
module.exports["getProfileCardKind"] = $376419ae07ceff42$export$1adaa688a523bf7e;

});

parcelRegister("dEXCO", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $2khPJ = parcelRequire("2khPJ");

function $44bd22d4022fd2c5$export$a630ca123dc18bf5(userId) {
    return (0, $2khPJ.IdentityUserAri).check(userId) && (0, $iDrrr.fg)('ptc_user_profile_card_normalize_user_ari') ? (0, $2khPJ.IdentityUserAri).parse(userId).userId : userId;
}
module.exports["profileQueryAccountId"] = $44bd22d4022fd2c5$export$a630ca123dc18bf5;

});


$parcel$global.rlb("48F3z")
//# sourceMappingURL=twc-onboarding-experience.0b02f812.js.map
